webpackJsonp([38378085918370],{

/***/ 779:
/***/ (function(module, exports) {

	module.exports = {
	  "key": "react-components",
	  "name": "React Components",
	  "description": "The building blocks of React apps. These are components that you can use in your own apps.",
	  "aka": [
	    "React Component Libraries",
	    "React UI Frameworks"
	  ],
	  "tags": [
	    {
	      "name": "dataviz",
	      "aka": [
	        "datavis",
	        "data visualization",
	        "infographics",
	        "charts",
	        "graphs"
	      ],
	      "description": "Charts, graphs, or other infographics for displaying data."
	    },
	    {
	      "name": "calendar",
	      "aka": [
	        "date picker"
	      ],
	      "description": "Allows the user to select a date or date range."
	    },
	    {
	      "name": "grid",
	      "aka": [
	        "layout"
	      ]
	    },
	    {
	      "name": "set",
	      "description": "A few components with a similar use-case. For instance color pickers or form components."
	    },
	    {
	      "name": "toolkit",
	      "aka": [
	        "library",
	        "framework"
	      ],
	      "description": "A large set of components in the same style that you can use to quickly bootstrap your project."
	    },
	    {
	      "name": "abandoned",
	      "aka": [
	        "discontinued"
	      ],
	      "description": "The project has been discontinued / abandoned by the creators"
	    },
	    {
	      "name": "native",
	      "description": "Components for react native - to be used in native iOS/Android apps (not the web)"
	    },
	    {
	      "name": "text editor",
	      "description": "Component for writing / editing rich text in the browser"
	    },
	    {
	      "name": "form"
	    },
	    {
	      "name": "material design"
	    },
	    {
	      "name": "list"
	    },
	    {
	      "name": "picker"
	    },
	    {
	      "name": "button"
	    },
	    {
	      "name": "spinner"
	    },
	    {
	      "name": "chat"
	    },
	    {
	      "name": "map"
	    },
	    {
	      "name": "animation"
	    },
	    {
	      "name": "icon"
	    },
	    {
	      "name": "menu"
	    },
	    {
	      "name": "game"
	    },
	    {
	      "name": "input"
	    },
	    {
	      "name": "autocomplete"
	    },
	    {
	      "name": "slider"
	    },
	    {
	      "name": "color"
	    },
	    {
	      "name": "3d"
	    },
	    {
	      "name": "notification"
	    },
	    {
	      "name": "devtool"
	    },
	    {
	      "name": "text"
	    },
	    {
	      "name": "search"
	    },
	    {
	      "name": "spreadsheet"
	    },
	    {
	      "name": "graphics"
	    },
	    {
	      "name": "layout"
	    },
	    {
	      "name": "dropdown"
	    },
	    {
	      "name": "wrapper"
	    },
	    {
	      "name": "video"
	    }
	  ],
	  "articles": [],
	  "projects": [
	    {
	      "githubPath": "jaredpalmer/formik",
	      "description": "Build forms in React, without the tears 😭 ",
	      "homepage": "https://npm.im/formik",
	      "dependencies": [
	        "@pisano/enzyme",
	        "@pisano/enzyme-adapter-react-16",
	        "@storybook/addon-options",
	        "@storybook/react",
	        "@types/jest",
	        "@types/lodash.clonedeep",
	        "@types/lodash.topath",
	        "@types/react",
	        "@types/react-dom",
	        "@types/react-test-renderer",
	        "@types/warning",
	        "all-contributors-cli",
	        "awesome-typescript-loader",
	        "create-react-context",
	        "cross-env",
	        "deepmerge",
	        "doctoc",
	        "hoist-non-react-statics",
	        "husky",
	        "jest",
	        "jest-cli",
	        "lint-staged",
	        "lodash.clonedeep",
	        "lodash.topath",
	        "prettier",
	        "prop-types",
	        "raw-loader",
	        "react",
	        "react-dom",
	        "react-fast-compare",
	        "rimraf",
	        "rollup",
	        "rollup-plugin-commonjs",
	        "rollup-plugin-filesize",
	        "rollup-plugin-node-resolve",
	        "rollup-plugin-replace",
	        "rollup-plugin-sourcemaps",
	        "rollup-plugin-uglify",
	        "size-limit",
	        "ts-jest",
	        "tsc-watch",
	        "tslib",
	        "tslint",
	        "tslint-react",
	        "typescript",
	        "warning",
	        "yup"
	      ],
	      "tags": [
	        "form"
	      ],
	      "lastStarCount": 8261,
	      "lastUpdatedAt": "2018-07-27T21:12:59Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/4060187?v=4"
	    },
	    {
	      "githubPath": "yjose/reactjs-popup",
	      "description": "React Popup Component - Modals,Tooltips and Menus —  All in one",
	      "homepage": "https://react-popup.netlify.com/",
	      "dependencies": [
	        "@babel/core",
	        "@babel/plugin-proposal-class-properties",
	        "@babel/preset-env",
	        "@babel/preset-react",
	        "babel-plugin-transform-class-properties",
	        "babel-preset-env",
	        "babel-preset-react",
	        "bili",
	        "cross-env",
	        "del",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "enzyme-to-json",
	        "http-server",
	        "jest",
	        "parcel-bundler",
	        "prop-types",
	        "react",
	        "react-dom",
	        "story-router",
	        "why-did-you-update"
	      ],
	      "tags": [],
	      "lastStarCount": 300,
	      "lastUpdatedAt": "2018-07-27T10:13:20Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/11137944?v=4"
	    },
	    {
	      "githubPath": "MailOnline/libreact",
	      "description": "React standard library",
	      "homepage": "http://bit.ly/2DNXjdv",
	      "dependencies": [
	        "@semantic-release/changelog",
	        "@semantic-release/git",
	        "@semantic-release/npm",
	        "@storybook/addon-actions",
	        "@storybook/addon-links",
	        "@storybook/react",
	        "@types/chai",
	        "@types/jest",
	        "@types/node",
	        "@types/react",
	        "@types/react-dom",
	        "chai",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "enzyme-to-json",
	        "fast-af",
	        "git-cz",
	        "gitbook-cli",
	        "glob",
	        "gulp",
	        "gulp-typescript",
	        "jest",
	        "jest-environment-jsdom",
	        "jest-environment-jsdom-global",
	        "mkdirp",
	        "mocha",
	        "nano-css",
	        "prop-types",
	        "react",
	        "react-dom",
	        "react-focus-lock",
	        "react-markdown",
	        "react-test-renderer",
	        "react-universal-interface",
	        "rimraf",
	        "screenfull",
	        "semantic-release",
	        "throttle-debounce",
	        "to-string-loader",
	        "ts-jest",
	        "ts-loader",
	        "ts-node",
	        "tslib",
	        "typescript",
	        "webpack"
	      ],
	      "tags": [
	        "toolkit"
	      ],
	      "lastStarCount": 90,
	      "lastUpdatedAt": "2018-07-23T14:52:13Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/1233900?v=4"
	    },
	    {
	      "githubPath": "reakit/reakit",
	      "description": "Toolkit for building interactive UIs with React",
	      "homepage": "https://reakit.io",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-jest",
	        "babel-plugin-external-helpers",
	        "babel-plugin-styled-components",
	        "babel-plugin-transform-es2015-modules-commonjs",
	        "babel-polyfill",
	        "babel-preset-env",
	        "babel-preset-react",
	        "babel-preset-stage-1",
	        "codemirror",
	        "constate",
	        "cross-spawn",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "enzyme-to-json",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-config-prettier",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-prettier",
	        "eslint-plugin-react",
	        "file-loader",
	        "hoist-non-react-statics",
	        "jest-cli",
	        "jest-serializer-html",
	        "lodash",
	        "lodash-es",
	        "markdown-to-jsx",
	        "opn-cli",
	        "parse-prop-types",
	        "prettier",
	        "pretty",
	        "prop-types",
	        "raf",
	        "raw-loader",
	        "react",
	        "react-benchmark",
	        "react-codemirror2",
	        "react-dom",
	        "react-helmet",
	        "react-icons",
	        "react-known-props",
	        "react-router-dom",
	        "react-styleguidist",
	        "react-test-renderer",
	        "rimraf",
	        "rollup",
	        "rollup-plugin-babel",
	        "rollup-plugin-commonjs",
	        "rollup-plugin-filesize",
	        "rollup-plugin-ignore",
	        "rollup-plugin-node-resolve",
	        "rollup-plugin-replace",
	        "rollup-plugin-uglify",
	        "singel",
	        "standard-changelog",
	        "styled-components",
	        "styled-tools",
	        "url-loader",
	        "webpack",
	        "webpack-blocks",
	        "whatwg-fetch"
	      ],
	      "tags": [
	        "toolkit"
	      ],
	      "lastStarCount": 759,
	      "lastUpdatedAt": "2018-07-27T14:26:22Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/40200111?v=4"
	    },
	    {
	      "githubPath": "josephmaxim/sc-react",
	      "description": "🥇 [sc-react v1 alpha] A react library for creating non-rectangular/slanted container divs. ",
	      "homepage": "",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-loader",
	        "babel-plugin-transform-object-rest-spread",
	        "babel-plugin-transform-react-jsx",
	        "babel-preset-env",
	        "enzyme",
	        "expect",
	        "mocha",
	        "prop-types",
	        "react",
	        "react-addons-test-utils",
	        "react-dom",
	        "styled-components",
	        "webpack"
	      ],
	      "tags": [],
	      "lastStarCount": 11,
	      "lastUpdatedAt": "2018-05-15T04:12:29Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/10732770?v=4"
	    },
	    {
	      "githubPath": "ArthurClemens/polythene",
	      "description": "Material Design component library for Mithril and React",
	      "homepage": "",
	      "dependencies": [
	        "@lhorie/rollup-plugin-commonjs",
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-external-helpers",
	        "babel-plugin-transform-object-assign",
	        "babel-plugin-transform-object-rest-spread",
	        "babel-plugin-transform-react-jsx",
	        "babel-plugin-transform-runtime",
	        "babel-preset-env",
	        "babel-register",
	        "broken-link-checker",
	        "css-loader",
	        "cssnano",
	        "del",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "enzyme-to-json",
	        "eslint",
	        "eslint-config-airbnb-base",
	        "eslint-plugin-import",
	        "eslint-plugin-react",
	        "fs-promise",
	        "glob-fs",
	        "j2c",
	        "j2c-plugin-prefix-browser",
	        "lerna",
	        "mithril-jest",
	        "react",
	        "react-addons-test-utils",
	        "react-dom",
	        "react-test-renderer",
	        "rollup",
	        "rollup-plugin-babel",
	        "rollup-plugin-commonjs",
	        "rollup-plugin-eslint",
	        "rollup-plugin-livereload",
	        "rollup-plugin-node-resolve",
	        "rollup-plugin-pathmodify",
	        "rollup-plugin-replace",
	        "rollup-plugin-serve",
	        "rollup-plugin-uglify",
	        "shelljs",
	        "style-loader"
	      ],
	      "tags": [
	        "material design",
	        "toolkit"
	      ],
	      "lastStarCount": 494,
	      "lastUpdatedAt": "2018-07-27T09:15:24Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/350303?v=4"
	    },
	    {
	      "githubPath": "LINKIWI/react-elemental",
	      "description": "Modern, flat React UI component library",
	      "homepage": "https://blog.kevinlin.info/react-elemental-a-modern-flat-react-ui-component-library/",
	      "dependencies": [
	        "@linkiwi/eslint-config",
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-jest",
	        "babel-plugin-module-resolver",
	        "babel-plugin-transform-react-remove-prop-types",
	        "babel-preset-env",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "bundlesize",
	        "color",
	        "concurrently",
	        "coveralls",
	        "derive-pkg-cli",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "eslint",
	        "eslint-import-resolver-babel-module",
	        "eslint-plugin-import",
	        "eslint-plugin-jest",
	        "eslint-plugin-react",
	        "jest",
	        "nodemon",
	        "pre-commit",
	        "prop-types",
	        "raf",
	        "react",
	        "react-dom",
	        "react-test-renderer",
	        "sinon"
	      ],
	      "tags": [
	        "toolkit"
	      ],
	      "lastStarCount": 125,
	      "lastUpdatedAt": "2018-07-13T05:30:23Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/8386642?v=4"
	    },
	    {
	      "githubPath": "appbaseio/reactivesearch",
	      "description": "A React and React Native UI components library for building data-driven apps with Elasticsearch",
	      "homepage": "https://opensource.appbase.io/reactivesearch",
	      "dependencies": [
	        "concurrently",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-plugin-babel",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "husky",
	        "lint-staged"
	      ],
	      "tags": [
	        "toolkit"
	      ],
	      "lastStarCount": 2143,
	      "lastUpdatedAt": "2018-07-27T07:07:26Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/8524145?v=4"
	    },
	    {
	      "githubPath": "mlaursen/react-md",
	      "description": "React material design",
	      "homepage": "https://react-md.mlaursen.com",
	      "dependencies": [
	        "@types/react",
	        "autoprefixer",
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-jest",
	        "babel-plugin-external-helpers",
	        "babel-plugin-transform-react-remove-prop-types",
	        "babel-polyfill",
	        "babel-preset-env",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "bluebird",
	        "classnames",
	        "cpx",
	        "cross-env",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "enzyme-to-json",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "gzip-size",
	        "intl",
	        "jest-cli",
	        "node-sass",
	        "npm-run-all",
	        "postcss",
	        "pretty-bytes",
	        "prop-types",
	        "react",
	        "react-dom",
	        "react-motion",
	        "react-prop-types",
	        "react-swipeable-views",
	        "react-test-renderer",
	        "react-transition-group",
	        "resize-observer-polyfill",
	        "rimraf",
	        "rollup",
	        "rollup-plugin-babel",
	        "rollup-plugin-commonjs",
	        "rollup-plugin-node-resolve",
	        "rollup-plugin-replace",
	        "rollup-plugin-uglify",
	        "typescript"
	      ],
	      "tags": [
	        "toolkit",
	        "material design"
	      ],
	      "lastStarCount": 1823,
	      "lastUpdatedAt": "2018-07-26T17:40:42Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/3920850?v=4"
	    },
	    {
	      "githubPath": "react-toolbox/react-toolbox",
	      "description": "A set of React components implementing Google's Material Design specification with the power of CSS Modules",
	      "homepage": "http://www.react-toolbox.io",
	      "dependencies": [
	        "autoprefixer",
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-react-transform",
	        "babel-polyfill",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "classnames",
	        "core-js",
	        "cpx",
	        "cross-env",
	        "css-loader",
	        "eslint",
	        "eslint-import-resolver-webpack",
	        "eslint-plugin-babel",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "expect",
	        "express",
	        "extract-text-webpack-plugin",
	        "git-dirty",
	        "glob",
	        "immutability-helper",
	        "immutability-helper",
	        "internal-ip",
	        "karma",
	        "karma-cli",
	        "karma-mocha",
	        "karma-phantomjs-launcher",
	        "karma-webpack",
	        "lint-staged",
	        "mocha",
	        "node-sass",
	        "normalize.css",
	        "phantomjs-prebuilt",
	        "postcss-loader",
	        "pre-commit",
	        "react",
	        "react-addons-css-transition-group",
	        "react-addons-test-utils",
	        "react-css-themr",
	        "react-dom",
	        "react-transform-catch-errors",
	        "react-transform-hmr",
	        "redbox-react",
	        "rimraf",
	        "sass-lint",
	        "sass-loader",
	        "sinon",
	        "style-loader",
	        "webpack",
	        "webpack-dev-middleware",
	        "webpack-hot-middleware"
	      ],
	      "tags": [
	        "toolkit",
	        "material design"
	      ],
	      "lastStarCount": 8065,
	      "lastUpdatedAt": "2018-07-27T20:47:25Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/13482715?v=4"
	    },
	    {
	      "githubPath": "frontend-collective/react-sortable-tree",
	      "description": "Drag-and-drop sortable component for nested data and hierarchies",
	      "homepage": "https://react-sortable-tree.surge.sh/",
	      "dependencies": [
	        "@storybook/addon-options",
	        "@storybook/addon-storyshots",
	        "@storybook/react",
	        "autoprefixer",
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-jest",
	        "babel-loader",
	        "babel-plugin-external-helpers",
	        "babel-plugin-transform-es2015-modules-commonjs",
	        "babel-plugin-transform-object-rest-spread",
	        "babel-plugin-transform-runtime",
	        "babel-polyfill",
	        "babel-preset-env",
	        "babel-preset-react",
	        "babel-preset-stage-2",
	        "codesandbox",
	        "coveralls",
	        "cross-env",
	        "css-loader",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-config-prettier",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "extract-text-webpack-plugin",
	        "file-loader",
	        "gh-pages",
	        "html-webpack-plugin",
	        "jest",
	        "jest-enzyme",
	        "json-loader",
	        "lodash.isequal",
	        "postcss-loader",
	        "prettier",
	        "prop-types",
	        "react",
	        "react-addons-shallow-compare",
	        "react-dnd",
	        "react-dnd-html5-backend",
	        "react-dnd-scrollzone",
	        "react-dnd-test-backend",
	        "react-dnd-touch-backend",
	        "react-dom",
	        "react-hot-loader",
	        "react-lifecycles-compat",
	        "react-sortable-tree-theme-file-explorer",
	        "react-test-renderer",
	        "react-virtualized",
	        "rimraf",
	        "rollup",
	        "rollup-plugin-babel",
	        "rollup-plugin-commonjs",
	        "rollup-plugin-node-resolve",
	        "rollup-plugin-postcss",
	        "standard-version",
	        "style-loader",
	        "webpack",
	        "webpack-cli",
	        "webpack-dev-server",
	        "webpack-node-externals"
	      ],
	      "tags": [
	        "list"
	      ],
	      "lastStarCount": 1925,
	      "lastUpdatedAt": "2018-07-27T19:02:56Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/38798818?v=4"
	    },
	    {
	      "githubPath": "nardeas/react-font-picker",
	      "description": "React font picker component with material design inspired default styling",
	      "homepage": "",
	      "dependencies": [
	        "babel-eslint",
	        "classnames",
	        "eslint",
	        "eslint-plugin-react",
	        "gulp",
	        "react",
	        "react-component-gulp-tasks",
	        "react-dom",
	        "react-style"
	      ],
	      "tags": [
	        "picker"
	      ],
	      "lastStarCount": 28,
	      "lastUpdatedAt": "2018-05-02T08:51:44Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/11169240?v=4"
	    },
	    {
	      "githubPath": "jxnblk/reflexbox",
	      "description": "React flexbox layout and grid system",
	      "homepage": "http://jxnblk.com/reflexbox",
	      "dependencies": [
	        "ava",
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-preset-env",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "babel-register",
	        "browser-env",
	        "chroma-js",
	        "funcup",
	        "prop-types",
	        "raw-loader",
	        "react",
	        "react-dom",
	        "react-live",
	        "react-test-renderer",
	        "react-x-ray",
	        "reline",
	        "repng",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "grid"
	      ],
	      "lastStarCount": 1202,
	      "lastUpdatedAt": "2018-07-27T17:15:29Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/3451712?v=4"
	    },
	    {
	      "githubPath": "chrvadala/react-svg-pan-zoom",
	      "description": ":eyes: A React component that adds pan and zoom features to SVG",
	      "homepage": "https://chrvadala.github.io/react-svg-pan-zoom/",
	      "dependencies": [
	        "@storybook/addon-actions",
	        "@storybook/addon-knobs",
	        "@storybook/addon-options",
	        "@storybook/addons",
	        "@storybook/react",
	        "@storybook/ui",
	        "babel-cli",
	        "babel-core",
	        "babel-loader",
	        "babel-plugin-transform-object-rest-spread",
	        "babel-preset-es2015",
	        "babel-preset-es2015-webpack2",
	        "babel-preset-react",
	        "cross-env",
	        "del-cli",
	        "gh-pages",
	        "npm-run-all",
	        "prop-types",
	        "react",
	        "react-dom",
	        "react-virtualized",
	        "transformation-matrix",
	        "webpack",
	        "webpack-cli",
	        "webpack-dev-server"
	      ],
	      "tags": [],
	      "lastStarCount": 310,
	      "lastUpdatedAt": "2018-07-27T14:51:09Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/1770596?v=4"
	    },
	    {
	      "githubPath": "jacted/lead-form",
	      "description": "Lead capture widget",
	      "homepage": "https://jacted.github.io/lead-form/",
	      "dependencies": [
	        "babel-core",
	        "babel-loader",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "css-loader",
	        "node-sass",
	        "react",
	        "react-dom",
	        "sass-loader",
	        "style-loader",
	        "superagent",
	        "url-loader",
	        "webpack"
	      ],
	      "tags": [],
	      "lastStarCount": 25,
	      "lastUpdatedAt": "2018-06-22T18:41:14Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/8938814?v=4"
	    },
	    {
	      "githubPath": "selvagsz/react-async-button",
	      "description": "React button component for handling async actions",
	      "homepage": "https://selvagsz.github.io/react-async-button/",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-jest",
	        "babel-loader",
	        "babel-polyfill",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "babel-preset-stage-1",
	        "coveralls",
	        "css-loader",
	        "enzyme",
	        "husky",
	        "jest",
	        "jest-cli",
	        "lint-staged",
	        "prettier",
	        "prop-types",
	        "react",
	        "react-addons-test-utils",
	        "react-dom",
	        "react-fa",
	        "react-highlight",
	        "react-test-renderer",
	        "sinon",
	        "style-loader",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "button"
	      ],
	      "lastStarCount": 33,
	      "lastUpdatedAt": "2018-05-24T12:45:24Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/2162441?v=4"
	    },
	    {
	      "githubPath": "zackargyle/react-bash",
	      "description": "A configurable/extendable bash terminal React component",
	      "homepage": null,
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-loader",
	        "babel-polyfill",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "chai",
	        "cross-env",
	        "enzyme",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "mocha",
	        "prop-types",
	        "react",
	        "react-addons-test-utils",
	        "react-dom",
	        "rimraf",
	        "sinon",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [],
	      "lastStarCount": 429,
	      "lastUpdatedAt": "2018-07-19T10:11:44Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/3934294?v=4"
	    },
	    {
	      "githubPath": "kaivi/riek",
	      "description": "An set of common form components for React, editable in-line",
	      "homepage": "",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-loader",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-1",
	        "debug",
	        "highlight.js",
	        "prop-types",
	        "react-highlight",
	        "webpack"
	      ],
	      "tags": [
	        "set",
	        "form"
	      ],
	      "lastStarCount": 291,
	      "lastUpdatedAt": "2018-07-17T14:28:53Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/3091192?v=4"
	    },
	    {
	      "githubPath": "uber/react-vis",
	      "description": "Data-Visualization oriented components",
	      "homepage": "https://uber.github.io/react-vis",
	      "dependencies": [
	        "babel-cli",
	        "babel-eslint",
	        "babel-plugin-module-resolver",
	        "babel-preset-es2015",
	        "babel-preset-es2017",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "babel-register",
	        "babelify",
	        "browserify",
	        "canvas-prebuilt",
	        "d3-array",
	        "d3-collection",
	        "d3-color",
	        "d3-contour",
	        "d3-format",
	        "d3-geo",
	        "d3-hierarchy",
	        "d3-interpolate",
	        "d3-sankey",
	        "d3-scale",
	        "d3-shape",
	        "d3-voronoi",
	        "deep-equal",
	        "enzyme",
	        "eslint",
	        "eslint-config-uber-es2015",
	        "eslint-config-uber-jsx",
	        "eslint-plugin-babel",
	        "eslint-plugin-no-only-tests",
	        "eslint-plugin-react",
	        "global",
	        "hoek",
	        "jsdom",
	        "node-sass",
	        "nyc",
	        "prop-types",
	        "react",
	        "react-addons-test-utils",
	        "react-dom",
	        "react-motion",
	        "react-test-renderer",
	        "stylelint",
	        "stylelint-config-standard",
	        "tape",
	        "uglify-js"
	      ],
	      "tags": [
	        "set",
	        "dataviz"
	      ],
	      "lastStarCount": 3950,
	      "lastUpdatedAt": "2018-07-27T19:32:43Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/538264?v=4"
	    },
	    {
	      "githubPath": "airbnb/react-dates",
	      "description": "An easily internationalizable, mobile-friendly datepicker library for the web",
	      "homepage": "http://airbnb.io/react-dates",
	      "dependencies": [
	        "@storybook/addon-actions",
	        "@storybook/addon-info",
	        "@storybook/addon-links",
	        "@storybook/addon-options",
	        "@storybook/react",
	        "airbnb-js-shims",
	        "airbnb-prop-types",
	        "aphrodite",
	        "babel-cli",
	        "babel-core",
	        "babel-loader",
	        "babel-plugin-inline-react-svg",
	        "babel-plugin-inline-svg",
	        "babel-plugin-istanbul",
	        "babel-plugin-syntax-jsx",
	        "babel-plugin-transform-replace-object-assign",
	        "babel-preset-airbnb",
	        "babel-register",
	        "chai",
	        "clean-css",
	        "consolidated-events",
	        "coveralls",
	        "cross-env",
	        "enzyme",
	        "enzyme-adapter-react-helper",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "eslint-plugin-react-with-styles",
	        "git-directory-deploy",
	        "imports-loader",
	        "in-publish",
	        "is-touch-device",
	        "json-loader",
	        "karma",
	        "karma-chai",
	        "karma-firefox-launcher",
	        "karma-mocha",
	        "karma-sinon",
	        "karma-webpack",
	        "lodash",
	        "mocha",
	        "mocha-wrap",
	        "moment",
	        "moment-jalaali",
	        "node-sass",
	        "nyc",
	        "object.assign",
	        "object.values",
	        "prop-types",
	        "raw-loader",
	        "react",
	        "react-addons-shallow-compare",
	        "react-dom",
	        "react-moment-proptypes",
	        "react-outside-click-handler",
	        "react-portal",
	        "react-with-styles",
	        "react-with-styles-interface-aphrodite",
	        "react-with-styles-interface-css",
	        "react-with-styles-interface-css-compiler",
	        "rimraf",
	        "safe-publish-latest",
	        "sass-loader",
	        "sinon",
	        "sinon-sandbox",
	        "style-loader",
	        "webpack"
	      ],
	      "tags": [
	        "calendar"
	      ],
	      "lastStarCount": 7891,
	      "lastUpdatedAt": "2018-07-27T20:32:07Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/698437?v=4"
	    },
	    {
	      "githubPath": "clauderic/react-infinite-calendar",
	      "description": "✨ Infinite scrolling date-picker built with React, with localization, range selection, themes, keyboard support, and more.",
	      "homepage": "http://clauderic.github.io/react-infinite-calendar/",
	      "dependencies": [
	        "@kadira/storybook",
	        "@kadira/storybook-addon-options",
	        "babel-eslint",
	        "babel-plugin-css-modules-transform",
	        "classnames",
	        "date-fns",
	        "dom-helpers",
	        "eslint",
	        "eslint-config-react-app",
	        "eslint-plugin-flowtype",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "node-sass",
	        "nwb",
	        "nwb-sass",
	        "prop-types",
	        "react",
	        "react-dom",
	        "react-tiny-virtual-list",
	        "react-transition-group",
	        "recompose"
	      ],
	      "tags": [
	        "calendar"
	      ],
	      "lastStarCount": 2986,
	      "lastUpdatedAt": "2018-07-27T19:37:53Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/1416436?v=4"
	    },
	    {
	      "githubPath": "troch/react-timer-hoc",
	      "description": "A React timer higher-order component",
	      "homepage": null,
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-plugin-transform-es2015-modules-umd",
	        "babel-plugin-transform-function-bind",
	        "babel-plugin-transform-object-rest-spread",
	        "babel-preset-es2015",
	        "chai",
	        "conventional-changelog",
	        "eslint",
	        "eslint-config-recommended",
	        "invariant",
	        "jsdom",
	        "mocha",
	        "prop-types",
	        "react",
	        "react-addons-test-utils",
	        "react-dom",
	        "react-hyperscript",
	        "sinon",
	        "sinon-chai"
	      ],
	      "tags": [],
	      "lastStarCount": 32,
	      "lastUpdatedAt": "2018-05-15T02:04:35Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/1777517?v=4"
	    },
	    {
	      "githubPath": "erikras/redux-form",
	      "description": "A Higher Order Component using react-redux to keep form state in a Redux store",
	      "homepage": "http://redux-form.com",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-jest",
	        "babel-loader",
	        "babel-plugin-istanbul",
	        "babel-plugin-lodash",
	        "babel-plugin-syntax-async-functions",
	        "babel-plugin-transform-es2015-modules-commonjs",
	        "babel-plugin-transform-react-jsx-source",
	        "babel-plugin-transform-regenerator",
	        "babel-preset-es2015-no-commonjs",
	        "babel-preset-react",
	        "babel-preset-stage-2",
	        "babel-register",
	        "codecov.io",
	        "cross-env",
	        "deep-equal",
	        "es6-error",
	        "eslint",
	        "eslint-config-react-app",
	        "eslint-plugin-babel",
	        "eslint-plugin-flowtype",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "flow-bin",
	        "flux-standard-action",
	        "glow",
	        "hoist-non-react-statics",
	        "husky",
	        "immutable",
	        "invariant",
	        "is-promise",
	        "jest",
	        "lint-staged",
	        "lodash",
	        "lodash-es",
	        "lodash-webpack-plugin",
	        "prettier",
	        "prettier-eslint-cli",
	        "prop-types",
	        "react",
	        "react-dom",
	        "react-is",
	        "react-lifecycles-compat",
	        "react-redux",
	        "redux",
	        "redux-immutablejs",
	        "rifraf",
	        "rimraf",
	        "stringstream",
	        "tmp",
	        "webpack",
	        "webpack-bundle-analyzer",
	        "webpack-cli"
	      ],
	      "tags": [
	        "set",
	        "form"
	      ],
	      "lastStarCount": 10207,
	      "lastUpdatedAt": "2018-07-27T21:28:42Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/4396759?v=4"
	    },
	    {
	      "githubPath": "clauderic/react-sortable-hoc",
	      "description": "A set of higher-order components to turn any list into an animated, touch-friendly, sortable list ✌️",
	      "homepage": "http://clauderic.github.io/react-sortable-hoc/",
	      "dependencies": [
	        "@kadira/storybook",
	        "@kadira/storybook-deployer",
	        "autoprefixer",
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-css-modules-transform",
	        "babel-plugin-transform-object-assign",
	        "babel-plugin-transform-runtime",
	        "babel-polyfill",
	        "babel-preset-es2015",
	        "babel-preset-es2015-rollup",
	        "babel-preset-react",
	        "babel-preset-react-hmre",
	        "babel-preset-stage-0",
	        "babel-preset-stage-1",
	        "babel-preset-stage-2",
	        "babel-register",
	        "babel-runtime",
	        "classnames",
	        "cross-env",
	        "css-loader",
	        "eslint",
	        "eslint-config-react-app",
	        "eslint-plugin-flowtype",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "express",
	        "extract-text-webpack-plugin",
	        "html-webpack-plugin",
	        "invariant",
	        "isparta-loader",
	        "lodash",
	        "node-libs-browser",
	        "node-sass",
	        "postcss-loader",
	        "prop-types",
	        "qs",
	        "raw-loader",
	        "react",
	        "react-addons-pure-render-mixin",
	        "react-addons-shallow-compare",
	        "react-addons-test-utils",
	        "react-dom",
	        "react-infinite",
	        "react-tiny-virtual-list",
	        "react-virtualized",
	        "redux",
	        "rimraf",
	        "sass-loader",
	        "stack-source-map",
	        "style-loader",
	        "webpack",
	        "webpack-dashboard",
	        "webpack-dev-middleware",
	        "webpack-hot-middleware",
	        "yargs"
	      ],
	      "tags": [
	        "list"
	      ],
	      "lastStarCount": 5060,
	      "lastUpdatedAt": "2018-07-27T18:31:52Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/1416436?v=4"
	    },
	    {
	      "githubPath": "mironov/react-redux-loading-bar",
	      "description": "Loading Bar (aka Progress Bar) for Redux and React",
	      "homepage": "https://mironov.github.io/react-redux-loading-bar/",
	      "dependencies": [
	        "@types/react",
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-2",
	        "coveralls",
	        "enzyme",
	        "enzyme-adapter-react-15",
	        "enzyme-adapter-react-16",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "expect",
	        "expect-jsx",
	        "immutable",
	        "istanbul",
	        "jsdom",
	        "lolex",
	        "mocha",
	        "pkgfiles",
	        "prop-types",
	        "react",
	        "react-dom",
	        "react-lifecycles-compat",
	        "react-redux",
	        "react-test-renderer",
	        "redux"
	      ],
	      "tags": [
	        "spinner"
	      ],
	      "lastStarCount": 641,
	      "lastUpdatedAt": "2018-07-26T14:49:36Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/20403?v=4"
	    },
	    {
	      "githubPath": "sevenleaps/chat-template",
	      "description": "Chat-Template is a React component that enables quick prototyping of bot conversations.",
	      "homepage": null,
	      "dependencies": [
	        "@kadira/storybook",
	        "aphrodite",
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-transform-runtime",
	        "babel-polyfill",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-1",
	        "babel-preset-stage-2",
	        "babel-runtime",
	        "chai",
	        "enzyme",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-plugin-babel",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "git-url-parse",
	        "jsdom",
	        "material-ui",
	        "mocha",
	        "object-assign-deep",
	        "raw-loader",
	        "react",
	        "react-addons-css-transition-group",
	        "react-addons-test-utils",
	        "react-dom",
	        "react-scroll",
	        "react-scrollbar",
	        "sinon",
	        "style-loader",
	        "webpack"
	      ],
	      "tags": [
	        "chat"
	      ],
	      "lastStarCount": 110,
	      "lastUpdatedAt": "2018-07-10T12:22:13Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/18499145?v=4"
	    },
	    {
	      "githubPath": "alex3165/react-mapbox-gl",
	      "description": "A React binding of mapbox-gl-js",
	      "homepage": "http://alex3165.github.io/react-mapbox-gl/",
	      "dependencies": [
	        "@turf/bbox",
	        "@turf/helpers",
	        "@types/core-js",
	        "@types/deep-equal",
	        "@types/enzyme",
	        "@types/geojson",
	        "@types/jest",
	        "@types/mapbox-gl",
	        "@types/node",
	        "@types/prettier",
	        "@types/prop-types",
	        "@types/react",
	        "@types/react-dom",
	        "@types/recompose",
	        "@types/supercluster",
	        "deep-equal",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "husky",
	        "jest",
	        "mapbox-gl",
	        "prettier",
	        "prop-types",
	        "react",
	        "react-dom",
	        "react-test-renderer",
	        "recompose",
	        "supercluster",
	        "ts-jest",
	        "tslint",
	        "tslint-react",
	        "typescript"
	      ],
	      "tags": [
	        "map"
	      ],
	      "lastStarCount": 716,
	      "lastUpdatedAt": "2018-07-27T09:48:27Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/4259832?v=4"
	    },
	    {
	      "githubPath": "mzabriskie/react-draggable",
	      "description": "React draggable component",
	      "homepage": "",
	      "dependencies": [
	        "@types/react",
	        "@types/react-dom",
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-espower",
	        "babel-plugin-external-helpers",
	        "babel-plugin-transform-flow-comments",
	        "babel-preset-env",
	        "babel-preset-react",
	        "babel-preset-stage-2",
	        "classnames",
	        "core-js",
	        "eslint",
	        "eslint-plugin-react",
	        "flow-bin",
	        "jasmine-core",
	        "json-loader",
	        "karma",
	        "karma-chrome-launcher",
	        "karma-cli",
	        "karma-firefox-launcher",
	        "karma-ie-launcher",
	        "karma-jasmine",
	        "karma-phantomjs-launcher",
	        "karma-phantomjs-shim",
	        "karma-webpack",
	        "lodash",
	        "open",
	        "phantomjs-prebuilt",
	        "power-assert",
	        "pre-commit",
	        "prop-types",
	        "puppeteer",
	        "react",
	        "react-dom",
	        "react-frame-component",
	        "react-test-renderer",
	        "rollup",
	        "rollup-plugin-babel",
	        "rollup-plugin-commonjs",
	        "rollup-plugin-node-resolve",
	        "rollup-plugin-replace",
	        "rollup-plugin-size-snapshot",
	        "rollup-plugin-uglify",
	        "semver",
	        "static-server",
	        "typescript",
	        "uglify-js",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [],
	      "lastStarCount": 3484,
	      "lastUpdatedAt": "2018-07-27T20:37:32Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/199035?v=4"
	    },
	    {
	      "githubPath": "patientslikeme/react-calendar-heatmap",
	      "description": "an svg calendar heatmap component, inspired by github's contribution graph",
	      "homepage": "http://patientslikeme.github.io/react-calendar-heatmap/",
	      "dependencies": [
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-preset-env",
	        "babel-preset-react",
	        "babel-register",
	        "cross-env",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "jest",
	        "prop-types",
	        "react",
	        "react-dom",
	        "react-test-renderer",
	        "rimraf",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "calendar"
	      ],
	      "lastStarCount": 373,
	      "lastUpdatedAt": "2018-07-27T02:17:38Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/23326?v=4"
	    },
	    {
	      "githubPath": "bvaughn/react-virtualized",
	      "description": "React components for efficiently rendering large lists and tabular data",
	      "homepage": "http://www.reactvirtualized.com",
	      "dependencies": [
	        "autoprefixer",
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-jest",
	        "babel-loader",
	        "babel-plugin-external-helpers",
	        "babel-plugin-flow-react-proptypes",
	        "babel-plugin-transform-es2015-modules-commonjs",
	        "babel-plugin-transform-react-remove-prop-types",
	        "babel-plugin-transform-runtime",
	        "babel-polyfill",
	        "babel-preset-env",
	        "babel-preset-flow",
	        "babel-preset-react",
	        "babel-preset-stage-2",
	        "babel-runtime",
	        "classnames",
	        "codecov",
	        "codemirror",
	        "cross-env",
	        "css-loader",
	        "dom-helpers",
	        "eslint",
	        "eslint-config-fbjs",
	        "eslint-config-prettier",
	        "eslint-config-react",
	        "eslint-plugin-babel",
	        "eslint-plugin-flowtype",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-prettier",
	        "eslint-plugin-react",
	        "eslint-plugin-relay",
	        "extract-text-webpack-plugin",
	        "file-loader",
	        "flow-bin",
	        "flow-copy-source",
	        "gh-pages",
	        "html-webpack-plugin",
	        "husky",
	        "immutable",
	        "jest",
	        "jest-environment-puppeteer",
	        "lint-staged",
	        "loose-envify",
	        "postcss",
	        "postcss-cli",
	        "postcss-loader",
	        "prettier",
	        "prop-types",
	        "puppeteer",
	        "react",
	        "react-codemirror",
	        "react-dom",
	        "react-lifecycles-compat",
	        "react-router",
	        "react-router-dom",
	        "react-test-renderer",
	        "rimraf",
	        "rollup",
	        "rollup-plugin-babel",
	        "rollup-plugin-commonjs",
	        "rollup-plugin-node-resolve",
	        "rollup-plugin-replace",
	        "rollup-plugin-uglify",
	        "style-loader",
	        "watch",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "list"
	      ],
	      "lastStarCount": 11687,
	      "lastUpdatedAt": "2018-07-27T17:56:17Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/29597?v=4"
	    },
	    {
	      "githubPath": "maisano/react-router-transition",
	      "description": "painless transitions built for react-router, powered by react-motion",
	      "homepage": "http://maisano.github.io/react-router-transition/",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-loader",
	        "babel-plugin-check-es2015-constants",
	        "babel-plugin-syntax-jsx",
	        "babel-plugin-syntax-object-rest-spread",
	        "babel-plugin-transform-class-properties",
	        "babel-plugin-transform-es2015-arrow-functions",
	        "babel-plugin-transform-es2015-block-scoped-functions",
	        "babel-plugin-transform-es2015-block-scoping",
	        "babel-plugin-transform-es2015-classes",
	        "babel-plugin-transform-es2015-computed-properties",
	        "babel-plugin-transform-es2015-destructuring",
	        "babel-plugin-transform-es2015-duplicate-keys",
	        "babel-plugin-transform-es2015-for-of",
	        "babel-plugin-transform-es2015-function-name",
	        "babel-plugin-transform-es2015-literals",
	        "babel-plugin-transform-es2015-modules-commonjs",
	        "babel-plugin-transform-es2015-object-super",
	        "babel-plugin-transform-es2015-parameters",
	        "babel-plugin-transform-es2015-shorthand-properties",
	        "babel-plugin-transform-es2015-spread",
	        "babel-plugin-transform-es2015-sticky-regex",
	        "babel-plugin-transform-es2015-template-literals",
	        "babel-plugin-transform-es2015-typeof-symbol",
	        "babel-plugin-transform-es2015-unicode-regex",
	        "babel-plugin-transform-object-rest-spread",
	        "babel-plugin-transform-react-display-name",
	        "babel-plugin-transform-react-jsx",
	        "babel-plugin-transform-react-remove-prop-types",
	        "babel-plugin-transform-regenerator",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "prettier",
	        "prop-types",
	        "react",
	        "react-dom",
	        "react-motion",
	        "react-router-dom",
	        "webpack"
	      ],
	      "tags": [],
	      "lastStarCount": 1795,
	      "lastUpdatedAt": "2018-07-27T15:05:51Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/689081?v=4"
	    },
	    {
	      "githubPath": "chenglou/react-motion",
	      "description": "A spring that solves your animation problems.",
	      "homepage": "",
	      "dependencies": [
	        "@babel/cli",
	        "@babel/core",
	        "@babel/plugin-transform-modules-commonjs",
	        "@babel/polyfill",
	        "@babel/preset-env",
	        "@babel/preset-flow",
	        "@babel/preset-react",
	        "@babel/preset-stage-3",
	        "babel-eslint",
	        "babel-loader",
	        "codemirror",
	        "cross-env",
	        "css-loader",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-loader",
	        "eslint-plugin-flowtype",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "flow-bin",
	        "inject-loader",
	        "isparta-loader",
	        "jasmine-core",
	        "karma",
	        "karma-coverage",
	        "karma-jasmine",
	        "karma-jasmine-diff-reporter",
	        "karma-phantomjs-launcher",
	        "karma-webpack",
	        "lodash.range",
	        "performance-now",
	        "phantomjs",
	        "prop-types",
	        "raf",
	        "react",
	        "react-codemirror",
	        "react-dom",
	        "rollup",
	        "rollup-plugin-babel",
	        "rollup-plugin-commonjs",
	        "rollup-plugin-node-resolve",
	        "rollup-plugin-replace",
	        "rollup-plugin-size-snapshot",
	        "rollup-plugin-uglify",
	        "style-loader",
	        "webpack",
	        "webpack-command",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "animation"
	      ],
	      "lastStarCount": 14060,
	      "lastUpdatedAt": "2018-07-27T19:01:29Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/1909539?v=4"
	    },
	    {
	      "githubPath": "dantrain/react-stonecutter",
	      "description": "Animated grid layout component for React",
	      "homepage": "http://dantrain.github.io/react-stonecutter",
	      "dependencies": [
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-2",
	        "browser-sync",
	        "chai",
	        "chai-enzyme",
	        "enquire.js",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "gulp",
	        "gulp-eslint",
	        "gulp-filter",
	        "gulp-rename",
	        "gulp-shell",
	        "gulp-util",
	        "husky",
	        "imagesloaded",
	        "lodash.assign",
	        "lodash.camelcase",
	        "lodash.debounce",
	        "lodash.isequalwith",
	        "lodash.omit",
	        "lodash.partition",
	        "lodash.shuffle",
	        "mocha",
	        "node-notifier",
	        "prop-types",
	        "rc-slider",
	        "react",
	        "react-dom",
	        "react-motion",
	        "react-radio-group",
	        "react-test-renderer",
	        "react-transition-group-plus",
	        "run-sequence",
	        "shallowequal",
	        "webpack",
	        "webpack-node-externals"
	      ],
	      "tags": [
	        "grid"
	      ],
	      "lastStarCount": 879,
	      "lastUpdatedAt": "2018-07-23T11:32:47Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/1765203?v=4"
	    },
	    {
	      "githubPath": "necolas/react-native-web",
	      "description": "React Native for Web",
	      "homepage": "https://necolas.github.io/react-native-web/examples",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-add-module-exports",
	        "babel-plugin-transform-class-properties",
	        "babel-plugin-transform-object-rest-spread",
	        "babel-plugin-transform-react-remove-prop-types",
	        "babel-preset-env",
	        "babel-preset-flow",
	        "babel-preset-react",
	        "babel-preset-react-native",
	        "caniuse-api",
	        "del-cli",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "enzyme-to-json",
	        "eslint",
	        "eslint-config-prettier",
	        "eslint-plugin-promise",
	        "eslint-plugin-react",
	        "flow-bin",
	        "glob",
	        "husky",
	        "jest",
	        "jest-canvas-mock",
	        "lint-staged",
	        "npm-run-all",
	        "prettier",
	        "react",
	        "react-art",
	        "react-dom",
	        "react-test-renderer"
	      ],
	      "tags": [
	        "toolkit"
	      ],
	      "lastStarCount": 9931,
	      "lastUpdatedAt": "2018-07-27T16:16:29Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/239676?v=4"
	    },
	    {
	      "githubPath": "moarwick/react-mt-svg-lines",
	      "description": "A React.js wrapper component to animate the line stroke in SVGs",
	      "homepage": "http://moarwick.github.io/react-mt-svg-lines",
	      "dependencies": [
	        "@tweenjs/tween.js",
	        "autoprefixer",
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-preset-env",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "css-loader",
	        "eslint",
	        "eslint-config-standard",
	        "eslint-plugin-import",
	        "eslint-plugin-node",
	        "eslint-plugin-promise",
	        "eslint-plugin-react",
	        "eslint-plugin-standard",
	        "extract-text-webpack-plugin",
	        "file-loader",
	        "gh-pages",
	        "html-webpack-plugin",
	        "node-sass",
	        "postcss-loader",
	        "prop-types",
	        "react",
	        "react-dom",
	        "react-hot-loader",
	        "rimraf",
	        "sass-loader",
	        "standard",
	        "style-loader",
	        "url-loader",
	        "webpack",
	        "webpack-dev-server",
	        "webpack-merge"
	      ],
	      "tags": [],
	      "lastStarCount": 293,
	      "lastUpdatedAt": "2018-07-26T20:35:46Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/4442541?v=4"
	    },
	    {
	      "githubPath": "facebook/draft-js",
	      "description": "A React framework for building text editors.",
	      "homepage": "https://draftjs.org/",
	      "dependencies": [
	        "babel-core",
	        "babel-eslint",
	        "babel-preset-fbjs",
	        "cross-env",
	        "del",
	        "envify",
	        "es6-shim",
	        "eslint",
	        "eslint-config-fbjs",
	        "eslint-config-prettier",
	        "eslint-plugin-babel",
	        "eslint-plugin-flowtype",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-prettier",
	        "eslint-plugin-react",
	        "eslint-plugin-relay",
	        "fbjs",
	        "fbjs-scripts",
	        "flow-bin",
	        "gulp",
	        "gulp-babel",
	        "gulp-browserify-thin",
	        "gulp-clean-css",
	        "gulp-concat-css",
	        "gulp-derequire",
	        "gulp-flatten",
	        "gulp-header",
	        "gulp-if",
	        "gulp-rename",
	        "gulp-uglify",
	        "gulp-util",
	        "immutable",
	        "jest",
	        "object-assign",
	        "prettier",
	        "react",
	        "react-dom",
	        "react-test-renderer",
	        "run-sequence",
	        "stats-webpack-plugin",
	        "through2",
	        "uglifyjs-webpack-plugin",
	        "vinyl-buffer",
	        "webpack-stream"
	      ],
	      "tags": [
	        "text editor"
	      ],
	      "lastStarCount": 13457,
	      "lastUpdatedAt": "2018-07-27T19:37:24Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/69631?v=4"
	    },
	    {
	      "githubPath": "draft-js-plugins/draft-js-plugins",
	      "description": "React Plugin Architecture for Draft.js including Slack-Like Emojis, FB-Like Mentions and Stickers",
	      "homepage": "https://www.draft-js-plugins.com/",
	      "dependencies": [
	        "@storybook/react",
	        "alex",
	        "animateplus",
	        "autoprefixer",
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-jest",
	        "babel-loader",
	        "babel-plugin-react-transform",
	        "babel-plugin-webpack-loaders",
	        "babel-polyfill",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-react-hmre",
	        "babel-preset-stage-0",
	        "chai",
	        "chai-enzyme",
	        "cheerio",
	        "css-loader",
	        "css-modules-require-hook",
	        "decorate-component-with-props",
	        "dirty-chai",
	        "draft-js",
	        "emojione",
	        "enzyme",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-mocha",
	        "eslint-plugin-react",
	        "estraverse-fb",
	        "express",
	        "extract-text-webpack-plugin",
	        "find-with-regex",
	        "flow-bin",
	        "immutable",
	        "jest-cli",
	        "jsdom",
	        "linkify-it",
	        "lint-staged",
	        "loader-utils",
	        "lodash.escaperegexp",
	        "lodash.keys",
	        "mocha",
	        "multer",
	        "postcss-loader",
	        "pre-commit",
	        "prepend-http",
	        "prismjs",
	        "prop-types",
	        "react",
	        "react-addons-pure-render-mixin",
	        "react-addons-test-utils",
	        "react-custom-scrollbars",
	        "react-dom",
	        "react-icons",
	        "react-router",
	        "react-static-webpack-plugin",
	        "react-transform-catch-errors",
	        "react-transform-hmr",
	        "redbox-react",
	        "rimraf",
	        "sinon",
	        "sinon-chai",
	        "style-loader",
	        "superagent",
	        "tlds",
	        "to-style",
	        "union-class-names",
	        "webpack",
	        "webpack-dev-middleware",
	        "webpack-hot-middleware"
	      ],
	      "tags": [
	        "text editor"
	      ],
	      "lastStarCount": 2807,
	      "lastUpdatedAt": "2018-07-27T19:32:02Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/17958833?v=4"
	    },
	    {
	      "githubPath": "sstur/react-rte",
	      "description": "Pure React rich text \"WYSISYG\" editor based on draft-js.",
	      "homepage": "https://react-rte.org",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-transform-es2015-modules-commonjs",
	        "babel-plugin-transform-runtime",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-2",
	        "babel-runtime",
	        "class-autobind",
	        "classnames",
	        "css-loader",
	        "css-modules-require-hook",
	        "draft-js",
	        "draft-js-export-html",
	        "draft-js-export-markdown",
	        "draft-js-import-html",
	        "draft-js-import-markdown",
	        "draft-js-utils",
	        "eslint",
	        "eslint-plugin-babel",
	        "eslint-plugin-flow-vars",
	        "eslint-plugin-react",
	        "expect",
	        "flow-bin",
	        "immutable",
	        "mocha",
	        "raw-loader",
	        "react-addons-test-utils",
	        "rimraf",
	        "style-loader",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "text editor"
	      ],
	      "lastStarCount": 1829,
	      "lastUpdatedAt": "2018-07-27T14:33:09Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/369384?v=4"
	    },
	    {
	      "githubPath": "malte-wessel/react-matchmedia-connect",
	      "description": "Higher order components for matchMedia",
	      "homepage": "http://malte-wessel.github.io/react-matchmedia-connect/",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-rewire",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-1",
	        "babel-register",
	        "babel-runtime",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "expect",
	        "isparta-loader",
	        "karma",
	        "karma-chrome-launcher",
	        "karma-cli",
	        "karma-coverage",
	        "karma-mocha",
	        "karma-mocha-reporter",
	        "karma-sourcemap-loader",
	        "karma-webpack",
	        "mocha",
	        "react",
	        "react-dom",
	        "rimraf",
	        "shallowequal",
	        "simulant",
	        "sinon",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [],
	      "lastStarCount": 45,
	      "lastUpdatedAt": "2018-04-26T07:18:56Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/1020216?v=4"
	    },
	    {
	      "githubPath": "seejamescode/draft-js-gutter",
	      "description": "A reusable React.js component that compliments Draft.js with a line number gutter.",
	      "homepage": "http://seejamescode.github.io/draft-js-gutter/",
	      "dependencies": [
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-react-hmre",
	        "babel-preset-stage-0",
	        "eventsource-polyfill",
	        "express",
	        "react",
	        "react-dom",
	        "redbox-react",
	        "rimraf",
	        "webpack",
	        "webpack-dev-middleware",
	        "webpack-dev-server",
	        "webpack-hot-middleware"
	      ],
	      "tags": [
	        "text editor"
	      ],
	      "lastStarCount": 12,
	      "lastUpdatedAt": "2018-06-19T20:08:21Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/7519029?v=4"
	    },
	    {
	      "githubPath": "bokuweb-sandbox/react-balloon",
	      "description": "[DEPRECATED] React resizable and movable balloon conponent.",
	      "homepage": "http://bokuweb.github.io/react-balloon/",
	      "dependencies": [
	        "babel",
	        "babel-cli",
	        "babel-eslint",
	        "babel-plugin-add-module-exports",
	        "babel-plugin-espower",
	        "babel-plugin-transform-object-assign",
	        "babel-polyfill",
	        "babel-preset-airbnb",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "babelify",
	        "browserify",
	        "enzyme",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-plugin-react",
	        "espower-babel",
	        "expect",
	        "expect-jsx",
	        "karma",
	        "karma-babel-preprocessor",
	        "karma-browserify",
	        "karma-cli",
	        "karma-mocha",
	        "karma-phantomjs-launcher",
	        "mocha",
	        "phantomjs",
	        "phantomjs-polyfill",
	        "power-assert",
	        "react",
	        "react-addons-test-utils",
	        "react-dom",
	        "react-resizable-and-movable",
	        "sinon",
	        "watchify"
	      ],
	      "tags": [],
	      "lastStarCount": 40,
	      "lastUpdatedAt": "2018-07-18T09:48:10Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/38875156?v=4"
	    },
	    {
	      "githubPath": "KtorZ/elm-react-component",
	      "description": "(deprecated) A React component which wraps an Elm module to be used in a React application.",
	      "homepage": "",
	      "dependencies": [
	        "babel",
	        "babel-core",
	        "babel-loader",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "expect.js",
	        "mocha",
	        "react",
	        "react-dom",
	        "webpack"
	      ],
	      "tags": [],
	      "lastStarCount": 118,
	      "lastUpdatedAt": "2017-11-22T08:58:17Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/5680256?v=4"
	    },
	    {
	      "githubPath": "fatiherikli/react-designer",
	      "description": "Editable vector graphics in your react components.",
	      "homepage": "http://fatiherikli.github.io/react-designer/",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-css-modules-transform",
	        "babel-plugin-webpack-loaders",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "classnames",
	        "css-loader",
	        "eslint-plugin-react",
	        "file-loader",
	        "lodash",
	        "radium",
	        "react",
	        "react-color",
	        "react-dom",
	        "react-hot-loader",
	        "react-hotkeys",
	        "react-portal",
	        "rimraf",
	        "style-loader",
	        "svg-inline-loader",
	        "url-loader",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "set"
	      ],
	      "lastStarCount": 996,
	      "lastUpdatedAt": "2018-07-27T16:28:26Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/1220743?v=4"
	    },
	    {
	      "githubPath": "joshwcomeau/react-flip-move",
	      "description": "Effortless animation between DOM changes (eg. list reordering) using the FLIP technique.",
	      "homepage": "http://joshwcomeau.github.io/react-flip-move/examples",
	      "dependencies": [
	        "@storybook/react",
	        "@types/react",
	        "babel",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-add-module-exports",
	        "babel-plugin-external-helpers",
	        "babel-plugin-istanbul",
	        "babel-plugin-transform-decorators-legacy",
	        "babel-plugin-transform-object-assign",
	        "babel-preset-env",
	        "babel-preset-flow",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "chai",
	        "create-react-class",
	        "cross-env",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-config-prettier",
	        "eslint-plugin-bdd",
	        "eslint-plugin-flowtype",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-prettier",
	        "eslint-plugin-react",
	        "eslint-plugin-sort-class-members",
	        "flow-bin",
	        "flow-coverage-report",
	        "husky",
	        "karma",
	        "karma-chai",
	        "karma-chrome-launcher",
	        "karma-coverage",
	        "karma-mocha",
	        "karma-sinon",
	        "karma-sinon-chai",
	        "karma-sourcemap-loader",
	        "karma-webpack",
	        "lodash",
	        "mocha",
	        "preact",
	        "preact-compat",
	        "prettier",
	        "prop-types",
	        "react",
	        "react-dom",
	        "react-test-renderer",
	        "rollup",
	        "rollup-plugin-babel",
	        "rollup-plugin-replace",
	        "rollup-plugin-uglify",
	        "sinon",
	        "sinon-chai",
	        "tslint",
	        "typescript",
	        "webpack"
	      ],
	      "tags": [
	        "animation"
	      ],
	      "lastStarCount": 2461,
	      "lastUpdatedAt": "2018-07-27T14:58:43Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/6692932?v=4"
	    },
	    {
	      "githubPath": "cameronbourke/react-cardstack",
	      "description": null,
	      "homepage": null,
	      "dependencies": [
	        "@babel/cli",
	        "@babel/core",
	        "@babel/plugin-proposal-object-rest-spread",
	        "@babel/preset-env",
	        "@babel/preset-react",
	        "babel-loader",
	        "prop-types",
	        "react",
	        "react-dom",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [],
	      "lastStarCount": 236,
	      "lastUpdatedAt": "2018-07-18T18:30:43Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/7464366?v=4"
	    },
	    {
	      "githubPath": "conorhastings/react-emoji-react",
	      "description": "a clone of slack emoji reactions in react",
	      "homepage": null,
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-loader",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-2",
	        "file-loader",
	        "get-emoji",
	        "json-loader",
	        "react",
	        "react-dom",
	        "url-loader",
	        "webpack"
	      ],
	      "tags": [],
	      "lastStarCount": 97,
	      "lastUpdatedAt": "2018-07-13T01:53:33Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/8263298?v=4"
	    },
	    {
	      "githubPath": "bokuweb/react-sortable-pane",
	      "description": ":sparkles: A sortable and resizable pane component for React.",
	      "homepage": "http://bokuweb.github.io/react-sortable-pane",
	      "dependencies": [
	        "@cypress/webpack-preprocessor",
	        "@storybook/addon-info",
	        "@storybook/addon-storysource",
	        "@storybook/react",
	        "@types/lodash",
	        "@types/lodash.debounce",
	        "@types/lodash.isequal",
	        "@types/react",
	        "@types/react-dom",
	        "@types/react-motion",
	        "@types/storybook__addon-actions",
	        "@types/storybook__react",
	        "babel-core",
	        "concurrently",
	        "cpx",
	        "cpy-cli",
	        "cypress",
	        "gh-pages",
	        "light-ts-loader",
	        "lodash.debounce",
	        "lodash.isequal",
	        "npm-run-all",
	        "prettier",
	        "re-resizable",
	        "react",
	        "react-dom",
	        "react-motion",
	        "resize-observer-polyfill",
	        "rollup",
	        "rollup-plugin-babel",
	        "rollup-plugin-commonjs",
	        "rollup-plugin-node-globals",
	        "rollup-plugin-node-resolve",
	        "rollup-plugin-replace",
	        "rollup-plugin-typescript2",
	        "ts-loader",
	        "tslib",
	        "typescript",
	        "wait-on"
	      ],
	      "tags": [],
	      "lastStarCount": 329,
	      "lastUpdatedAt": "2018-07-27T12:57:09Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/10220449?v=4"
	    },
	    {
	      "githubPath": "ccm-innovation/react-initicon",
	      "description": "Initial Icons for React",
	      "homepage": "https://ccm-innovation.github.io/react-initicon",
	      "dependencies": [
	        "babel-cli",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "browserify",
	        "concat-cli",
	        "uglify-js",
	        "uglifyjs"
	      ],
	      "tags": [
	        "icon"
	      ],
	      "lastStarCount": 25,
	      "lastUpdatedAt": "2018-04-03T09:06:22Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/17185076?v=4"
	    },
	    {
	      "githubPath": "nathanstitt/dayz",
	      "description": "A calendar component for React",
	      "homepage": null,
	      "dependencies": [
	        "babel-core",
	        "babel-eslint",
	        "babel-jest",
	        "babel-loader",
	        "babel-plugin-external-helpers",
	        "babel-plugin-transform-es2015-modules-umd",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "babel-runtime",
	        "babelrc-rollup",
	        "css-loader",
	        "enzyme",
	        "eslint",
	        "eslint-config-argosity",
	        "eslint-plugin-react",
	        "extract-text-webpack-plugin",
	        "file-loader",
	        "gulp",
	        "gulp-babel",
	        "gulp-exec",
	        "gulp-run",
	        "gulp-util",
	        "gulp-watch",
	        "html-webpack-plugin",
	        "jest",
	        "jest-cli",
	        "jest-webpack-alias",
	        "moment",
	        "moment-range",
	        "node-sass",
	        "npm-release",
	        "react",
	        "react-addons-test-utils",
	        "react-dom",
	        "react-test-renderer",
	        "rollup",
	        "rollup-plugin-babel",
	        "rollup-plugin-node-resolve",
	        "rollup-plugin-sass",
	        "sass-loader",
	        "scss",
	        "scss-loader",
	        "style-loader",
	        "through2",
	        "tiny-emitter",
	        "url-loader",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "calendar"
	      ],
	      "lastStarCount": 106,
	      "lastUpdatedAt": "2018-07-25T19:31:29Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/79566?v=4"
	    },
	    {
	      "githubPath": "davidkpiano/react-redux-form",
	      "description": "Create forms easily in React with Redux.",
	      "homepage": "https://davidkpiano.github.io/react-redux-form",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-lodash",
	        "babel-plugin-transform-react-remove-prop-types",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-2",
	        "babel-register",
	        "chai",
	        "chai-subset",
	        "css-loader",
	        "esdoc-es7-plugin",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "estraverse-fb",
	        "express",
	        "express-urlrewrite",
	        "icepick",
	        "immutable",
	        "invariant",
	        "jsdom",
	        "lodash",
	        "lodash.get",
	        "lodash.topath",
	        "mocha",
	        "prop-types",
	        "react",
	        "react-dom",
	        "react-native-segmented-control-tab",
	        "react-redux",
	        "redux",
	        "redux-immutable",
	        "redux-logger",
	        "redux-mock-store",
	        "redux-test-store",
	        "redux-thunk",
	        "shallow-compare",
	        "sinon",
	        "style-loader",
	        "webpack",
	        "webpack-bundle-size-analyzer",
	        "webpack-dev-middleware"
	      ],
	      "tags": [
	        "form"
	      ],
	      "lastStarCount": 1976,
	      "lastUpdatedAt": "2018-07-27T14:10:26Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/1093738?v=4"
	    },
	    {
	      "githubPath": "conorhastings/react-syntax-highlighter",
	      "description": "syntax highlighting component for react with prismjs or highlightjs ast using inline styles",
	      "homepage": "http://conor.rodeo/react-syntax-highlighter/demo/",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-loader",
	        "babel-plugin-transform-object-rest-spread",
	        "babel-plugin-transform-runtime",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-runtime",
	        "codecov",
	        "css",
	        "css-loader",
	        "highlight.js",
	        "jest",
	        "lowlight",
	        "prism-themes",
	        "prismjs",
	        "react",
	        "react-dom",
	        "react-syntax-highlighter-virtualized-renderer",
	        "react-test-renderer",
	        "refractor",
	        "style-loader",
	        "to-camel-case",
	        "webpack"
	      ],
	      "tags": [],
	      "lastStarCount": 676,
	      "lastUpdatedAt": "2018-07-27T21:08:16Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/8263298?v=4"
	    },
	    {
	      "githubPath": "abhijeetNmishra/react-password-strength-meter",
	      "description": "React Component to display password strength meter - Demo at : ",
	      "homepage": "http://abhijeetnmishra.github.io/react-password-strength-meter/",
	      "dependencies": [
	        "babel-core",
	        "babel-loader",
	        "babel-plugin-transform-runtime",
	        "babel-polyfill",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-runtime",
	        "css-loader",
	        "style-loader",
	        "webpack",
	        "webpack-dev-server",
	        "zxcvbn"
	      ],
	      "tags": [],
	      "lastStarCount": 48,
	      "lastUpdatedAt": "2018-04-18T03:09:48Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/3447996?v=4"
	    },
	    {
	      "githubPath": "mozilla-services/react-jsonschema-form",
	      "description": "A React component for building Web forms from JSON Schema.",
	      "homepage": "https://mozilla-services.github.io/react-jsonschema-form/",
	      "dependencies": [
	        "ajv",
	        "atob",
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-react-transform",
	        "babel-plugin-transform-class-properties",
	        "babel-plugin-transform-object-rest-spread",
	        "babel-plugin-transform-runtime",
	        "babel-preset-env",
	        "babel-preset-react",
	        "babel-register",
	        "babel-runtime",
	        "chai",
	        "codemirror",
	        "core-js",
	        "cross-env",
	        "css-loader",
	        "eslint",
	        "eslint-config-react-app",
	        "eslint-plugin-flowtype",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "estraverse",
	        "estraverse-fb",
	        "express",
	        "extract-text-webpack-plugin",
	        "gh-pages",
	        "html",
	        "husky",
	        "jsdom",
	        "json-loader",
	        "lint-staged",
	        "lodash.topath",
	        "mocha",
	        "prettier",
	        "prop-types",
	        "react",
	        "react-addons-test-utils",
	        "react-codemirror2",
	        "react-dom",
	        "react-transform-catch-errors",
	        "react-transform-hmr",
	        "redbox-react",
	        "rimraf",
	        "sinon",
	        "style-loader",
	        "toctoc",
	        "webpack",
	        "webpack-dev-middleware",
	        "webpack-hot-middleware"
	      ],
	      "tags": [
	        "set"
	      ],
	      "lastStarCount": 3776,
	      "lastUpdatedAt": "2018-07-27T19:46:00Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/1066228?v=4"
	    },
	    {
	      "githubPath": "dogfessional/react-swipeable",
	      "description": "React swipe component - Swipe bindings for react",
	      "homepage": "http://dogfessional.github.io/react-swipeable/",
	      "dependencies": [
	        "babel-cli",
	        "babel-plugin-transform-object-rest-spread",
	        "babel-preset-es2015-loose",
	        "babel-preset-react",
	        "detect-passive-events",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "gh-pages",
	        "jest",
	        "prop-types",
	        "react",
	        "react-dom",
	        "rimraf"
	      ],
	      "tags": [],
	      "lastStarCount": 648,
	      "lastUpdatedAt": "2018-07-26T08:34:36Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/9157134?v=4"
	    },
	    {
	      "githubPath": "bokuweb/react-rnd",
	      "description": "🖱  A resizable and draggable component for React.",
	      "homepage": "http://bokuweb.github.io/react-rnd/stories",
	      "dependencies": [
	        "@storybook/addon-actions",
	        "@storybook/addon-links",
	        "@storybook/react",
	        "@types/enzyme",
	        "@types/enzyme-adapter-react-16",
	        "@types/react",
	        "@types/react-dom",
	        "@types/sinon",
	        "@types/storybook__addon-actions",
	        "@types/storybook__react",
	        "avaron",
	        "cpy-cli",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "gh-pages",
	        "light-ts-loader",
	        "npm-run-all",
	        "prettier",
	        "re-resizable",
	        "react",
	        "react-dom",
	        "react-draggable",
	        "react-test-renderer",
	        "rollup",
	        "rollup-plugin-babel",
	        "rollup-plugin-commonjs",
	        "rollup-plugin-node-globals",
	        "rollup-plugin-node-resolve",
	        "rollup-plugin-replace",
	        "rollup-plugin-typescript2",
	        "rollup-watch",
	        "sinon",
	        "tslib",
	        "tslint",
	        "tslint-eslint-rules",
	        "tslint-plugin-prettier",
	        "tslint-react",
	        "typescript"
	      ],
	      "tags": [],
	      "lastStarCount": 645,
	      "lastUpdatedAt": "2018-07-27T07:21:12Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/10220449?v=4"
	    },
	    {
	      "githubPath": "burakcan/react-snowstorm",
	      "description": "A Snow Effect component for React.",
	      "homepage": "http://burakcan.github.io/react-snowstorm",
	      "dependencies": [
	        "babel",
	        "react",
	        "react-dom"
	      ],
	      "tags": [],
	      "lastStarCount": 163,
	      "lastUpdatedAt": "2018-06-12T21:26:53Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/3121257?v=4"
	    },
	    {
	      "githubPath": "clari/react-ios-switch",
	      "description": "React switch component https://clari.github.io/react-ios-switch",
	      "homepage": "",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-loader",
	        "babel-polyfill",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "color-name",
	        "history",
	        "inline-style-prefixer",
	        "popmotion",
	        "prop-types",
	        "react",
	        "react-dom",
	        "react-router",
	        "react-router-dom",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "button"
	      ],
	      "lastStarCount": 96,
	      "lastUpdatedAt": "2018-06-08T13:02:15Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/2006754?v=4"
	    },
	    {
	      "githubPath": "wangzuo/input-moment",
	      "description": "React datetime picker powered by momentjs",
	      "homepage": "https://wangzuo.github.io/input-moment",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-jest",
	        "babel-loader",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "classnames",
	        "css-loader",
	        "github-pages-deploy",
	        "jest",
	        "json-loader",
	        "less",
	        "less-loader",
	        "less-plugin-clean-css",
	        "lodash",
	        "moment",
	        "react",
	        "react-dom",
	        "react-input-slider",
	        "react-test-renderer",
	        "style-loader",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [],
	      "lastStarCount": 430,
	      "lastUpdatedAt": "2018-07-27T06:18:51Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/1039026?v=4"
	    },
	    {
	      "githubPath": "neptunian/react-photo-gallery",
	      "description": "React Photo Gallery",
	      "homepage": "http://neptunian.github.io/react-photo-gallery/",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-jest",
	        "babel-loader",
	        "babel-plugin-external-helpers",
	        "babel-plugin-transform-class-properties",
	        "babel-plugin-transform-react-remove-prop-types",
	        "babel-preset-env",
	        "babel-preset-react",
	        "coveralls",
	        "cross-env",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "enzyme-to-json",
	        "eslint",
	        "eslint-config-prettier",
	        "eslint-plugin-prettier",
	        "eslint-plugin-react",
	        "jest",
	        "jest-cli",
	        "jsonp",
	        "nps",
	        "nps-utils",
	        "prettier",
	        "prop-types",
	        "react",
	        "react-dom",
	        "react-images",
	        "react-measure",
	        "react-test-renderer",
	        "resize-observer-polyfill",
	        "rollup",
	        "rollup-plugin-babel",
	        "rollup-plugin-node-resolve",
	        "rollup-plugin-uglify",
	        "uglify-es",
	        "webpack",
	        "webpack-cli",
	        "webpack-dev-server"
	      ],
	      "tags": [],
	      "lastStarCount": 659,
	      "lastUpdatedAt": "2018-07-27T17:03:58Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/1676003?v=4"
	    },
	    {
	      "githubPath": "bokuweb-sandbox/react-motion-menu",
	      "description": "[DEPRECATED] 🍔 A spring animation menu component for React.",
	      "homepage": "http://bokuweb.github.io/react-motion-menu/",
	      "dependencies": [
	        "babel-cli",
	        "babel-eslint",
	        "babel-plugin-espower",
	        "babel-polyfill",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-2",
	        "babelify",
	        "browserify",
	        "enzyme",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "flow-bin",
	        "karma",
	        "karma-browserify",
	        "karma-cli",
	        "karma-mocha",
	        "karma-nightmare",
	        "mocha",
	        "power-assert",
	        "prop-types",
	        "react",
	        "react-addons-test-utils",
	        "react-dom",
	        "react-motion",
	        "react-test-renderer",
	        "sinon",
	        "watchify"
	      ],
	      "tags": [
	        "menu"
	      ],
	      "lastStarCount": 331,
	      "lastUpdatedAt": "2018-06-09T03:14:05Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/38875156?v=4"
	    },
	    {
	      "githubPath": "romainberger/react-portal-tooltip",
	      "description": "Awesome React tooltip",
	      "homepage": "http://romainberger.github.io/react-portal-tooltip/",
	      "dependencies": [
	        "babel",
	        "mocha",
	        "react",
	        "react-dom",
	        "react-test-renderer"
	      ],
	      "tags": [],
	      "lastStarCount": 295,
	      "lastUpdatedAt": "2018-07-24T08:46:42Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/1272948?v=4"
	    },
	    {
	      "githubPath": "alexkuz/react-input-enhancements",
	      "description": "Set of enhancements for input control",
	      "homepage": "http://alexkuz.github.io/react-input-enhancements/",
	      "dependencies": [
	        "babel-core",
	        "babel-loader",
	        "babel-preset-env",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "babel-runtime",
	        "css-loader",
	        "html-webpack-plugin",
	        "imports-loader",
	        "inline-style-prefixer",
	        "jest",
	        "lodash.sortby",
	        "moment",
	        "postcss-loader",
	        "pre-commit",
	        "prettier-eslint-cli",
	        "prop-types",
	        "raf",
	        "raw-loader",
	        "react",
	        "react-base16-styling",
	        "react-bootstrap",
	        "react-day-picker-themeable",
	        "react-dom",
	        "react-scripts",
	        "react-test-renderer",
	        "react-transform-hmr",
	        "style-loader",
	        "webpack",
	        "webpack-dev-server",
	        "webpack-simple-progress-plugin"
	      ],
	      "tags": [
	        "set"
	      ],
	      "lastStarCount": 1341,
	      "lastUpdatedAt": "2018-07-23T12:04:51Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/790659?v=4"
	    },
	    {
	      "githubPath": "alexkuz/cake-chart",
	      "description": "Interactive multi-layer pie chart",
	      "homepage": null,
	      "dependencies": [
	        "babel",
	        "babel-eslint",
	        "babel-runtime",
	        "classnames",
	        "eslint",
	        "eslint-loader",
	        "eslint-plugin-babel",
	        "eslint-plugin-react",
	        "jss",
	        "jss-vendor-prefixer",
	        "lodash.throttle",
	        "react-jss",
	        "react-pure-render"
	      ],
	      "tags": [
	        "dataviz"
	      ],
	      "lastStarCount": 387,
	      "lastUpdatedAt": "2018-07-25T08:52:31Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/790659?v=4"
	    },
	    {
	      "githubPath": "BelkaLab/react-yearly-calendar",
	      "description": "React.js Yearly Calendar Component",
	      "homepage": "",
	      "dependencies": [
	        "babel-cli",
	        "babel-preset-env",
	        "babel-preset-react",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "moment",
	        "prettier",
	        "prop-types",
	        "react",
	        "react-moment-proptypes"
	      ],
	      "tags": [
	        "calendar"
	      ],
	      "lastStarCount": 493,
	      "lastUpdatedAt": "2018-07-24T20:30:00Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/15244762?v=4"
	    },
	    {
	      "githubPath": "FormidableLabs/victory",
	      "description": "A collection of composable React components for building interactive data visualizations",
	      "homepage": "http://formidable.com/open-source/victory/",
	      "dependencies": [
	        "@babel/cli",
	        "@babel/core",
	        "@babel/plugin-proposal-class-properties",
	        "@babel/plugin-proposal-object-rest-spread",
	        "@babel/plugin-transform-arrow-functions",
	        "@babel/plugin-transform-block-scoping",
	        "@babel/plugin-transform-classes",
	        "@babel/plugin-transform-computed-properties",
	        "@babel/plugin-transform-destructuring",
	        "@babel/plugin-transform-modules-commonjs",
	        "@babel/plugin-transform-parameters",
	        "@babel/plugin-transform-shorthand-properties",
	        "@babel/plugin-transform-spread",
	        "@babel/plugin-transform-template-literals",
	        "@babel/preset-react",
	        "@storybook/addon-actions",
	        "@storybook/addon-options",
	        "@storybook/react",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-lodash",
	        "babel-plugin-module-resolver",
	        "babel-preset-react-native",
	        "chai",
	        "core-js",
	        "cross-env",
	        "d3-scale",
	        "d3-shape",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "eslint",
	        "eslint-config-formidable",
	        "eslint-plugin-filenames",
	        "eslint-plugin-import",
	        "eslint-plugin-mocha",
	        "eslint-plugin-react",
	        "glob",
	        "immutable",
	        "istanbul",
	        "istanbul-instrumenter-loader",
	        "json-loader",
	        "karma",
	        "karma-benchmark",
	        "karma-benchmarkjs-reporter",
	        "karma-chrome-launcher",
	        "karma-coverage-istanbul-reporter",
	        "karma-firefox-launcher",
	        "karma-ie-launcher",
	        "karma-mocha",
	        "karma-safari-launcher",
	        "karma-sauce-launcher",
	        "karma-spec-reporter",
	        "karma-webpack",
	        "lerna",
	        "lodash",
	        "lodash-webpack-plugin",
	        "mocha",
	        "nps",
	        "nps-utils",
	        "prop-types",
	        "react",
	        "react-chromatic",
	        "react-dom",
	        "react-hot-loader",
	        "rimraf",
	        "seedrandom",
	        "sinon",
	        "sinon-chai",
	        "webpack",
	        "webpack-dev-server",
	        "webpack-stats-plugin"
	      ],
	      "tags": [
	        "dataviz"
	      ],
	      "lastStarCount": 6225,
	      "lastUpdatedAt": "2018-07-27T18:16:57Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/5078602?v=4"
	    },
	    {
	      "githubPath": "jsdevkr/react-chatview",
	      "description": "Infinite scroll chat or feed component for React.js",
	      "homepage": "",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-add-module-exports",
	        "babel-plugin-transform-class-properties",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-loader",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "lodash.clone",
	        "react",
	        "react-dom",
	        "webpack"
	      ],
	      "tags": [
	        "chat"
	      ],
	      "lastStarCount": 190,
	      "lastUpdatedAt": "2018-06-27T21:45:53Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/26325746?v=4"
	    },
	    {
	      "githubPath": "arsich/react-redux-cats",
	      "description": "React and Redux with cats",
	      "homepage": "http://cats.arsich.ru/",
	      "dependencies": [
	        "autoprefixer",
	        "babel-core",
	        "babel-loader",
	        "babel-plugin-react-transform",
	        "chai",
	        "chai-immutable",
	        "clean-webpack-plugin",
	        "css-loader",
	        "es6-promise",
	        "history",
	        "html-webpack-plugin",
	        "immutable",
	        "isomorphic-fetch",
	        "material-ui",
	        "mocha",
	        "postcss-loader",
	        "react",
	        "react-addons-create-fragment",
	        "react-addons-pure-render-mixin",
	        "react-addons-transition-group",
	        "react-addons-update",
	        "react-dom",
	        "react-redux",
	        "react-router",
	        "react-tap-event-plugin",
	        "react-transform-hmr",
	        "redux",
	        "redux-router",
	        "redux-thunk",
	        "style-loader",
	        "webpack",
	        "webpack-dev-server",
	        "webpack-merge"
	      ],
	      "tags": [],
	      "lastStarCount": 24,
	      "lastUpdatedAt": "2018-04-05T12:20:04Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/8176860?v=4"
	    },
	    {
	      "githubPath": "nosovsh/fifteen",
	      "description": "Simple fifteen puzzle game build with react-native",
	      "homepage": null,
	      "dependencies": [
	        "babel-eslint",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-config-airbnb-es5",
	        "eslint-plugin-react",
	        "lodash",
	        "react-native"
	      ],
	      "tags": [
	        "game"
	      ],
	      "lastStarCount": 50,
	      "lastUpdatedAt": "2018-06-29T05:20:39Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/239423?v=4"
	    },
	    {
	      "githubPath": "intljusticemission/react-big-calendar",
	      "description": "gcal/outlook like calendar component",
	      "homepage": "http://intljusticemission.github.io/react-big-calendar/examples/index.html",
	      "dependencies": [
	        "@storybook/addon-actions",
	        "@storybook/react",
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-plugin-object-assign",
	        "babel-preset-jason",
	        "bootstrap",
	        "classnames",
	        "component-metadata-loader",
	        "cpy",
	        "date-arithmetic",
	        "dom-helpers",
	        "eslint",
	        "eslint-config-jason",
	        "eslint-config-prettier",
	        "eslint-import-resolver-webpack",
	        "eslint-plugin-import",
	        "eslint-plugin-react",
	        "font-awesome",
	        "globalize",
	        "husky",
	        "invariant",
	        "jest",
	        "less",
	        "less-loader",
	        "less-plugin-autoprefix",
	        "lint-staged",
	        "lodash",
	        "markdown-jsx-loader",
	        "marked",
	        "memoize-one",
	        "moment",
	        "mt-changelog",
	        "prettier",
	        "prop-types",
	        "react",
	        "react-bootstrap",
	        "react-docgen",
	        "react-dom",
	        "react-overlays",
	        "react-prop-types",
	        "release-script",
	        "rimraf",
	        "uncontrollable",
	        "warning",
	        "webpack",
	        "webpack-atoms",
	        "webpack-dev-server"
	      ],
	      "tags": [],
	      "lastStarCount": 2251,
	      "lastUpdatedAt": "2018-07-27T06:36:33Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/5813881?v=4"
	    },
	    {
	      "githubPath": "Swizec/space-invaders",
	      "description": "Space Invaders clone in React and d3.js",
	      "homepage": "http://swizec.github.io/space-invaders/",
	      "dependencies": [
	        "d3",
	        "flux",
	        "react",
	        "react-dom",
	        "react-scripts"
	      ],
	      "tags": [
	        "game"
	      ],
	      "lastStarCount": 26,
	      "lastUpdatedAt": "2018-05-07T23:04:27Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/56883?v=4"
	    },
	    {
	      "githubPath": "mderrick/react-html5video",
	      "description": "A customizeable HTML5 Video React component with i18n and a11y.",
	      "homepage": "http://mderrick.github.io/react-html5video/",
	      "dependencies": [
	        "babel",
	        "babel-core",
	        "babel-jest",
	        "babel-loader",
	        "babel-plugin-transform-object-rest-spread",
	        "babel-plugin-transform-runtime",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-runtime",
	        "case-sensitive-paths-webpack-plugin",
	        "chalk",
	        "copy-webpack-plugin",
	        "css-loader",
	        "detect-port",
	        "enzyme",
	        "eslint",
	        "eslint-plugin-react",
	        "express",
	        "extract-text-webpack-plugin",
	        "file-loader",
	        "gh-pages",
	        "html-webpack-plugin",
	        "identity-obj-proxy",
	        "jest",
	        "json-loader",
	        "open",
	        "postcss-loader",
	        "prop-types",
	        "react",
	        "react-dom",
	        "react-hot-loader",
	        "react-svg-loader",
	        "react-test-renderer",
	        "style-loader",
	        "url-loader",
	        "webpack",
	        "webpack-dev-middleware",
	        "webpack-hot-middleware"
	      ],
	      "tags": [],
	      "lastStarCount": 396,
	      "lastUpdatedAt": "2018-07-27T15:03:25Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/1044686?v=4"
	    },
	    {
	      "githubPath": "gorangajic/react-svg-morph",
	      "description": ":crystal_ball: morph your svg component one into another other",
	      "homepage": "http://gorangajic.github.io/react-svg-morph/",
	      "dependencies": [
	        "babel",
	        "babel-eslint",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-plugin-react",
	        "prop-types",
	        "react-render-to-json",
	        "svgpath",
	        "webpack"
	      ],
	      "tags": [
	        "set"
	      ],
	      "lastStarCount": 579,
	      "lastUpdatedAt": "2018-07-24T15:28:49Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/249310?v=4"
	    },
	    {
	      "githubPath": "storybooks/react-treebeard",
	      "description": "React Tree View Component. Data-Driven, Fast, Efficient and Customisable.",
	      "homepage": "http://alexcurtis.github.io/react-treebeard",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-transform-decorators-legacy",
	        "babel-plugin-transform-runtime",
	        "babel-preset-env",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "babel-runtime",
	        "chai",
	        "deep-equal",
	        "del",
	        "eslint",
	        "eslint-loader",
	        "eslint-plugin-react",
	        "gulp",
	        "gulp-babel",
	        "gulp-eslint",
	        "gulp-open",
	        "gulp-util",
	        "istanbul",
	        "istanbul-instrumenter-loader",
	        "karma",
	        "karma-babel-preprocessor",
	        "karma-chrome-launcher",
	        "karma-coverage",
	        "karma-firefox-launcher",
	        "karma-mocha",
	        "karma-sourcemap-loader",
	        "karma-spec-reporter",
	        "karma-webpack",
	        "mocha",
	        "node-libs-browser",
	        "prop-types",
	        "radium",
	        "react",
	        "react-dom",
	        "react-hot-loader",
	        "rimraf",
	        "shallowequal",
	        "sinon",
	        "sinon-chai",
	        "velocity-react",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [],
	      "lastStarCount": 996,
	      "lastUpdatedAt": "2018-07-26T08:07:33Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/22632046?v=4"
	    },
	    {
	      "githubPath": "furqanZafar/react-selectize",
	      "description": null,
	      "homepage": "http://furqanzafar.github.io/react-selectize/",
	      "dependencies": [
	        "async-ls",
	        "brace",
	        "brfs",
	        "browserify",
	        "browserify-shim",
	        "coveralls",
	        "gulp",
	        "gulp-connect",
	        "gulp-if",
	        "gulp-livescript",
	        "gulp-rename",
	        "gulp-streamify",
	        "gulp-stylus",
	        "gulp-uglify",
	        "gulp-util",
	        "istanbul",
	        "jquery-browserify",
	        "jsdom",
	        "liveify",
	        "livescript",
	        "mocha",
	        "mocha-lcov-reporter",
	        "nib",
	        "prelude-extension",
	        "prelude-ls",
	        "react",
	        "react-dom",
	        "react-dom-factories",
	        "react-router",
	        "react-tools",
	        "react-transition-group",
	        "run-sequence",
	        "should",
	        "tether",
	        "underscore",
	        "vinyl-source-stream",
	        "watchify"
	      ],
	      "tags": [
	        "set"
	      ],
	      "lastStarCount": 635,
	      "lastUpdatedAt": "2018-07-23T18:21:07Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/2241430?v=4"
	    },
	    {
	      "githubPath": "conorhastings/react-thermometer",
	      "description": "a simple thermometer gauge component (does not tell temperature)",
	      "homepage": null,
	      "dependencies": [
	        "babel",
	        "babel-core",
	        "babelify",
	        "browserify",
	        "react",
	        "react-addons-test-utils",
	        "react-dom"
	      ],
	      "tags": [],
	      "lastStarCount": 13,
	      "lastUpdatedAt": "2018-07-18T00:17:56Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/8263298?v=4"
	    },
	    {
	      "githubPath": "luqin/react-icheck",
	      "description": ":radio_button: iCheck components built with React. Highly customizable checkbox, radio buttons and radio group.",
	      "homepage": "https://luqin.github.io/react-icheck",
	      "dependencies": [
	        "babel",
	        "babel-core",
	        "babel-eslint",
	        "babel-plugin-object-assign",
	        "babel-runtime",
	        "bootstrap",
	        "classnames",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-config-onefe",
	        "eslint-plugin-react",
	        "gulp",
	        "icheck",
	        "prop-types",
	        "react",
	        "react-bootstrap",
	        "react-component-tools",
	        "react-dom",
	        "react-router",
	        "react-router-bootstrap",
	        "react-router-loader",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [],
	      "lastStarCount": 169,
	      "lastUpdatedAt": "2018-06-03T20:12:30Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/2267688?v=4"
	    },
	    {
	      "githubPath": "coderiety/react-list",
	      "description": ":scroll: A versatile infinite scroll React component.",
	      "homepage": "https://coderiety.github.io/react-list",
	      "dependencies": [
	        "babel-eslint",
	        "babel-plugin-transform-es2015-modules-umd",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "cogs",
	        "cogs-transformer-babel",
	        "cogs-transformer-concat-commonjs",
	        "cogs-transformer-eslint",
	        "cogs-transformer-replace",
	        "eslint",
	        "eslint-config-coderiety",
	        "eslint-plugin-react",
	        "prop-types",
	        "react",
	        "react-dom"
	      ],
	      "tags": [
	        "list"
	      ],
	      "lastStarCount": 1447,
	      "lastUpdatedAt": "2018-07-26T09:27:42Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/3303155?v=4"
	    },
	    {
	      "githubPath": "socialtables/react-user-tour",
	      "description": "give your user a guided tour around your application",
	      "homepage": null,
	      "dependencies": [
	        "babel",
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-plugin-transform-object-rest-spread",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babelify",
	        "browserify",
	        "eslint",
	        "eslint-plugin-react",
	        "react",
	        "react-addons-test-utils",
	        "react-dom",
	        "react-motion",
	        "scroll-to",
	        "sinon",
	        "smokestack",
	        "tap-closer",
	        "tap-status",
	        "tape",
	        "tape-catch"
	      ],
	      "tags": [],
	      "lastStarCount": 129,
	      "lastUpdatedAt": "2018-07-24T01:03:46Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/1447804?v=4"
	    },
	    {
	      "githubPath": "tomkp/react-split-pane",
	      "description": "React split-pane component",
	      "homepage": "http://react-split-pane.surge.sh/",
	      "dependencies": [
	        "@types/inline-style-prefixer",
	        "@types/react",
	        "babel-cli",
	        "babel-eslint",
	        "babel-plugin-external-helpers",
	        "babel-preset-env",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "babelify",
	        "chai",
	        "chai-spies",
	        "coveralls",
	        "cross-env",
	        "eslint",
	        "eslint-config-fbjs",
	        "eslint-config-prettier",
	        "eslint-config-react",
	        "eslint-plugin-babel",
	        "eslint-plugin-flowtype",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-prettier",
	        "eslint-plugin-react",
	        "eslint-plugin-relay",
	        "husky",
	        "inline-style-prefixer",
	        "lint-staged",
	        "mochify",
	        "mochify-istanbul",
	        "prettier",
	        "prop-types",
	        "react",
	        "react-dom",
	        "react-lifecycles-compat",
	        "react-style-proptype",
	        "rimraf",
	        "rollup",
	        "rollup-plugin-babel",
	        "rollup-plugin-commonjs",
	        "rollup-plugin-node-resolve",
	        "surge"
	      ],
	      "tags": [],
	      "lastStarCount": 1120,
	      "lastUpdatedAt": "2018-07-27T08:11:05Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/171331?v=4"
	    },
	    {
	      "githubPath": "nkbt/react-collapse",
	      "description": "Component-wrapper for collapse animation with react-motion for elements with variable (and dynamic) height",
	      "homepage": null,
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-transform-class-properties",
	        "babel-plugin-transform-object-rest-spread",
	        "babel-plugin-transform-react-remove-prop-types",
	        "babel-preset-env",
	        "babel-preset-react",
	        "babel-register",
	        "css-loader",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "finalhandler",
	        "gh-pages",
	        "glob",
	        "html-webpack-include-assets-plugin",
	        "html-webpack-plugin",
	        "mini-css-extract-plugin",
	        "nightwatch",
	        "portfinder",
	        "prop-types",
	        "react",
	        "react-dom",
	        "rimraf",
	        "serve-static",
	        "style-loader",
	        "tape",
	        "webpack",
	        "webpack-cli",
	        "webpack-dev-server"
	      ],
	      "tags": [],
	      "lastStarCount": 702,
	      "lastUpdatedAt": "2018-07-25T06:59:51Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/175264?v=4"
	    },
	    {
	      "githubPath": "jstejada/react-typist",
	      "description": "Typing animations with React",
	      "homepage": "https://jstejada.github.io/react-typist/",
	      "dependencies": [
	        "autoprefixer",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-transform-class-properties",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "css-loader",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-loader",
	        "eslint-plugin-react",
	        "eslint_d",
	        "extract-text-webpack-plugin",
	        "jasmine-core",
	        "jasmine-react-matchers",
	        "karma",
	        "karma-chrome-launcher",
	        "karma-cli",
	        "karma-jasmine",
	        "karma-sourcemap-loader",
	        "karma-webpack",
	        "mock-promises",
	        "node-sass",
	        "postcss-loader",
	        "promise-mock",
	        "prop-types",
	        "react",
	        "react-dom",
	        "sass-loader",
	        "style-loader",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [],
	      "lastStarCount": 558,
	      "lastUpdatedAt": "2018-07-26T13:59:28Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/1271509?v=4"
	    },
	    {
	      "githubPath": "google-fabric/velocity-react",
	      "description": "React components for Velocity.js",
	      "homepage": "",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-transform-class-properties",
	        "babel-plugin-transform-object-rest-spread",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "create-react-class",
	        "css-loader",
	        "eslint",
	        "eslint-config-prettier",
	        "eslint-plugin-import",
	        "eslint-plugin-prettier",
	        "eslint-plugin-react",
	        "husky",
	        "lint-staged",
	        "lodash",
	        "prettier",
	        "prop-types",
	        "react",
	        "react-dom",
	        "react-transition-group",
	        "style-loader",
	        "twemoji",
	        "underscore.string",
	        "velocity-animate",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "animation"
	      ],
	      "lastStarCount": 2813,
	      "lastUpdatedAt": "2018-07-27T12:20:19Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/14279844?v=4"
	    },
	    {
	      "githubPath": "James-Oldfield/react-rpg",
	      "description": ":camera: Responsive photo grid component for react js",
	      "homepage": "",
	      "dependencies": [
	        "babel",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "chai",
	        "concurrently",
	        "css-loader",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-config-defaults",
	        "eslint-plugin-filenames",
	        "eslint-plugin-react",
	        "expect",
	        "file-loader",
	        "isparta-loader",
	        "karma",
	        "karma-chrome-launcher",
	        "karma-coverage",
	        "karma-firefox-launcher",
	        "karma-ie-launcher",
	        "karma-mocha",
	        "karma-phantomjs-launcher",
	        "karma-phantomjs-shim",
	        "karma-safari-launcher",
	        "karma-sauce-launcher",
	        "karma-spec-reporter",
	        "karma-webpack",
	        "lodash",
	        "mocha",
	        "opener",
	        "phantomjs",
	        "react",
	        "react-addons-test-utils",
	        "react-dom",
	        "react-hot-loader",
	        "rimraf",
	        "sinon",
	        "sinon-chai",
	        "style-loader",
	        "url-loader",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [],
	      "lastStarCount": 45,
	      "lastUpdatedAt": "2018-06-23T18:01:41Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/7990316?v=4"
	    },
	    {
	      "githubPath": "react-icons/react-icons",
	      "description": "svg react icons of popular icon packs",
	      "homepage": "http://react-icons.github.io/react-icons/",
	      "dependencies": [
	        "babel",
	        "babel-cli",
	        "babel-eslint",
	        "babel-plugin-add-module-exports",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "camelcase",
	        "capitalize",
	        "cheerio",
	        "classnames",
	        "commitizen",
	        "cz-conventional-changelog",
	        "decamelize",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-plugin-react",
	        "ghooks",
	        "glob",
	        "gulp",
	        "marky-markdown",
	        "material-design-lite",
	        "react-icon-base",
	        "svg-scaler",
	        "underscore",
	        "validate-commit-msg"
	      ],
	      "tags": [
	        "set"
	      ],
	      "lastStarCount": 1906,
	      "lastUpdatedAt": "2018-07-26T23:46:15Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/39895671?v=4"
	    },
	    {
	      "githubPath": "tgecho/react-prosemirror",
	      "description": "An unofficial React component for ProseMirror",
	      "homepage": "https://tgecho.github.io/react-prosemirror",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-polyfill",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-2",
	        "eslint",
	        "eslint-plugin-react",
	        "jasmine-core",
	        "json-loader",
	        "karma",
	        "karma-jasmine",
	        "karma-phantomjs-launcher",
	        "karma-webpack",
	        "phantomjs-prebuilt",
	        "react",
	        "react-addons-test-utils",
	        "react-dom",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "text editor"
	      ],
	      "lastStarCount": 103,
	      "lastUpdatedAt": "2018-07-04T14:55:26Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/49615?v=4"
	    },
	    {
	      "githubPath": "formly-js/react-formly",
	      "description": "JSON powered forms for react",
	      "homepage": "http://formly-js.github.io/react-formly",
	      "dependencies": [
	        "chai",
	        "connect",
	        "gulp",
	        "gulp-gh-pages",
	        "gulp-help",
	        "gulp-jshint",
	        "gulp-react",
	        "gulp-webpack",
	        "jshint-stylish",
	        "jsx-loader",
	        "karma",
	        "karma-chai",
	        "karma-chrome-launcher",
	        "karma-cli",
	        "karma-firefox-launcher",
	        "karma-mocha",
	        "livereload",
	        "mocha",
	        "react",
	        "react-addons",
	        "rimraf",
	        "serve-static",
	        "webpack",
	        "with-package",
	        "yargs"
	      ],
	      "tags": [
	        "form"
	      ],
	      "lastStarCount": 98,
	      "lastUpdatedAt": "2018-06-11T09:24:56Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/8561755?v=4"
	    },
	    {
	      "githubPath": "jossmac/react-images",
	      "description": "🌄 A lightbox component for displaying images",
	      "homepage": "http://jossmac.github.io/react-images",
	      "dependencies": [
	        "aphrodite",
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-external-helpers",
	        "babel-plugin-transform-object-assign",
	        "babel-plugin-transform-object-rest-spread",
	        "babel-plugin-transform-react-remove-prop-types",
	        "babel-preset-env",
	        "babel-preset-react",
	        "css-loader",
	        "eslint",
	        "eslint-config-keystone",
	        "eslint-plugin-react",
	        "extract-text-webpack-plugin",
	        "html-loader",
	        "html-webpack-plugin",
	        "less",
	        "less-loader",
	        "nps",
	        "nps-utils",
	        "prop-types",
	        "react",
	        "react-dom",
	        "react-scrolllock",
	        "react-transition-group",
	        "rollup",
	        "rollup-plugin-babel",
	        "rollup-plugin-commonjs",
	        "rollup-plugin-node-resolve",
	        "rollup-plugin-uglify",
	        "style-loader",
	        "uglify-es",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "grid"
	      ],
	      "lastStarCount": 1113,
	      "lastUpdatedAt": "2018-07-26T14:17:31Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/2730833?v=4"
	    },
	    {
	      "githubPath": "sanniassin/react-input-mask",
	      "description": "Input masking component for React. Made with attention to UX.",
	      "homepage": "",
	      "dependencies": [
	        "@babel/cli",
	        "@babel/core",
	        "@babel/plugin-transform-modules-commonjs",
	        "@babel/plugin-transform-proto-to-assign",
	        "@babel/polyfill",
	        "@babel/preset-env",
	        "@babel/preset-react",
	        "@babel/preset-stage-3",
	        "@babel/register",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-dev-expression",
	        "babel-plugin-minify-dead-code-elimination",
	        "chai",
	        "console-polyfill",
	        "cross-env",
	        "es3ify-loader",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "html-webpack-plugin",
	        "invariant",
	        "karma",
	        "karma-browserstack-launcher",
	        "karma-chrome-launcher",
	        "karma-mocha",
	        "karma-webpack",
	        "mocha",
	        "puppeteer",
	        "react",
	        "react-dom",
	        "rollup",
	        "rollup-plugin-babel",
	        "rollup-plugin-commonjs",
	        "rollup-plugin-node-resolve",
	        "rollup-plugin-replace",
	        "rollup-plugin-size-snapshot",
	        "rollup-plugin-uglify",
	        "warning",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "input"
	      ],
	      "lastStarCount": 706,
	      "lastUpdatedAt": "2018-07-26T23:56:01Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/2291616?v=4"
	    },
	    {
	      "githubPath": "saulhoward/react-evil-icons",
	      "description": "Evil icons as react components",
	      "homepage": null,
	      "dependencies": [
	        "babel",
	        "create-react-class",
	        "evil-icons",
	        "gulp",
	        "gulp-inject-string",
	        "jest-cli",
	        "onchange",
	        "prop-types",
	        "react",
	        "react-dom"
	      ],
	      "tags": [
	        "icon"
	      ],
	      "lastStarCount": 72,
	      "lastUpdatedAt": "2018-07-03T06:27:32Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/354048?v=4"
	    },
	    {
	      "githubPath": "IBM-Cloud/election-insights",
	      "description": "Sentiment analysis and visualization on all things election",
	      "homepage": "http://electioninsights.mybluemix.net/",
	      "dependencies": [
	        "alchemyapi_node",
	        "autoprefixer",
	        "babel",
	        "babel-core",
	        "babel-loader",
	        "babel-plugin-react-transform",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "better-npm-run",
	        "bluebird",
	        "body-parser",
	        "cfenv",
	        "classnames",
	        "css-loader",
	        "d3",
	        "express",
	        "flux",
	        "keymirror",
	        "less",
	        "less-loader",
	        "lodash",
	        "moment",
	        "mongoose",
	        "morgan",
	        "object-assign",
	        "postcss-cli",
	        "postcss-loader",
	        "raw-loader",
	        "react",
	        "react-bubble-chart",
	        "react-dom",
	        "react-hot-loader",
	        "react-transform-catch-errors",
	        "react-transform-hmr",
	        "redbox-react",
	        "style-loader",
	        "superagent",
	        "webpack",
	        "webpack-dev-middleware",
	        "webpack-hot-middleware"
	      ],
	      "tags": [],
	      "lastStarCount": 60,
	      "lastUpdatedAt": "2018-04-22T14:52:18Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/7284885?v=4"
	    },
	    {
	      "githubPath": "alanrsoares/redux-game-of-life",
	      "description": "An educational implementation of Conway's Game of Life using React and Redux",
	      "homepage": "http://alanrsoares.github.io/redux-game-of-life/",
	      "dependencies": [
	        "babel-core",
	        "babel-loader",
	        "babel-plugin-ramda",
	        "babel-preset-env",
	        "babel-preset-react",
	        "babel-preset-react-hmre",
	        "babel-preset-stage-2",
	        "classnames",
	        "cross-env",
	        "express",
	        "prop-types",
	        "ramda",
	        "react",
	        "react-dom",
	        "react-redux",
	        "redux",
	        "redux-actions",
	        "rimraf",
	        "webpack",
	        "webpack-dev-middleware",
	        "webpack-hot-middleware"
	      ],
	      "tags": [
	        "game"
	      ],
	      "lastStarCount": 57,
	      "lastUpdatedAt": "2018-07-22T16:50:59Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/273334?v=4"
	    },
	    {
	      "githubPath": "andyyou/react-coverflow",
	      "description": "A Coverflow effect component of React version made for the web.",
	      "homepage": "http://andyyou.github.io/react-coverflow/",
	      "dependencies": [
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-transform-class-properties",
	        "babel-plugin-transform-decorators-legacy",
	        "babel-plugin-transform-runtime",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "babel-runtime",
	        "chai",
	        "css-loader",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-loader",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "extract-text-webpack-plugin",
	        "file-loader",
	        "glob",
	        "mocha",
	        "node-sass",
	        "open-browser-webpack-plugin",
	        "postcss-load-config",
	        "postcss-loader",
	        "precss",
	        "prop-types",
	        "radium",
	        "react",
	        "react-dom",
	        "react-hot-loader",
	        "react-tap-event-plugin",
	        "sass-loader",
	        "style-loader",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [],
	      "lastStarCount": 191,
	      "lastUpdatedAt": "2018-07-23T12:52:32Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/665690?v=4"
	    },
	    {
	      "githubPath": "peterKaleta/react-token-autocomplete",
	      "description": null,
	      "homepage": null,
	      "dependencies": [
	        "babel",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-rewire",
	        "babel-runtime",
	        "chai",
	        "codecov.io",
	        "component-playground",
	        "css-loader",
	        "cz-conventional-changelog",
	        "eslint",
	        "eslint-plugin-react",
	        "exports-loader",
	        "html-webpack-plugin",
	        "image-webpack-loader",
	        "immutable",
	        "inert",
	        "isparta",
	        "isparta-loader",
	        "karma",
	        "karma-chai",
	        "karma-chrome-launcher",
	        "karma-cli",
	        "karma-coverage",
	        "karma-firefox-launcher",
	        "karma-mocha",
	        "karma-mocha-reporter",
	        "karma-phantomjs2-launcher",
	        "karma-sinon",
	        "karma-sourcemap-loader",
	        "karma-webpack",
	        "l",
	        "lodash",
	        "mocha",
	        "mocha-babel",
	        "path",
	        "peters-toolbelt",
	        "radium",
	        "raw-loader",
	        "react",
	        "react-hot-loader",
	        "rewire",
	        "rewire-webpack",
	        "sass",
	        "sass-loader",
	        "script-loader",
	        "sinon",
	        "sinon-chai",
	        "style-loader",
	        "underscore.string",
	        "url-loader",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "autocomplete"
	      ],
	      "lastStarCount": 95,
	      "lastUpdatedAt": "2018-06-20T02:29:48Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/2013380?v=4"
	    },
	    {
	      "githubPath": "whoisandy/react-rangeslider",
	      "description": "A lightweight responsive react range slider component.A fast & lightweight react component as a drop in replacement for HTML5 input range slider element.",
	      "homepage": "https://whoisandy.github.io/react-rangeslider/",
	      "dependencies": [
	        "babel",
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-jest",
	        "babel-loader",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "babel-register",
	        "classnames",
	        "cpy-cli",
	        "cross-env",
	        "css-loader",
	        "del-cli",
	        "enzyme",
	        "eslint",
	        "eslint-config-standard",
	        "eslint-config-standard-jsx",
	        "eslint-config-standard-react",
	        "eslint-loader",
	        "eslint-plugin-import",
	        "eslint-plugin-prettier",
	        "eslint-plugin-promise",
	        "eslint-plugin-react",
	        "eslint-plugin-standard",
	        "express",
	        "extract-text-webpack-plugin",
	        "file-loader",
	        "gh-pages",
	        "highlight.js",
	        "html-webpack-plugin",
	        "jest",
	        "less",
	        "less-loader",
	        "less-plugin-clean-css",
	        "marked",
	        "opn-cli",
	        "prop-types",
	        "raw-loader",
	        "react",
	        "react-addons-test-utils",
	        "react-dom",
	        "react-ga",
	        "react-github-button",
	        "react-test-renderer",
	        "resize-observer-polyfill",
	        "style-loader",
	        "url-loader",
	        "webpack",
	        "webpack-dev-middleware",
	        "webpack-hot-middleware"
	      ],
	      "tags": [
	        "slider"
	      ],
	      "lastStarCount": 408,
	      "lastUpdatedAt": "2018-07-27T02:44:02Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/297132?v=4"
	    },
	    {
	      "githubPath": "andrepolischuk/react-rotation",
	      "description": "React rotation component",
	      "homepage": "http://andrepolischuk.github.io/react-rotation",
	      "dependencies": [
	        "ava",
	        "babel-cli",
	        "babel-eslint",
	        "babel-plugin-transform-class-properties",
	        "babel-plugin-transform-object-rest-spread",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-register",
	        "enzyme",
	        "prop-types",
	        "react",
	        "react-addons-test-utils",
	        "react-dom",
	        "rimraf",
	        "standard"
	      ],
	      "tags": [],
	      "lastStarCount": 74,
	      "lastUpdatedAt": "2018-07-04T14:46:52Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/8956796?v=4"
	    },
	    {
	      "githubPath": "daviferreira/react-sanfona",
	      "description": "Accessible react accordion component",
	      "homepage": "https://daviferreira.github.io/react-sanfona",
	      "dependencies": [
	        "autoprefixer",
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-transform-react-remove-prop-types",
	        "babel-preset-env",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "classnames",
	        "css-loader",
	        "eslint",
	        "eslint-config-prettier",
	        "eslint-config-standard",
	        "eslint-config-standard-react",
	        "eslint-plugin-import",
	        "eslint-plugin-node",
	        "eslint-plugin-promise",
	        "eslint-plugin-react",
	        "eslint-plugin-standard",
	        "gh-pages",
	        "mocha",
	        "normalize.css",
	        "postcss-loader",
	        "prop-types",
	        "react",
	        "react-addons-test-utils",
	        "react-dom",
	        "react-test-renderer",
	        "skin-deep",
	        "style-loader",
	        "unexpected",
	        "uuid",
	        "webpack",
	        "webpack-cli",
	        "webpack-dev-server"
	      ],
	      "tags": [],
	      "lastStarCount": 207,
	      "lastUpdatedAt": "2018-07-26T23:56:51Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/38787?v=4"
	    },
	    {
	      "githubPath": "casesandberg/react-color",
	      "description": ":art: Color Pickers from Sketch, Photoshop, Chrome, Github, Twitter & more",
	      "homepage": "http://casesandberg.github.io/react-color/",
	      "dependencies": [
	        "@case/eslint-config",
	        "@icons/material",
	        "@storybook/addon-centered",
	        "@storybook/addon-knobs",
	        "@storybook/addon-options",
	        "@storybook/react",
	        "babel-cli",
	        "babel-core",
	        "babel-jest",
	        "babel-loader",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "babel-register",
	        "chai",
	        "chai-spies",
	        "css-loader",
	        "enzyme",
	        "event-stream",
	        "fbjs",
	        "highlight.js",
	        "html-loader",
	        "html-webpack-plugin",
	        "i",
	        "jest",
	        "jest-cli",
	        "jsx-loader",
	        "lodash",
	        "material-colors",
	        "mocha",
	        "normalize.css",
	        "npm",
	        "object-assign",
	        "prop-types",
	        "react",
	        "react-addons-test-utils",
	        "react-context",
	        "react-dom",
	        "react-hot-loader",
	        "react-mark",
	        "react-test-renderer",
	        "reactcss",
	        "remarkable",
	        "require-dir",
	        "rimraf",
	        "style-loader",
	        "testdom",
	        "tinycolor2",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "set",
	        "color",
	        "picker"
	      ],
	      "lastStarCount": 5378,
	      "lastUpdatedAt": "2018-07-27T20:02:06Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/4633636?v=4"
	    },
	    {
	      "githubPath": "jquense/react-formal",
	      "description": "Sophisticated HTML form management for React",
	      "homepage": "http://jquense.github.io/react-formal",
	      "dependencies": [
	        "@babel/cli",
	        "@babel/core",
	        "@monastic.panic/component-playground",
	        "@monastic.panic/enzyme-adapter-react-16",
	        "babel-core",
	        "babel-eslint",
	        "babel-jest",
	        "babel-preset-jason",
	        "chai",
	        "chai-as-promised",
	        "chain-function",
	        "classnames",
	        "component-metadata-loader",
	        "dirty-chai",
	        "enzyme",
	        "eslint",
	        "eslint-config-jason",
	        "eslint-import-resolver-webpack",
	        "eslint-plugin-import",
	        "eslint-plugin-react",
	        "globalize",
	        "handlebars",
	        "history",
	        "invariant",
	        "jest",
	        "lodash",
	        "markdown-jsx-loader",
	        "marked",
	        "prismjs",
	        "prop-types",
	        "property-expr",
	        "react",
	        "react-bootstrap",
	        "react-component-metadata",
	        "react-dom",
	        "react-formal",
	        "react-lifecycles-compat",
	        "react-router",
	        "react-router-dom",
	        "release-script",
	        "rimraf",
	        "sinon",
	        "sinon-chai",
	        "topeka",
	        "uncontrollable",
	        "warning",
	        "webpack",
	        "webpack-atoms",
	        "webpack-dev-server",
	        "yup"
	      ],
	      "tags": [
	        "set",
	        "form"
	      ],
	      "lastStarCount": 408,
	      "lastUpdatedAt": "2018-07-12T04:10:10Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/339286?v=4"
	    },
	    {
	      "githubPath": "KyleAMathews/react-spinkit",
	      "description": "A collection of loading indicators animated with CSS for React",
	      "homepage": "http://kyleamathews.github.io/react-spinkit/",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "chai",
	        "classnames",
	        "css-loader",
	        "cssify",
	        "enzyme",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "ignore-styles",
	        "loaders.css",
	        "mkdirp",
	        "mocha",
	        "object-assign",
	        "prop-types",
	        "react",
	        "react-addons-test-utils",
	        "react-dom",
	        "style-loader",
	        "webpack"
	      ],
	      "tags": [
	        "spinner"
	      ],
	      "lastStarCount": 1028,
	      "lastUpdatedAt": "2018-07-27T19:12:58Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/71047?v=4"
	    },
	    {
	      "githubPath": "gre/gl-react",
	      "description": "gl-react – React library to write and compose WebGL shaders",
	      "homepage": "https://gl-react-cookbook.surge.sh",
	      "dependencies": [
	        "babel-cli",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-1",
	        "browserify",
	        "browserify-shim",
	        "documentation",
	        "flow-copy-source",
	        "lerna",
	        "prettier"
	      ],
	      "tags": [
	        "3d"
	      ],
	      "lastStarCount": 1580,
	      "lastUpdatedAt": "2018-07-27T17:59:18Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/211411?v=4"
	    },
	    {
	      "githubPath": "andrewhathaway/Winterfell",
	      "description": "Generate complex, validated and extendable JSON-based forms in React.",
	      "homepage": "http://winterfell.andrewhathaway.net",
	      "dependencies": [
	        "babel",
	        "babel-core",
	        "babel-loader",
	        "babelify",
	        "browserify",
	        "gulp",
	        "gulp-uglify",
	        "keycodez",
	        "lodash",
	        "rimraf",
	        "validator",
	        "vinyl-buffer",
	        "vinyl-source-stream",
	        "webpack"
	      ],
	      "tags": [
	        "form"
	      ],
	      "lastStarCount": 684,
	      "lastUpdatedAt": "2018-07-22T11:47:26Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/1188830?v=4"
	    },
	    {
	      "githubPath": "gilbarbara/react-joyride",
	      "description": "Create walkthroughs and guided tours for your app",
	      "homepage": "https://2zpjporp4p.codesandbox.io/",
	      "dependencies": [
	        "babel-core",
	        "babel-eslint",
	        "babel-jest",
	        "babel-plugin-array-includes",
	        "babel-plugin-external-helpers",
	        "babel-plugin-transform-flow-strip-types",
	        "babel-plugin-transform-node-env-inline",
	        "babel-plugin-transform-react-remove-prop-types",
	        "babel-plugin-transform-runtime",
	        "babel-preset-env",
	        "babel-preset-react",
	        "babel-preset-stage-1",
	        "chalk",
	        "cross-env",
	        "date-fns",
	        "deep-diff",
	        "deepmerge",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-plugin-babel",
	        "eslint-plugin-flowtype",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "exenv",
	        "flow-bin",
	        "husky",
	        "is-lite",
	        "jest",
	        "jest-chain",
	        "jest-environment-jsdom-global",
	        "jest-enzyme",
	        "jest-extended",
	        "jest-watch-typeahead",
	        "nested-property",
	        "prop-types",
	        "react",
	        "react-dom",
	        "react-floater",
	        "react-proptype-conditional-require",
	        "rimraf",
	        "rollup",
	        "rollup-plugin-babel",
	        "rollup-plugin-commonjs",
	        "rollup-plugin-node-resolve",
	        "scroll",
	        "scroll-doc",
	        "scrollparent",
	        "tree-changes"
	      ],
	      "tags": [],
	      "lastStarCount": 1933,
	      "lastUpdatedAt": "2018-07-27T11:20:28Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/31954?v=4"
	    },
	    {
	      "githubPath": "nkbt/react-copy-to-clipboard",
	      "description": "Copy-to-clipboard React component",
	      "homepage": null,
	      "dependencies": [
	        "babel-cli",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-transform-class-properties",
	        "babel-plugin-transform-object-rest-spread",
	        "babel-plugin-transform-react-remove-prop-types",
	        "babel-preset-env",
	        "babel-preset-react",
	        "babel-register",
	        "babili-webpack-plugin",
	        "copy-to-clipboard",
	        "css-loader",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-plugin-babel",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "extract-text-webpack-plugin",
	        "finalhandler",
	        "gh-pages",
	        "glob",
	        "html-webpack-include-assets-plugin",
	        "html-webpack-plugin",
	        "nightwatch",
	        "portfinder",
	        "prop-types",
	        "react",
	        "react-dom",
	        "rimraf",
	        "serve-static",
	        "style-loader",
	        "tape",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [],
	      "lastStarCount": 732,
	      "lastUpdatedAt": "2018-07-27T17:41:18Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/175264?v=4"
	    },
	    {
	      "githubPath": "plouc/react-svg-buttons",
	      "description": "React configurable animated svg buttons",
	      "homepage": "http://plouc.github.io/react-svg-buttons/",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-2",
	        "prettier",
	        "prop-types",
	        "react",
	        "react-motion"
	      ],
	      "tags": [
	        "button"
	      ],
	      "lastStarCount": 157,
	      "lastUpdatedAt": "2018-07-21T13:30:31Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/501642?v=4"
	    },
	    {
	      "githubPath": "borisyankov/react-sparklines",
	      "description": "Beautiful and expressive Sparklines React component",
	      "homepage": null,
	      "dependencies": [
	        "babel",
	        "babel-core",
	        "babel-loader",
	        "babel-plugin-transform-object-assign",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-1",
	        "babel-runtime",
	        "chai",
	        "enzyme",
	        "hiff",
	        "line-by-line",
	        "mocha",
	        "prop-types",
	        "react",
	        "react-addons-test-utils",
	        "react-dom",
	        "react-element-to-jsx-string",
	        "replaceall",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [],
	      "lastStarCount": 1959,
	      "lastUpdatedAt": "2018-07-25T07:08:34Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/867242?v=4"
	    },
	    {
	      "githubPath": "nikgraf/belle",
	      "description": "Configurable React Components with great UX",
	      "homepage": "http://nikgraf.github.io/belle/",
	      "dependencies": [
	        "alex",
	        "babel",
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-jest",
	        "babel-loader",
	        "babel-plugin-react-transform",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-react-hmre",
	        "babel-preset-stage-0",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-plugin-react",
	        "exenv",
	        "jest-cli",
	        "prop-types",
	        "react",
	        "react-dom",
	        "react-test-renderer",
	        "react-transform-catch-errors",
	        "react-transform-hmr",
	        "redbox-react",
	        "webpack",
	        "webpack-dev-middleware",
	        "webpack-hot-middleware"
	      ],
	      "tags": [
	        "toolkit"
	      ],
	      "lastStarCount": 2245,
	      "lastUpdatedAt": "2018-07-27T21:22:26Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/223045?v=4"
	    },
	    {
	      "githubPath": "adazzle/react-data-grid",
	      "description": "Excel-like grid component built with React, with editors, keyboard navigation, copy & paste, and the like http://adazzle.github.io/react-data-grid/  ",
	      "homepage": null,
	      "dependencies": [
	        "avcoveralls",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-transform-class-properties",
	        "babel-plugin-transform-es3-member-expression-literals",
	        "babel-plugin-transform-es3-property-literals",
	        "babel-plugin-transform-react-jsx",
	        "babel-plugin-typecheck",
	        "babel-preset-es2015",
	        "babel-preset-es2015-loose",
	        "babel-preset-react",
	        "classnames",
	        "copy-dir",
	        "css-loader",
	        "del",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "es5-shim",
	        "eslint",
	        "eslint-loader",
	        "eslint-plugin-react",
	        "faker",
	        "fs-extra",
	        "gh-pages",
	        "gulp",
	        "gulp-concat",
	        "gulp-util",
	        "immutable",
	        "istanbul-instrumenter-loader",
	        "jasmine-core",
	        "jasmine-enzyme",
	        "karma",
	        "karma-chrome-launcher",
	        "karma-coverage",
	        "karma-firefox-launcher",
	        "karma-ie-launcher",
	        "karma-jasmine",
	        "karma-jasmine-matchers",
	        "karma-junit-reporter",
	        "karma-mocha-reporter",
	        "karma-phantomjs-launcher",
	        "karma-phantomjs-launcher-nonet",
	        "karma-sourcemap-loader",
	        "karma-webpack",
	        "keymirror",
	        "lerna",
	        "minimist",
	        "mkdirp",
	        "moment",
	        "node-dir",
	        "object-assign",
	        "open",
	        "prop-types",
	        "react",
	        "react-contextmenu",
	        "react-dnd",
	        "react-dnd-html5-backend",
	        "react-dnd-test-backend",
	        "react-docgen",
	        "react-dom",
	        "react-select",
	        "react-test-renderer",
	        "reselect",
	        "rewire",
	        "rewire-webpack",
	        "ron-react-autocomplete",
	        "run-sequence",
	        "semver",
	        "shallowequal",
	        "sinon",
	        "style-loader",
	        "underscore",
	        "vinyl-source-stream",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "grid",
	        "set"
	      ],
	      "lastStarCount": 2718,
	      "lastUpdatedAt": "2018-07-27T19:26:41Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/1763971?v=4"
	    },
	    {
	      "githubPath": "rsamec/react-pathjs-chart",
	      "description": "Charts (Pie,SmoothLine,Bar,Tree,Radar,ScatterPlot) using path-js",
	      "homepage": "http://rsamec.github.io/react-pathjs-chart/",
	      "dependencies": [
	        "genie",
	        "gulp",
	        "lodash",
	        "paths-js",
	        "react-binding",
	        "react-bootstrap",
	        "react-component-gulp-tasks",
	        "react-json",
	        "react-json-fork",
	        "react-property-editor",
	        "vivus"
	      ],
	      "tags": [
	        "dataviz"
	      ],
	      "lastStarCount": 62,
	      "lastUpdatedAt": "2018-05-29T07:14:24Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/5671166?v=4"
	    },
	    {
	      "githubPath": "nsisodiya/react-json-viewer",
	      "description": "React JSON Viewer Component. View JSON in beautiful tabular format.",
	      "homepage": "http://nsisodiya.github.io/react-json-viewer",
	      "dependencies": [
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-transform-class-properties",
	        "babel-plugin-transform-object-rest-spread",
	        "babel-preset-env",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "eslint",
	        "eslint-loader",
	        "eslint-plugin-babel",
	        "eslint-plugin-react",
	        "husky",
	        "prettier",
	        "prop-types",
	        "react",
	        "react-dom",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "icon"
	      ],
	      "lastStarCount": 106,
	      "lastUpdatedAt": "2018-06-19T16:59:24Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/333455?v=4"
	    },
	    {
	      "githubPath": "bharani91/react-select-popover",
	      "description": "A react component to convert a select box into a nifty popover with prepopulated options",
	      "homepage": "http://bharani91.github.io/react-select-popover",
	      "dependencies": [
	        "browserify",
	        "browserify-shim",
	        "gulp",
	        "gulp-autoprefixer",
	        "gulp-concat",
	        "gulp-connect",
	        "gulp-copy",
	        "gulp-cssmin",
	        "gulp-react",
	        "gulp-rename",
	        "gulp-sass",
	        "gulp-sourcemaps",
	        "gulp-streamify",
	        "gulp-uglify",
	        "react-dom",
	        "react-onclickoutside",
	        "reactify",
	        "vinyl-source-stream"
	      ],
	      "tags": [
	        "autocomplete"
	      ],
	      "lastStarCount": 73,
	      "lastUpdatedAt": "2018-07-17T10:34:21Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/919147?v=4"
	    },
	    {
	      "githubPath": "mxstbr/sharingbuttons.io",
	      "description": "Quickly generate social sharing buttons with a tiny performance footprint",
	      "homepage": "http://sharingbuttons.io",
	      "dependencies": [
	        "appcache-webpack-plugin",
	        "autoprefixer-core",
	        "babel",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "css-loader",
	        "cssnano",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-plugin-react",
	        "expect",
	        "file-loader",
	        "flux",
	        "html-webpack-plugin",
	        "mocha",
	        "object.assign",
	        "postcss-focus",
	        "postcss-font-magician",
	        "postcss-import",
	        "postcss-loader",
	        "postcss-nested",
	        "postcss-reporter",
	        "postcss-simple-vars",
	        "react",
	        "react-hot-loader",
	        "style-loader",
	        "url-loader",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "set",
	        "button"
	      ],
	      "lastStarCount": 2086,
	      "lastUpdatedAt": "2018-07-24T08:57:53Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/7525670?v=4"
	    },
	    {
	      "githubPath": "AllenFang/react-bootstrap-table",
	      "description": "A Bootstrap table built with React.js",
	      "homepage": "https://allenfang.github.io/react-bootstrap-table/",
	      "dependencies": [
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "babelify",
	        "bootstrap",
	        "browserify",
	        "classnames",
	        "css-loader",
	        "del",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-loader",
	        "eslint-plugin-react",
	        "gulp",
	        "gulp-babel",
	        "gulp-concat-css",
	        "gulp-cssmin",
	        "gulp-shell",
	        "history",
	        "jest-cli",
	        "jquery",
	        "jsx-loader",
	        "prop-types",
	        "react",
	        "react-bootstrap",
	        "react-dom",
	        "react-hot-loader",
	        "react-modal",
	        "react-router",
	        "react-s-alert",
	        "style-loader",
	        "styled-components",
	        "vinyl-source-stream",
	        "watchify",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "list"
	      ],
	      "lastStarCount": 2017,
	      "lastUpdatedAt": "2018-07-27T06:53:43Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/5351390?v=4"
	    },
	    {
	      "githubPath": "dreyescat/react-rating",
	      "description": "A rating react component with custom symbols.",
	      "homepage": "http://dreyescat.github.io/react-rating/",
	      "dependencies": [
	        "@types/lodash",
	        "@types/react",
	        "babel",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "bootstrap",
	        "chai",
	        "create-react-class",
	        "cross-env",
	        "eslint",
	        "eslint-loader",
	        "eslint-plugin-react",
	        "font-awesome",
	        "mocha",
	        "node-libs-browser",
	        "prismjs",
	        "prop-types",
	        "react",
	        "react-dom",
	        "react-test-renderer",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [],
	      "lastStarCount": 218,
	      "lastUpdatedAt": "2018-07-26T18:46:45Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/1313415?v=4"
	    },
	    {
	      "githubPath": "pqx/react-ui-tree",
	      "description": "React tree component",
	      "homepage": "https://pqx.github.io/react-ui-tree",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-loader",
	        "babel-preset-env",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "classnames",
	        "css-loader",
	        "github-pages-deploy",
	        "js-tree",
	        "less",
	        "less-loader",
	        "mocha",
	        "prop-types",
	        "react",
	        "react-dom",
	        "style-loader",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [],
	      "lastStarCount": 540,
	      "lastUpdatedAt": "2018-07-27T17:17:33Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/4981025?v=4"
	    },
	    {
	      "githubPath": "wangzuo/react-progress-label",
	      "description": "progress label component",
	      "homepage": "http://wangzuo.github.io/react-progress-label",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-jest",
	        "babel-loader",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "css-loader",
	        "github-pages-deploy",
	        "jest",
	        "less",
	        "less-loader",
	        "prop-types",
	        "react",
	        "react-dom",
	        "react-input-color",
	        "react-input-slider",
	        "react-test-renderer",
	        "style-loader",
	        "webpack"
	      ],
	      "tags": [],
	      "lastStarCount": 74,
	      "lastUpdatedAt": "2018-06-29T13:23:12Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/1039026?v=4"
	    },
	    {
	      "githubPath": "negomi/react-burger-menu",
	      "description": ":hamburger: An off-canvas sidebar component with a collection of effects and styles using CSS transitions and SVG path animations",
	      "homepage": "http://negomi.github.io/react-burger-menu/",
	      "dependencies": [
	        "ajv",
	        "babel-core",
	        "babel-eslint",
	        "babel-plugin-istanbul",
	        "babel-preset-env",
	        "babel-preset-react",
	        "babel-register",
	        "browserify-optional",
	        "chai",
	        "classnames",
	        "cross-env",
	        "eslint",
	        "eslint-plugin-react",
	        "eve",
	        "gulp",
	        "gulp-git",
	        "jsdom",
	        "jsdom-global",
	        "mocha",
	        "nyc",
	        "pre-commit",
	        "prettier",
	        "prop-types",
	        "react",
	        "react-component-gulp-tasks",
	        "react-dom",
	        "react-test-renderer",
	        "sinon",
	        "snapsvg-cjs"
	      ],
	      "tags": [
	        "menu"
	      ],
	      "lastStarCount": 2464,
	      "lastUpdatedAt": "2018-07-27T16:44:06Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/3727684?v=4"
	    },
	    {
	      "githubPath": "wangzuo/react-input-color",
	      "description": "React input color component with hsv color picker",
	      "homepage": "https://wangzuo.github.io/react-input-color",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-jest",
	        "babel-loader",
	        "babel-preset-env",
	        "babel-preset-react",
	        "blacklist",
	        "classnames",
	        "color-functions",
	        "css-loader",
	        "github-pages-deploy",
	        "jest",
	        "less",
	        "less-loader",
	        "object-assign",
	        "react",
	        "react-dom",
	        "react-input-number",
	        "react-input-slider",
	        "react-test-renderer",
	        "style-loader",
	        "webpack",
	        "webpack-cli",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "color",
	        "picker"
	      ],
	      "lastStarCount": 141,
	      "lastUpdatedAt": "2018-07-11T07:26:12Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/1039026?v=4"
	    },
	    {
	      "githubPath": "malte-wessel/react-custom-scrollbars",
	      "description": "React scrollbars component",
	      "homepage": "http://malte-wessel.github.io/react-custom-scrollbars/",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-1",
	        "babel-register",
	        "babel-runtime",
	        "cross-env",
	        "dom-css",
	        "es3ify",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "expect",
	        "glob",
	        "isparta-loader",
	        "karma",
	        "karma-chrome-launcher",
	        "karma-cli",
	        "karma-coverage",
	        "karma-mocha",
	        "karma-mocha-reporter",
	        "karma-sourcemap-loader",
	        "karma-webpack",
	        "mocha",
	        "prop-types",
	        "raf",
	        "react",
	        "react-dom",
	        "rimraf",
	        "simulant",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [],
	      "lastStarCount": 1601,
	      "lastUpdatedAt": "2018-07-27T20:24:41Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/1020216?v=4"
	    },
	    {
	      "githubPath": "wangzuo/react-medium-editor",
	      "description": "React wrapper for medium-editor",
	      "homepage": "https://wangzuo.github.io/react-medium-editor",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "blacklist",
	        "css-loader",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "github-pages-deploy",
	        "medium-editor",
	        "object-assign",
	        "static-site-generator-webpack-plugin",
	        "style-loader",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "text editor"
	      ],
	      "lastStarCount": 387,
	      "lastUpdatedAt": "2018-07-27T02:34:56Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/1039026?v=4"
	    },
	    {
	      "githubPath": "k4wo/react-notify",
	      "description": "Tiny React's module that shows notifications.",
	      "homepage": "http://k4wo.github.io/react-notify/public/",
	      "dependencies": [
	        "babel-core",
	        "babel-loader",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "react",
	        "webpack"
	      ],
	      "tags": [
	        "notification"
	      ],
	      "lastStarCount": 49,
	      "lastUpdatedAt": "2018-06-27T13:11:38Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/7694418?v=4"
	    },
	    {
	      "githubPath": "georgeOsdDev/react-draggable-tab",
	      "description": "Atom like draggable tab react component",
	      "homepage": "http://georgeosddev.github.io/react-draggable-tab/",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-plugin-minify-dead-code-elimination",
	        "babel-preset-env",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "babel-preset-stage-2",
	        "babelify",
	        "browser-sync",
	        "browserify",
	        "chai",
	        "classnames",
	        "cross-env",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "immutable",
	        "invariant",
	        "karma",
	        "karma-browserify",
	        "karma-chai",
	        "karma-chrome-launcher",
	        "karma-cli",
	        "karma-firefox-launcher",
	        "karma-mocha",
	        "karma-safari-launcher",
	        "karma-spec-reporter",
	        "lodash",
	        "material-ui",
	        "mocha",
	        "mousetrap",
	        "prop-types",
	        "react",
	        "react-dom",
	        "react-draggable",
	        "react-notification-badge",
	        "react-tap-event-plugin",
	        "react-test-renderer",
	        "rimraf",
	        "watchify"
	      ],
	      "tags": [],
	      "lastStarCount": 107,
	      "lastUpdatedAt": "2018-07-12T12:48:46Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/1381907?v=4"
	    },
	    {
	      "githubPath": "arqex/react-json-table",
	      "description": "A simple but reactive table react component to display JSON data.",
	      "homepage": null,
	      "dependencies": [
	        "gulp",
	        "gulp-insert",
	        "gulp-uglify",
	        "gulp-webpack"
	      ],
	      "tags": [
	        "list"
	      ],
	      "lastStarCount": 67,
	      "lastUpdatedAt": "2018-06-18T20:09:22Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/6509397?v=4"
	    },
	    {
	      "githubPath": "mathieudutour/react-progress-button",
	      "description": ":cyclone: Simple react.js component for an inline progress indicator",
	      "homepage": "https://mathieudutour.github.io/react-progress-button",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "create-react-class",
	        "prop-types",
	        "react",
	        "react-dom",
	        "standard",
	        "webpack"
	      ],
	      "tags": [
	        "button"
	      ],
	      "lastStarCount": 409,
	      "lastUpdatedAt": "2018-07-24T08:37:10Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/3254314?v=4"
	    },
	    {
	      "githubPath": "Lapple/react-transitive-number",
	      "description": "React component to apply transition effect to numeric strings, a la old Groupon timers",
	      "homepage": null,
	      "dependencies": [
	        "browserify",
	        "moment",
	        "watchify"
	      ],
	      "tags": [
	        "animation"
	      ],
	      "lastStarCount": 185,
	      "lastUpdatedAt": "2018-07-08T06:23:07Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/1042560?v=4"
	    },
	    {
	      "githubPath": "Lapple/react-json-inspector",
	      "description": "React JSON inspector component",
	      "homepage": null,
	      "dependencies": [
	        "browserify",
	        "chai",
	        "create-react-class",
	        "debounce",
	        "enzyme",
	        "http-server",
	        "md5-o-matic",
	        "mocha",
	        "object-assign",
	        "prop-types",
	        "react",
	        "react-addons-test-utils",
	        "react-dom",
	        "react-test-renderer",
	        "watchify"
	      ],
	      "tags": [
	        "devtool"
	      ],
	      "lastStarCount": 234,
	      "lastUpdatedAt": "2018-07-27T15:00:57Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/1042560?v=4"
	    },
	    {
	      "githubPath": "DropsOfSerenity/react-avatar-cropper",
	      "description": "Aiming to be a complete solution for avatar cropping in react.",
	      "homepage": "http://dropsofserenity.github.io/react-avatar-cropper",
	      "dependencies": [
	        "babel",
	        "babel-core",
	        "babel-loader",
	        "browserify",
	        "css-loader",
	        "node-libs-browser",
	        "react-bootstrap",
	        "react-hot-loader",
	        "style-loader",
	        "warning",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [],
	      "lastStarCount": 247,
	      "lastUpdatedAt": "2018-07-17T09:37:14Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/2287977?v=4"
	    },
	    {
	      "githubPath": "RakanNimer/react-google-charts",
	      "description": "A thin, typed, React wrapper over Google Charts Visualization and Charts API.",
	      "homepage": "https://codesandbox.io/s/6wjj700k9w",
	      "dependencies": [
	        "@types/react",
	        "@types/react-dom",
	        "husky",
	        "jsdoc",
	        "jsdom",
	        "lint-staged",
	        "object-assign",
	        "parcel-bundler",
	        "prettier",
	        "react",
	        "react-dom",
	        "react-google-charts",
	        "react-load-script",
	        "typescript"
	      ],
	      "tags": [
	        "dataviz"
	      ],
	      "lastStarCount": 383,
	      "lastUpdatedAt": "2018-07-27T09:26:40Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/1270909?v=4"
	    },
	    {
	      "githubPath": "LevInteractive/react-serial-forms",
	      "description": "A high performance form library built specifically for React.",
	      "homepage": "",
	      "dependencies": [
	        "babel",
	        "babel-core",
	        "babel-eslint",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babelify",
	        "browserify",
	        "browserify-shim",
	        "chai",
	        "del",
	        "gulp",
	        "gulp-babel",
	        "gulp-plumber",
	        "gulp-sourcemaps",
	        "gulp-uglify",
	        "gulp-util",
	        "jsdom",
	        "lodash",
	        "mocha",
	        "react-addons-test-utils",
	        "testdom",
	        "vinyl-buffer",
	        "vinyl-source-stream"
	      ],
	      "tags": [
	        "form"
	      ],
	      "lastStarCount": 164,
	      "lastUpdatedAt": "2018-07-23T11:16:35Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/4335292?v=4"
	    },
	    {
	      "githubPath": "signavio/react-mentions",
	      "description": "@mention people in a textarea",
	      "homepage": "https://signavio.github.io/react-mentions/master/",
	      "dependencies": [
	        "babel-eslint",
	        "condition-circle",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "eslint",
	        "eslint-config-react-app",
	        "eslint-plugin-flowtype",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "gh-pages",
	        "lodash",
	        "nwb",
	        "prettier",
	        "prop-types",
	        "radium",
	        "react",
	        "react-dom",
	        "recompose",
	        "semantic-release",
	        "substyle"
	      ],
	      "tags": [],
	      "lastStarCount": 517,
	      "lastUpdatedAt": "2018-07-27T07:54:02Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/5164647?v=4"
	    },
	    {
	      "githubPath": "google-map-react/google-map-react",
	      "description": "Google map library for react that allows rendering components as markers :tada:",
	      "homepage": "http://google-map-react.github.io/google-map-react/map/main/",
	      "dependencies": [
	        "@mapbox/point-geometry",
	        "autoprefixer",
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-webpack-loaders",
	        "babel-polyfill",
	        "babel-preset-env",
	        "babel-preset-react",
	        "babel-preset-react-hmre",
	        "babel-preset-stage-0",
	        "babel-register",
	        "css-loader",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-config-prettier",
	        "eslint-plugin-babel",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-prettier",
	        "eslint-plugin-react",
	        "eventemitter3",
	        "expect",
	        "file-loader",
	        "husky",
	        "jsdom",
	        "kotatsu",
	        "lint-staged",
	        "mocha",
	        "node-sass",
	        "normalize.css",
	        "postcss-loader",
	        "prettier",
	        "prop-types",
	        "react",
	        "react-dom",
	        "react-motion",
	        "react-router",
	        "recompose",
	        "reselect",
	        "rimraf",
	        "rxjs",
	        "sass-loader",
	        "scriptjs",
	        "style-loader",
	        "url-loader",
	        "webpack"
	      ],
	      "tags": [
	        "map"
	      ],
	      "lastStarCount": 2880,
	      "lastUpdatedAt": "2018-07-27T18:46:39Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/37761132?v=4"
	    },
	    {
	      "githubPath": "greena13/react-hotkeys",
	      "description": "Declarative hotkey and focus area management for React",
	      "homepage": "https://github.com/greena13/react-hotkeys",
	      "dependencies": [
	        "autoprefixer-loader",
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-external-helpers",
	        "babel-plugin-remove-comments",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-2",
	        "babel-register",
	        "chai",
	        "chai-enzyme",
	        "cheerio",
	        "css-loader",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "eslint",
	        "eslint-config-react-app",
	        "eslint-plugin-flowtype",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "estraverse",
	        "jsdom",
	        "jsdom-global",
	        "lodash.isboolean",
	        "lodash.isequal",
	        "lodash.isobject",
	        "lodash.random",
	        "mocha",
	        "mousetrap",
	        "nodemon",
	        "prompt",
	        "prop-types",
	        "react",
	        "react-dom",
	        "rollup",
	        "rollup-plugin-babel",
	        "rollup-plugin-license",
	        "rollup-plugin-replace",
	        "rollup-plugin-uglify",
	        "simulant",
	        "sinon",
	        "sinon-chai",
	        "style-loader",
	        "webpack"
	      ],
	      "tags": [],
	      "lastStarCount": 1046,
	      "lastUpdatedAt": "2018-07-27T17:32:40Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/2115363?v=4"
	    },
	    {
	      "githubPath": "jakubzloczewski/react-steps",
	      "description": "Steps component for react",
	      "homepage": null,
	      "dependencies": [
	        "babel-core",
	        "babel-loader",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "classnames",
	        "css-loader",
	        "less",
	        "less-loader",
	        "react",
	        "react-dom",
	        "style-loader",
	        "webpack"
	      ],
	      "tags": [],
	      "lastStarCount": 45,
	      "lastUpdatedAt": "2018-04-26T12:49:00Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/1206297?v=4"
	    },
	    {
	      "githubPath": "whoisandy/react-blocks",
	      "description": "A higher-level react component to manage complex layouts using flexbox.",
	      "homepage": "http://whoisandy.github.io/react-blocks",
	      "dependencies": [
	        "babel",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "chai",
	        "css-loader",
	        "es5-shim",
	        "eslint",
	        "eslint-loader",
	        "eslint-plugin-react",
	        "gh-pages",
	        "html-webpack-plugin",
	        "karma",
	        "karma-chai",
	        "karma-chai-plugins",
	        "karma-mocha",
	        "karma-mocha-reporter",
	        "karma-phantomjs-launcher",
	        "karma-webpack",
	        "less",
	        "less-loader",
	        "mocha",
	        "object-assign",
	        "phantomjs",
	        "react",
	        "react-dom",
	        "react-hot-loader",
	        "style-loader",
	        "webpack",
	        "webpack-dev-server",
	        "webpack-merge"
	      ],
	      "tags": [
	        "grid"
	      ],
	      "lastStarCount": 355,
	      "lastUpdatedAt": "2018-07-27T03:28:25Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/297132?v=4"
	    },
	    {
	      "githubPath": "jxnblk/react-fitter-happier-text",
	      "description": "React component for fully fluid headings",
	      "homepage": "http://jxnblk.com/react-fitter-happier-text",
	      "dependencies": [
	        "babel",
	        "babel-core",
	        "babel-loader",
	        "blk",
	        "css-loader",
	        "cssnext-loader",
	        "flex-object",
	        "gravitons",
	        "lodash",
	        "node-libs-browser",
	        "react",
	        "react",
	        "style-loader",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "text"
	      ],
	      "lastStarCount": 48,
	      "lastUpdatedAt": "2018-07-09T20:31:26Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/3451712?v=4"
	    },
	    {
	      "githubPath": "jxnblk/rgx",
	      "description": "React grid system based on minimum and maximum widths",
	      "homepage": "http://jxnblk.com/rgx",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-loader",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "babel-register",
	        "basscss-color-input-range",
	        "basscss-input-range",
	        "blk",
	        "css-loader",
	        "cssnext-loader",
	        "expect",
	        "file-loader",
	        "html-loader",
	        "json-loader",
	        "karma",
	        "karma-chai",
	        "karma-chai-plugins",
	        "karma-chrome-launcher",
	        "karma-cli",
	        "karma-firefox-launcher",
	        "karma-mocha",
	        "karma-mocha-reporter",
	        "karma-webpack",
	        "lodash",
	        "markdown-loader",
	        "marked",
	        "mocha",
	        "node-libs-browser",
	        "raw-loader",
	        "react",
	        "react-addons-test-utils",
	        "react-dom",
	        "react-hot-loader",
	        "rebass",
	        "simple-modular-scale",
	        "style-loader",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "grid"
	      ],
	      "lastStarCount": 198,
	      "lastUpdatedAt": "2018-06-18T01:36:31Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/3451712?v=4"
	    },
	    {
	      "githubPath": "xudafeng/autoresponsive-react",
	      "description": "Auto Responsive Layout Library For React",
	      "homepage": "https://xudafeng.github.com/autoresponsive-react",
	      "dependencies": [
	        "autoresponsive-core",
	        "babel-cli",
	        "babel-core",
	        "babel-loader",
	        "babel-plugin-istanbul",
	        "babel-preset-env",
	        "babel-preset-react",
	        "babel-preset-stage-2",
	        "bluebird",
	        "cross-env",
	        "css-loader",
	        "eslint",
	        "eslint-config-standard",
	        "eslint-loader",
	        "eslint-plugin-import",
	        "eslint-plugin-mocha",
	        "eslint-plugin-node",
	        "eslint-plugin-promise",
	        "eslint-plugin-react",
	        "eslint-plugin-standard",
	        "exenv",
	        "forkmeon.github.io",
	        "git-contributor",
	        "highlight.js",
	        "json-loader",
	        "jsx-loader",
	        "less",
	        "less-loader",
	        "macaca-cli",
	        "macaca-electron",
	        "macaca-wd",
	        "marked",
	        "react",
	        "react-dom",
	        "react-logo",
	        "style-loader",
	        "webpack",
	        "webpack-cli",
	        "webpack-dev-server",
	        "xutil"
	      ],
	      "tags": [
	        "grid"
	      ],
	      "lastStarCount": 972,
	      "lastUpdatedAt": "2018-07-24T18:45:02Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/1011681?v=4"
	    },
	    {
	      "githubPath": "enkidevs/react-search-input",
	      "description": ":mag: Simple react.js component for a search input, providing a filter function.",
	      "homepage": "",
	      "dependencies": [
	        "babel-cli",
	        "babel-jest",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "fuse.js",
	        "immutable",
	        "jest",
	        "prop-types",
	        "react",
	        "react-dom",
	        "standard",
	        "webpack"
	      ],
	      "tags": [
	        "search"
	      ],
	      "lastStarCount": 244,
	      "lastUpdatedAt": "2018-07-14T14:16:25Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/12428872?v=4"
	    },
	    {
	      "githubPath": "FormidableLabs/component-playground",
	      "description": "A component for rendering React components with editable source and live preview",
	      "homepage": "https://formidable.com/open-source/component-playground/",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-polyfill",
	        "babel-preset-env",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "babel-preset-stage-1",
	        "babel-standalone",
	        "chai",
	        "codemirror",
	        "core-js",
	        "css-loader",
	        "eslint",
	        "eslint-config-formidable",
	        "eslint-plugin-filenames",
	        "eslint-plugin-import",
	        "eslint-plugin-react",
	        "file-loader",
	        "isparta-loader",
	        "karma",
	        "karma-chrome-launcher",
	        "karma-coverage",
	        "karma-firefox-launcher",
	        "karma-ie-launcher",
	        "karma-mocha",
	        "karma-phantomjs-launcher",
	        "karma-phantomjs-shim",
	        "karma-safari-launcher",
	        "karma-sauce-launcher",
	        "karma-spec-reporter",
	        "karma-webpack",
	        "lodash",
	        "mocha",
	        "opener",
	        "phantomjs-prebuilt",
	        "prop-types",
	        "publishr",
	        "raw-loader",
	        "react",
	        "react-codemirror2",
	        "react-dom",
	        "react-hot-loader",
	        "react-test-renderer",
	        "rimraf",
	        "sinon",
	        "sinon-chai",
	        "style-loader",
	        "url-loader",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "devtool"
	      ],
	      "lastStarCount": 952,
	      "lastUpdatedAt": "2018-07-27T19:42:20Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/5078602?v=4"
	    },
	    {
	      "githubPath": "jxnblk/react-geomicons",
	      "description": "React icon component for Geomicons Open",
	      "homepage": "http://jxnblk.com/react-geomicons",
	      "dependencies": [
	        "ava",
	        "babel-cli",
	        "babel-loader",
	        "babel-plugin-transform-react-jsx",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "babel-register",
	        "chroma-js",
	        "cxs",
	        "enzyme",
	        "geomicons-open",
	        "highlight-loader",
	        "html-loader",
	        "json-loader",
	        "markdown-loader",
	        "marked",
	        "react",
	        "react-addons-test-utils",
	        "react-dom",
	        "rebass",
	        "standard",
	        "static-site-generator-webpack-plugin",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "icon"
	      ],
	      "lastStarCount": 84,
	      "lastUpdatedAt": "2017-10-15T17:57:51Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/3451712?v=4"
	    },
	    {
	      "githubPath": "roadmanfong/react-cropper",
	      "description": "Cropper as React components",
	      "homepage": "http://roadmanfong.github.io/react-cropper/",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-transform-object-assign",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "cropperjs",
	        "css-loader",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "extract-text-webpack-plugin",
	        "prop-types",
	        "react",
	        "react-dom",
	        "react-hot-loader",
	        "rimraf",
	        "style-loader",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [],
	      "lastStarCount": 712,
	      "lastUpdatedAt": "2018-07-23T12:58:51Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/2047789?v=4"
	    },
	    {
	      "githubPath": "Evo-Forge/Essence",
	      "description": "Essence - The Essential Material Design Framework",
	      "homepage": "http://getessence.io",
	      "dependencies": [
	        "essence-appbar",
	        "essence-bottomsheet",
	        "essence-button",
	        "essence-card",
	        "essence-chip",
	        "essence-core",
	        "essence-data-table",
	        "essence-dialog",
	        "essence-icon",
	        "essence-image",
	        "essence-input",
	        "essence-list",
	        "essence-menu",
	        "essence-navigation",
	        "essence-paper",
	        "essence-progress",
	        "essence-slider",
	        "essence-snackbar",
	        "essence-stepper",
	        "essence-switch",
	        "essence-tab",
	        "essence-toast",
	        "essence-toolbar",
	        "essence-tooltip",
	        "essence-touchpad"
	      ],
	      "tags": [
	        "toolkit",
	        "material design",
	        "abandoned"
	      ],
	      "lastStarCount": 414,
	      "lastUpdatedAt": "2018-07-25T00:17:14Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/9674664?v=4"
	    },
	    {
	      "githubPath": "felixrieseberg/React-Spreadsheet-Component",
	      "description": ":clipboard: Spreadsheet Component for ReactJS",
	      "homepage": "",
	      "dependencies": [
	        "babel-jest",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babelify",
	        "body-parser",
	        "browserify",
	        "browserify-shim",
	        "del",
	        "express",
	        "gulp",
	        "gulp-babel",
	        "gulp-connect",
	        "gulp-header",
	        "gulp-jshint",
	        "gulp-plumber",
	        "gulp-react",
	        "gulp-rename",
	        "gulp-streamify",
	        "gulp-uglify",
	        "gulp-util",
	        "jest",
	        "jquery",
	        "jshint-stylish",
	        "minimatch",
	        "mousetrap",
	        "multer",
	        "react",
	        "react-dom",
	        "react-test-renderer",
	        "tape",
	        "vinyl-source-stream"
	      ],
	      "tags": [
	        "spreadsheet"
	      ],
	      "lastStarCount": 533,
	      "lastUpdatedAt": "2018-07-25T07:25:35Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/1426799?v=4"
	    },
	    {
	      "githubPath": "javierbyte/react-number-easing",
	      "description": "React component for fancy number transitions.",
	      "homepage": "http://javier.xyz/react-number-easing/",
	      "dependencies": [
	        "eases"
	      ],
	      "tags": [
	        "animation"
	      ],
	      "lastStarCount": 86,
	      "lastUpdatedAt": "2018-07-05T20:37:11Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/2009676?v=4"
	    },
	    {
	      "githubPath": "zenoamaro/react-quill",
	      "description": "A Quill component for React.",
	      "homepage": "https://zenoamaro.github.io/react-quill",
	      "dependencies": [
	        "@types/quill",
	        "@types/react",
	        "blanket",
	        "chai",
	        "chai-enzyme",
	        "cheerio",
	        "create-react-class",
	        "enzyme",
	        "jsdom",
	        "jsdom-global",
	        "jshint",
	        "lodash",
	        "mocha",
	        "mocha-text-cov",
	        "prop-types",
	        "quill",
	        "react",
	        "react-addons-test-utils",
	        "react-dom",
	        "react-dom-factories",
	        "react-test-renderer",
	        "should",
	        "sinon",
	        "travis-cov",
	        "uglify-js",
	        "webpack"
	      ],
	      "tags": [
	        "text editor"
	      ],
	      "lastStarCount": 1907,
	      "lastUpdatedAt": "2018-07-27T06:32:08Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/493139?v=4"
	    },
	    {
	      "githubPath": "igorprado/react-notification-system",
	      "description": "A complete and totally customizable component for notifications in React",
	      "homepage": "http://igorprado.github.io/react-notification-system/",
	      "dependencies": [
	        "autoprefixer-loader",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-react-class-display-name",
	        "babel-plugin-react-transform",
	        "babel-preset-airbnb",
	        "chai",
	        "create-react-class",
	        "css-loader",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "express",
	        "extract-text-webpack-plugin",
	        "file-loader",
	        "install",
	        "isparta-loader",
	        "karma",
	        "karma-chai-plugins",
	        "karma-chrome-launcher",
	        "karma-cli",
	        "karma-coverage",
	        "karma-coveralls",
	        "karma-firefox-launcher",
	        "karma-mocha",
	        "karma-sourcemap-loader",
	        "karma-webpack",
	        "mocha",
	        "node-sass",
	        "object-assign",
	        "prop-types",
	        "react",
	        "react-dom",
	        "react-tools",
	        "react-transform-catch-errors",
	        "react-transform-hmr",
	        "redbox-react",
	        "rimraf",
	        "sass-loader",
	        "style-loader",
	        "webpack",
	        "webpack-dev-middleware",
	        "webpack-hot-middleware"
	      ],
	      "tags": [
	        "notification"
	      ],
	      "lastStarCount": 2087,
	      "lastUpdatedAt": "2018-07-26T22:25:33Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/2054758?v=4"
	    },
	    {
	      "githubPath": "prakhar1989/react-tags",
	      "description": "A fantastically simple tagging component for your React projects",
	      "homepage": "http://prakhar1989.github.io/react-tags/example/",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-jest",
	        "babel-loader",
	        "babel-preset-env",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "babel-register",
	        "chai",
	        "core-js",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "eslint",
	        "eslint-plugin-jest",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "greenkeeper-lockfile",
	        "jest",
	        "jsdom",
	        "lodash",
	        "npm-run-all",
	        "opn",
	        "prettier",
	        "prop-types",
	        "raf",
	        "react",
	        "react-dnd",
	        "react-dnd-html5-backend",
	        "react-dnd-test-backend",
	        "react-dom",
	        "react-test-renderer",
	        "sinon",
	        "webpack",
	        "webpack-cli",
	        "webpack-dev-server"
	      ],
	      "tags": [],
	      "lastStarCount": 683,
	      "lastUpdatedAt": "2018-07-27T15:34:04Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/649249?v=4"
	    },
	    {
	      "githubPath": "liferay/alloy-editor",
	      "description": "WYSIWYG editor based on CKEditor with completely rewritten UI",
	      "homepage": "http://alloyeditor.com",
	      "dependencies": [
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "bourbon",
	        "chai",
	        "del",
	        "dir-compare",
	        "eslint",
	        "event-stream",
	        "gulp",
	        "gulp-babel",
	        "gulp-compass",
	        "gulp-concat",
	        "gulp-consolidate",
	        "gulp-cssnano",
	        "gulp-empty",
	        "gulp-iconfont",
	        "gulp-rename",
	        "gulp-replace",
	        "gulp-sass",
	        "gulp-template",
	        "gulp-uglify",
	        "gulp-yuidoc-relative",
	        "gulp-zip",
	        "hash-files",
	        "karma",
	        "karma-babel-preprocessor",
	        "karma-chai",
	        "karma-chrome-launcher",
	        "karma-coverage",
	        "karma-firefox-launcher",
	        "karma-fixture",
	        "karma-html2js-preprocessor",
	        "karma-ie-launcher",
	        "karma-ievms",
	        "karma-junit-reporter",
	        "karma-mocha",
	        "karma-safari-launcher",
	        "karma-sauce-launcher",
	        "karma-sinon",
	        "lodash",
	        "mkdirp",
	        "mocha",
	        "require-dir",
	        "run-sequence",
	        "sinon",
	        "walk",
	        "yargs"
	      ],
	      "tags": [
	        "text editor"
	      ],
	      "lastStarCount": 908,
	      "lastUpdatedAt": "2018-07-26T13:29:01Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/131436?v=4"
	    },
	    {
	      "githubPath": "brigade/react-waypoint",
	      "description": "A React component to execute a function whenever you scroll to an element.",
	      "homepage": "http://brigade.github.io/react-waypoint/",
	      "dependencies": [
	        "@types/react",
	        "babel-cli",
	        "babel-core",
	        "babel-loader",
	        "babel-plugin-transform-react-remove-prop-types",
	        "babel-preset-airbnb",
	        "consolidated-events",
	        "eslint",
	        "eslint-config-brigade",
	        "eslint-plugin-react",
	        "in-publish",
	        "jasmine-core",
	        "karma",
	        "karma-chrome-launcher",
	        "karma-cli",
	        "karma-firefox-launcher",
	        "karma-jasmine",
	        "karma-webpack",
	        "prop-types",
	        "react",
	        "react-dom",
	        "rimraf",
	        "rollup",
	        "rollup-plugin-babel",
	        "safe-publish-latest",
	        "webpack"
	      ],
	      "tags": [],
	      "lastStarCount": 2641,
	      "lastUpdatedAt": "2018-07-27T19:10:31Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/7872961?v=4"
	    },
	    {
	      "githubPath": "felixrieseberg/React-Dropzone-Component",
	      "description": ":camera: ReactJS Dropzone for File Uploads (using Dropzone.js)",
	      "homepage": "",
	      "dependencies": [
	        "@types/dropzone",
	        "babel-core",
	        "babel-jest",
	        "babel-loader",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "dropzone",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "extend",
	        "jest",
	        "standard",
	        "uglifyjs-webpack-plugin",
	        "webpack"
	      ],
	      "tags": [],
	      "lastStarCount": 803,
	      "lastUpdatedAt": "2018-07-24T20:27:24Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/1426799?v=4"
	    },
	    {
	      "githubPath": "rexxars/react-markdown",
	      "description": "Render Markdown as React components",
	      "homepage": "https://rexxars.github.io/react-markdown/",
	      "dependencies": [
	        "babel-cli",
	        "babel-loader",
	        "babel-plugin-transform-react-remove-prop-types",
	        "babel-preset-env",
	        "babel-preset-react",
	        "eslint",
	        "eslint-config-prettier",
	        "eslint-config-sanity",
	        "eslint-plugin-react",
	        "gh-pages-deploy",
	        "jest",
	        "mdast-add-list-metadata",
	        "prettier",
	        "prop-types",
	        "react",
	        "react-addons-test-utils",
	        "react-dom",
	        "react-test-renderer",
	        "remark-breaks",
	        "remark-parse",
	        "remark-shortcodes",
	        "rimraf",
	        "uglify-js",
	        "unified",
	        "unist-util-visit",
	        "webpack",
	        "webpack-cli",
	        "xtend"
	      ],
	      "tags": [],
	      "lastStarCount": 2378,
	      "lastUpdatedAt": "2018-07-27T13:30:34Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/48200?v=4"
	    },
	    {
	      "githubPath": "JedWatson/react-codemirror",
	      "description": "Codemirror Component for React.js",
	      "homepage": null,
	      "dependencies": [
	        "classnames",
	        "codemirror",
	        "create-react-class",
	        "gulp",
	        "happiness",
	        "lodash.debounce",
	        "lodash.isequal",
	        "prop-types",
	        "react",
	        "react-component-gulp-tasks",
	        "react-dom"
	      ],
	      "tags": [
	        "text editor"
	      ],
	      "lastStarCount": 1057,
	      "lastUpdatedAt": "2018-07-26T18:57:58Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/872310?v=4"
	    },
	    {
	      "githubPath": "react-dnd/react-dnd",
	      "description": "Drag and Drop for React",
	      "homepage": "http://react-dnd.github.io/react-dnd",
	      "dependencies": [
	        "@types/jest",
	        "husky",
	        "jest",
	        "jest-environment-jsdom",
	        "lerna",
	        "lint-staged",
	        "npm-run-all",
	        "prettier",
	        "ts-jest",
	        "tslint",
	        "tslint-config-prettier",
	        "tslint-react"
	      ],
	      "tags": [],
	      "lastStarCount": 8963,
	      "lastUpdatedAt": "2018-07-27T20:19:11Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/25307599?v=4"
	    },
	    {
	      "githubPath": "developerdizzle/react-virtual-list",
	      "description": "Super simple virtualized list React component",
	      "homepage": "http://developerdizzle.github.io/react-virtual-list/",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-jest",
	        "babel-loader",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "file-loader",
	        "gulp",
	        "gulp-react",
	        "jasmine-node",
	        "jest",
	        "prop-types",
	        "react",
	        "react-dom",
	        "react-test-renderer",
	        "webpack"
	      ],
	      "tags": [
	        "list"
	      ],
	      "lastStarCount": 525,
	      "lastUpdatedAt": "2018-07-27T09:36:16Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/1398136?v=4"
	    },
	    {
	      "githubPath": "javierbyte/react-textgradient",
	      "description": "Text gradients with CSS with SVG fallback.",
	      "homepage": "http://javier.xyz/react-textgradient/",
	      "dependencies": [],
	      "tags": [
	        "text"
	      ],
	      "lastStarCount": 101,
	      "lastUpdatedAt": "2018-06-20T22:00:18Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/2009676?v=4"
	    },
	    {
	      "githubPath": "davidguttman/react-pivot",
	      "description": "React-Pivot is a data-grid component with pivot-table-like functionality for data display, filtering, and exploration.",
	      "homepage": "http://davidguttman.github.io/react-pivot/",
	      "dependencies": [
	        "browserify",
	        "budo",
	        "create-react-class",
	        "cssify",
	        "dataframe",
	        "envify",
	        "faker",
	        "lodash",
	        "react",
	        "react-dom",
	        "reactify",
	        "uglify-js",
	        "wildemitter",
	        "xtend"
	      ],
	      "tags": [
	        "spreadsheet"
	      ],
	      "lastStarCount": 782,
	      "lastUpdatedAt": "2018-07-24T14:34:41Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/431696?v=4"
	    },
	    {
	      "githubPath": "andreypopp/react-fa",
	      "description": "Font Awesome icons as React components",
	      "homepage": "http://andreypopp.github.io/react-fa/",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-jest",
	        "babel-loader",
	        "babel-preset-env",
	        "babel-preset-react",
	        "babel-preset-stage-1",
	        "babel-runtime",
	        "css-loader",
	        "extract-text-webpack-plugin",
	        "file-loader",
	        "flow-bin",
	        "font-awesome",
	        "jest-cli",
	        "prettier",
	        "prop-types",
	        "react",
	        "react-dom",
	        "style-loader",
	        "url-loader",
	        "webpack"
	      ],
	      "tags": [
	        "icon"
	      ],
	      "lastStarCount": 481,
	      "lastUpdatedAt": "2018-07-11T04:50:06Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/30594?v=4"
	    },
	    {
	      "githubPath": "tajo/react-portal",
	      "description": "React component for transportation of modals, lightboxes, loading bars... to document.body",
	      "homepage": "",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-jest",
	        "babel-loader",
	        "babel-preset-env",
	        "babel-preset-react",
	        "cross-env",
	        "enzyme",
	        "enzyme-adapter-react-helper",
	        "eslint",
	        "eslint-plugin-prettier",
	        "jest",
	        "prettier",
	        "prop-types",
	        "raf",
	        "react",
	        "react-dom",
	        "rimraf",
	        "webpack"
	      ],
	      "tags": [],
	      "lastStarCount": 1619,
	      "lastUpdatedAt": "2018-07-27T16:29:19Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/1387913?v=4"
	    },
	    {
	      "githubPath": "gcanti/tcomb-form-native",
	      "description": "Forms library for react-native",
	      "homepage": "",
	      "dependencies": [
	        "@types/eslint-plugin-prettier",
	        "@types/prettier",
	        "babel",
	        "babel-core",
	        "eslint",
	        "eslint-config-prettier",
	        "eslint-plugin-prettier",
	        "eslint-plugin-react",
	        "prettier",
	        "prop-types",
	        "react",
	        "tape",
	        "tcomb-validation"
	      ],
	      "tags": [
	        "form"
	      ],
	      "lastStarCount": 2707,
	      "lastUpdatedAt": "2018-07-27T15:54:32Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/878912?v=4"
	    },
	    {
	      "githubPath": "corymsmith/react-native-icons",
	      "description": "Quick and easy icons in React Native",
	      "homepage": null,
	      "dependencies": [
	        "react-native"
	      ],
	      "tags": [
	        "icon"
	      ],
	      "lastStarCount": 1164,
	      "lastUpdatedAt": "2018-07-24T08:07:01Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/7315?v=4"
	    },
	    {
	      "githubPath": "gilbox/react-track",
	      "description": "Track the position of DOM elements. Create cool animations.",
	      "homepage": "",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-loader",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-1",
	        "bundle-loader",
	        "chokidar",
	        "classnames",
	        "functional-easing",
	        "jsxhint",
	        "lodash",
	        "prop-types",
	        "raf",
	        "raf",
	        "react",
	        "react-dom",
	        "react-imation",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [],
	      "lastStarCount": 327,
	      "lastUpdatedAt": "2018-07-14T01:56:14Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/2136203?v=4"
	    },
	    {
	      "githubPath": "insin/react-maskedinput",
	      "description": "Masked <input/> React component",
	      "homepage": "http://insin.github.io/react-maskedinput/",
	      "dependencies": [
	        "eslint-config-jonnybuchanan",
	        "inputmask-core",
	        "nwb",
	        "prop-types",
	        "react",
	        "react-dom"
	      ],
	      "tags": [],
	      "lastStarCount": 598,
	      "lastUpdatedAt": "2018-07-26T14:07:06Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/226692?v=4"
	    },
	    {
	      "githubPath": "react-component/tooltip",
	      "description": "React Tooltip",
	      "homepage": "http://react-component.github.io/tooltip/",
	      "dependencies": [
	        "babel-runtime",
	        "bootstrap",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "enzyme-to-json",
	        "jest",
	        "pre-commit",
	        "prop-types",
	        "rc-tools",
	        "rc-trigger",
	        "react",
	        "react-dom"
	      ],
	      "tags": [],
	      "lastStarCount": 492,
	      "lastUpdatedAt": "2018-07-19T19:05:36Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/9441414?v=4"
	    },
	    {
	      "githubPath": "yuanyan/halogen",
	      "description": "A collection of loading spinners with React.js",
	      "homepage": "http://madscript.com/halogen",
	      "dependencies": [
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-1",
	        "babelify",
	        "browserify",
	        "browserify-shim",
	        "chalk",
	        "codemirror",
	        "del",
	        "domkit",
	        "gulp",
	        "gulp-babel",
	        "gulp-bump",
	        "gulp-connect",
	        "gulp-gh-pages",
	        "gulp-git",
	        "gulp-less",
	        "gulp-rename",
	        "gulp-streamify",
	        "gulp-uglify",
	        "gulp-util",
	        "merge-stream",
	        "vinyl-paths",
	        "vinyl-source-stream",
	        "watchify"
	      ],
	      "tags": [
	        "spinner"
	      ],
	      "lastStarCount": 1385,
	      "lastUpdatedAt": "2018-07-24T05:21:38Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/677114?v=4"
	    },
	    {
	      "githubPath": "oliviertassinari/react-swipeable-views",
	      "description": "A React component for swipeable views. :snowflake:",
	      "homepage": "https://react-swipeable-views.com/",
	      "dependencies": [
	        "@babel/cli",
	        "@babel/core",
	        "@babel/plugin-transform-object-assign",
	        "@babel/plugin-transform-runtime",
	        "@babel/preset-react",
	        "@babel/preset-stage-1",
	        "@babel/register",
	        "@babel/runtime",
	        "@material-ui/core",
	        "@material-ui/docs",
	        "@material-ui/icons",
	        "animated",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-module-resolver",
	        "babel-plugin-preval",
	        "babel-plugin-react-remove-properties",
	        "babel-plugin-transform-dev-warning",
	        "babel-plugin-transform-react-constant-elements",
	        "babel-plugin-transform-react-remove-prop-types",
	        "chai",
	        "chai-shallow-deep-equal",
	        "clean-css",
	        "cross-env",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-plugin-babel",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-mocha",
	        "eslint-plugin-prettier",
	        "eslint-plugin-react",
	        "glob",
	        "jsdom",
	        "lerna",
	        "lz-string",
	        "mocha",
	        "next",
	        "nyc",
	        "prettier",
	        "prop-types",
	        "raw-loader",
	        "react",
	        "react-dom",
	        "recompose",
	        "sinon",
	        "size-limit",
	        "webpack",
	        "webpack-bundle-analyzer"
	      ],
	      "tags": [],
	      "lastStarCount": 2341,
	      "lastUpdatedAt": "2018-07-27T20:39:22Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/3165635?v=4"
	    },
	    {
	      "githubPath": "FormidableLabs/nuka-carousel",
	      "description": "Pure React Carousel Component",
	      "homepage": "http://kenwheeler.github.io/nuka-carousel",
	      "dependencies": [
	        "@babel/cli",
	        "@babel/core",
	        "@babel/plugin-transform-object-assign",
	        "@babel/polyfill",
	        "@babel/preset-env",
	        "@babel/preset-react",
	        "babel-core",
	        "babel-eslint",
	        "babel-jest",
	        "babel-loader",
	        "builder",
	        "chai",
	        "css-loader",
	        "d3-ease",
	        "del",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "eslint",
	        "eslint-config-formidable",
	        "eslint-config-jest-enzyme",
	        "eslint-config-prettier",
	        "eslint-loader",
	        "eslint-plugin-babel",
	        "eslint-plugin-filenames",
	        "eslint-plugin-import",
	        "eslint-plugin-prettier",
	        "eslint-plugin-react",
	        "exenv",
	        "jest",
	        "jest-environment-enzyme",
	        "jest-enzyme",
	        "jest-puppeteer-preset",
	        "prop-types",
	        "puppeteer",
	        "react",
	        "react-dom",
	        "react-hot-loader",
	        "react-move",
	        "react-test-renderer",
	        "sinon",
	        "style-loader",
	        "url-loader",
	        "webpack",
	        "webpack-cli",
	        "webpack-dev-server"
	      ],
	      "tags": [],
	      "lastStarCount": 1350,
	      "lastUpdatedAt": "2018-07-27T08:19:59Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/5078602?v=4"
	    },
	    {
	      "githubPath": "jrm2k6/react-markdown-editor",
	      "description": "A markdown editor using React/Reflux",
	      "homepage": null,
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-loader",
	        "babel-plugin-transform-react-jsx",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "codeclimate-test-reporter",
	        "console",
	        "create-react-class",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "expect",
	        "expect-jsx",
	        "jest",
	        "jest-cli",
	        "markdown",
	        "mocha",
	        "object-assign",
	        "prop-types",
	        "react",
	        "react-dom",
	        "react-test-renderer",
	        "react-tools",
	        "reflux",
	        "webpack"
	      ],
	      "tags": [
	        "text editor"
	      ],
	      "lastStarCount": 172,
	      "lastUpdatedAt": "2018-07-23T21:20:45Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/1088099?v=4"
	    },
	    {
	      "githubPath": "brigade/react-simple-pie-chart",
	      "description": "Simple pie chart React component",
	      "homepage": null,
	      "dependencies": [
	        "babel",
	        "babel-cli",
	        "babel-core",
	        "babel-loader",
	        "babel-plugin-add-module-exports",
	        "babel-plugin-transform-react-jsx",
	        "babel-preset-es2015",
	        "eslint",
	        "eslint-config-brigade",
	        "eslint-plugin-react",
	        "jasmine-core",
	        "karma",
	        "karma-chrome-launcher",
	        "karma-cli",
	        "karma-firefox-launcher",
	        "karma-jasmine",
	        "karma-webpack",
	        "prop-types",
	        "react",
	        "react-addons-test-utils",
	        "react-dom",
	        "webpack"
	      ],
	      "tags": [
	        "dataviz"
	      ],
	      "lastStarCount": 60,
	      "lastUpdatedAt": "2018-06-07T18:25:45Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/7872961?v=4"
	    },
	    {
	      "githubPath": "moroshko/react-autosuggest",
	      "description": "WAI-ARIA compliant React autosuggest component",
	      "homepage": "http://react-autosuggest.js.org",
	      "dependencies": [
	        "autoprefixer",
	        "autosuggest-highlight",
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-react-transform",
	        "babel-plugin-transform-react-remove-prop-types",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "babel-register",
	        "chai",
	        "cross-env",
	        "css-loader",
	        "es6-promise",
	        "eslint",
	        "eslint-plugin-react",
	        "extract-text-webpack-plugin",
	        "file-loader",
	        "husky",
	        "ismobilejs",
	        "isomorphic-fetch",
	        "jsdom",
	        "less",
	        "less-loader",
	        "lint-staged",
	        "mocha",
	        "nyc",
	        "openurl",
	        "postcss-loader",
	        "prettier",
	        "prop-types",
	        "react",
	        "react-autowhatever",
	        "react-dom",
	        "react-modal",
	        "react-transform-hmr",
	        "shallow-equal",
	        "sinon",
	        "sinon-chai",
	        "style-loader",
	        "svgo",
	        "svgo-loader",
	        "url-loader",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "autocomplete"
	      ],
	      "lastStarCount": 3620,
	      "lastUpdatedAt": "2018-07-27T13:59:55Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/259753?v=4"
	    },
	    {
	      "githubPath": "flipboard/react-canvas",
	      "description": "High performance <canvas> rendering for React components",
	      "homepage": "",
	      "dependencies": null,
	      "tags": [
	        "graphics"
	      ],
	      "lastStarCount": 11417,
	      "lastUpdatedAt": "2018-07-27T05:36:48Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/457049?v=4"
	    },
	    {
	      "githubPath": "MicheleBertoli/react-gmaps",
	      "description": "A Google Maps component for React.js",
	      "homepage": "http://react-gmaps.herokuapp.com/",
	      "dependencies": [
	        "babel",
	        "babel-eslint",
	        "babel-jest",
	        "babelify",
	        "browserify",
	        "create-react-class",
	        "eslint",
	        "eslint-plugin-react",
	        "express",
	        "jest-cli",
	        "object-assign",
	        "raf",
	        "react",
	        "react-dom"
	      ],
	      "tags": [
	        "map"
	      ],
	      "lastStarCount": 280,
	      "lastUpdatedAt": "2018-07-23T12:46:29Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/1308971?v=4"
	    },
	    {
	      "githubPath": "insin/react-auto-form",
	      "description": "Simplifies getting user input from basic forms via onChange and onSubmit events",
	      "homepage": "https://insin.github.io/react-auto-form/",
	      "dependencies": [
	        "eslint-config-jonnybuchanan",
	        "get-form-data",
	        "nwb",
	        "prop-types",
	        "react",
	        "react-dom"
	      ],
	      "tags": [
	        "form"
	      ],
	      "lastStarCount": 111,
	      "lastUpdatedAt": "2018-07-24T04:18:01Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/226692?v=4"
	    },
	    {
	      "githubPath": "skratchdot/react-bootstrap-daterangepicker",
	      "description": "A date/time picker for react (using bootstrap). This is a react wrapper around the bootstrap-daterangepicker project.",
	      "homepage": "http://projects.skratchdot.com/react-bootstrap-daterangepicker/",
	      "dependencies": [
	        "@storybook/addon-actions",
	        "@storybook/addon-info",
	        "@storybook/addon-knobs",
	        "@storybook/addon-options",
	        "@storybook/react",
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-jest",
	        "babel-plugin-external-helpers",
	        "babel-preset-env",
	        "babel-preset-react",
	        "bootstrap",
	        "bootstrap-daterangepicker",
	        "cheerio",
	        "coveralls",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "eslint",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "identity-obj-proxy",
	        "jest",
	        "jquery",
	        "lolex",
	        "moment",
	        "npm-run-all",
	        "prettier",
	        "prop-types",
	        "react",
	        "react-dom",
	        "regenerator-runtime",
	        "rimraf",
	        "rollup",
	        "rollup-plugin-babel",
	        "rollup-plugin-node-resolve",
	        "wordwrap"
	      ],
	      "tags": [
	        "calendar"
	      ],
	      "lastStarCount": 362,
	      "lastUpdatedAt": "2018-07-18T07:30:21Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/434470?v=4"
	    },
	    {
	      "githubPath": "gfazioli/react-switch-button",
	      "description": "React Switch Button control",
	      "homepage": "http://gfazioli.github.io/react-switch-button/",
	      "dependencies": [
	        "babel-plugin-transform-object-rest-spread",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "cross-env",
	        "laravel-mix",
	        "less",
	        "less-loader",
	        "react",
	        "react-dom",
	        "webpack-strip-blocks"
	      ],
	      "tags": [
	        "button"
	      ],
	      "lastStarCount": 82,
	      "lastUpdatedAt": "2018-07-27T21:25:36Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/432181?v=4"
	    },
	    {
	      "githubPath": "KyleAMathews/react-headroom",
	      "description": "Hide your header until you need it",
	      "homepage": "https://kyleamathews.github.io/react-headroom",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-transform-undefined-to-void",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-1",
	        "chai",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-config-airbnb-base",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "mocha",
	        "mocha-unfunk-reporter",
	        "pre-commit",
	        "prop-types",
	        "raf",
	        "shallowequal"
	      ],
	      "tags": [],
	      "lastStarCount": 797,
	      "lastUpdatedAt": "2018-07-27T19:12:41Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/71047?v=4"
	    },
	    {
	      "githubPath": "codesuki/react-d3-components",
	      "description": "D3 Components for React",
	      "homepage": "http://codesuki.github.io/react-d3-components/example.html",
	      "dependencies": [
	        "@babel/cli",
	        "@babel/core",
	        "@babel/preset-env",
	        "@babel/preset-react",
	        "@babel/preset-stage-0",
	        "babel-eslint",
	        "babel-loader",
	        "create-react-class",
	        "d3",
	        "eslint",
	        "eslint-config-prettier",
	        "eslint-plugin-prettier",
	        "eslint-plugin-react",
	        "husky",
	        "lint-staged",
	        "npm-run-all",
	        "prop-types",
	        "webpack",
	        "webpack-cli",
	        "webpack-merge"
	      ],
	      "tags": [
	        "dataviz"
	      ],
	      "lastStarCount": 1387,
	      "lastUpdatedAt": "2018-07-26T17:39:56Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/5276006?v=4"
	    },
	    {
	      "githubPath": "javierbyte/react-blur",
	      "description": "React component for blurred backgrounds.",
	      "homepage": "http://javier.xyz/react-blur/",
	      "dependencies": [
	        "babel-cli",
	        "babel-eslint",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-1",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-config-prettier",
	        "eslint-plugin-babel",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-prettier",
	        "eslint-plugin-react",
	        "prettier",
	        "prop-types"
	      ],
	      "tags": [],
	      "lastStarCount": 337,
	      "lastUpdatedAt": "2018-07-16T09:51:59Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/2009676?v=4"
	    },
	    {
	      "githubPath": "Sitebase/react-avatar",
	      "description": "Universal avatar makes it possible to fetch/generate an avatar based on the information you have about that user.",
	      "homepage": null,
	      "dependencies": [
	        "@types/react",
	        "babel",
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-plugin-add-module-exports",
	        "babel-plugin-dev",
	        "babel-plugin-dev-expression",
	        "babel-plugin-transform-decorators-legacy",
	        "babel-plugin-transform-inline-environment-variables",
	        "babel-plugin-transform-member-expression-literals",
	        "babel-plugin-transform-property-literals",
	        "babel-plugin-transform-react-constant-elements",
	        "babel-plugin-transform-react-inline-elements",
	        "babel-plugin-transform-runtime",
	        "babel-plugin-transform-undefined-to-void",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "babel-regenerator-runtime",
	        "babel-register",
	        "babel-runtime",
	        "babelify",
	        "browserify",
	        "browserify-global-shim",
	        "eslint",
	        "eslint-plugin-react",
	        "is-retina",
	        "md5",
	        "react",
	        "react-dom",
	        "reactify",
	        "watchify"
	      ],
	      "tags": [],
	      "lastStarCount": 276,
	      "lastUpdatedAt": "2018-07-25T22:18:21Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/421104?v=4"
	    },
	    {
	      "githubPath": "react-component/menu",
	      "description": "React Menu",
	      "homepage": "http://react-component.github.io/menu/",
	      "dependencies": [
	        "babel-runtime",
	        "classnames",
	        "coveralls",
	        "dom-scroll-into-view",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "enzyme-to-json",
	        "jest",
	        "mini-store",
	        "pre-commit",
	        "prop-types",
	        "rc-animate",
	        "rc-tools",
	        "rc-trigger",
	        "rc-util",
	        "react",
	        "react-dom",
	        "react-test-renderer",
	        "rmc-tools"
	      ],
	      "tags": [
	        "menu"
	      ],
	      "lastStarCount": 289,
	      "lastUpdatedAt": "2018-07-25T11:54:46Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/9441414?v=4"
	    },
	    {
	      "githubPath": "Hacker0x01/react-datepicker",
	      "description": "A simple and reusable datepicker component for React",
	      "homepage": "https://reactdatepicker.com/",
	      "dependencies": [
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-add-react-displayname",
	        "babel-plugin-external-helpers",
	        "babel-plugin-react-transform",
	        "babel-plugin-transform-class-properties",
	        "babel-plugin-transform-react-remove-prop-types",
	        "babel-polyfill",
	        "babel-preset-airbnb",
	        "babel-preset-env",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "chai",
	        "classnames",
	        "codecov.io",
	        "cross-env",
	        "css-loader",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "eslint",
	        "eslint-plugin-import",
	        "eslint-plugin-node",
	        "eslint-plugin-promise",
	        "eslint-plugin-react",
	        "express",
	        "extract-text-webpack-plugin",
	        "flow-bin",
	        "highlight.js",
	        "husky",
	        "isparta-loader",
	        "karma",
	        "karma-chai",
	        "karma-coverage",
	        "karma-firefox-launcher",
	        "karma-mocha",
	        "karma-sinon",
	        "karma-sourcemap-loader",
	        "karma-webpack",
	        "lint-staged",
	        "lodash",
	        "mocha",
	        "moment",
	        "node-sass",
	        "npm-run-all",
	        "prettier",
	        "prop-types",
	        "react",
	        "react-docgen",
	        "react-dom",
	        "react-onclickoutside",
	        "react-popper",
	        "react-test-renderer",
	        "react-transform-hmr",
	        "rimraf",
	        "rollup",
	        "rollup-plugin-babel",
	        "rollup-plugin-commonjs",
	        "rollup-plugin-node-resolve",
	        "rollup-plugin-uglify",
	        "sass-lint",
	        "sass-loader",
	        "sinon",
	        "style-loader",
	        "webpack",
	        "webpack-dev-middleware",
	        "webpack-dev-server",
	        "webpack-hot-middleware"
	      ],
	      "tags": [
	        "calendar"
	      ],
	      "lastStarCount": 2868,
	      "lastUpdatedAt": "2018-07-27T18:53:05Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/3014877?v=4"
	    },
	    {
	      "githubPath": "marcio/react-skylight",
	      "description": "A react component for modals and dialogs",
	      "homepage": "http://marcio.github.io/react-skylight/",
	      "dependencies": [
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "chai",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-loader",
	        "eslint-plugin-react",
	        "isparta-loader",
	        "jest-cli",
	        "karma",
	        "karma-chai",
	        "karma-chrome-launcher",
	        "karma-coverage",
	        "karma-mocha",
	        "karma-phantomjs-launcher",
	        "karma-sourcemap-loader",
	        "karma-webpack",
	        "mocha",
	        "npm-run-all",
	        "phantomjs-polyfill-object-assign",
	        "phantomjs-prebuilt",
	        "prop-types",
	        "react",
	        "react-addons-test-utils"
	      ],
	      "tags": [],
	      "lastStarCount": 464,
	      "lastUpdatedAt": "2018-07-25T15:10:28Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/6532?v=4"
	    },
	    {
	      "githubPath": "react-component/form",
	      "description": "React High Order Form Component(web & react-native)",
	      "homepage": "http://react-component.github.io/form/",
	      "dependencies": [
	        "antd",
	        "async",
	        "async-validator",
	        "babel-runtime",
	        "create-react-class",
	        "dom-scroll-into-view",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "enzyme-to-json",
	        "history",
	        "hoist-non-react-statics",
	        "jest",
	        "lodash",
	        "pre-commit",
	        "prop-types",
	        "rc-tools",
	        "react",
	        "react-dom",
	        "react-redux",
	        "react-router",
	        "react-test-renderer",
	        "redux",
	        "warning"
	      ],
	      "tags": [
	        "form"
	      ],
	      "lastStarCount": 755,
	      "lastUpdatedAt": "2018-07-27T07:48:23Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/9441414?v=4"
	    },
	    {
	      "githubPath": "ggordan/react-infinite-grid",
	      "description": "A React component which renders a grid of elements.",
	      "homepage": "",
	      "dependencies": [
	        "babel",
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "lodash",
	        "react",
	        "react-dom",
	        "rimraf",
	        "webpack"
	      ],
	      "tags": [
	        "grid"
	      ],
	      "lastStarCount": 190,
	      "lastUpdatedAt": "2018-07-20T22:00:45Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/196237?v=4"
	    },
	    {
	      "githubPath": "facebookarchive/fixed-data-table",
	      "description": "A React table component designed to allow presenting thousands of rows of data.",
	      "homepage": "http://facebook.github.io/fixed-data-table/",
	      "dependencies": [
	        "autoprefixer",
	        "babel-core",
	        "babel-loader",
	        "bundle-loader",
	        "create-react-class",
	        "css-loader",
	        "extract-text-webpack-plugin",
	        "faker",
	        "file-loader",
	        "glob",
	        "html-loader",
	        "less",
	        "less-loader",
	        "marked",
	        "null-loader",
	        "postcss",
	        "postcss-custom-properties",
	        "prop-types",
	        "react",
	        "react-docgen",
	        "react-dom",
	        "react-tools",
	        "style-loader",
	        "url-loader",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "list"
	      ],
	      "lastStarCount": 4306,
	      "lastUpdatedAt": "2018-07-27T20:39:18Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/7560860?v=4"
	    },
	    {
	      "githubPath": "contra/react-responsive",
	      "description": "Media queries in react for responsive design",
	      "homepage": null,
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-add-module-exports",
	        "babel-plugin-transform-class-properties",
	        "babel-plugin-transform-object-rest-spread",
	        "babel-preset-env",
	        "babel-preset-react",
	        "babel-register",
	        "chai",
	        "cross-env",
	        "eslint",
	        "eslint-plugin-import",
	        "eslint-plugin-react",
	        "hyphenate-style-name",
	        "jsdom",
	        "matchmediaquery",
	        "mocha",
	        "prop-types",
	        "react",
	        "react-dom",
	        "should",
	        "sinon",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "layout"
	      ],
	      "lastStarCount": 2926,
	      "lastUpdatedAt": "2018-07-26T15:42:25Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/425716?v=4"
	    },
	    {
	      "githubPath": "wmira/react-sidenav",
	      "description": "React based Sidebar Navigation component with React Router integration",
	      "homepage": "",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-preset-env",
	        "babel-preset-react",
	        "babel-preset-stage-2",
	        "enzyme",
	        "eslint",
	        "eslint-plugin-react",
	        "jest",
	        "prop-types",
	        "react",
	        "react-addons-test-utils",
	        "react-dom",
	        "react-icons-kit",
	        "react-router",
	        "react-router-dom",
	        "react-test-renderer",
	        "styled-components",
	        "styled-components",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "layout"
	      ],
	      "lastStarCount": 224,
	      "lastUpdatedAt": "2018-07-22T17:46:43Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/468496?v=4"
	    },
	    {
	      "githubPath": "reactjs/react-chartjs",
	      "description": "common react charting components using chart.js",
	      "homepage": null,
	      "dependencies": [
	        "create-react-class",
	        "uglify-js",
	        "webpack"
	      ],
	      "tags": [
	        "dataviz"
	      ],
	      "lastStarCount": 2490,
	      "lastUpdatedAt": "2018-07-27T14:17:43Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/6412038?v=4"
	    },
	    {
	      "githubPath": "mozmorris/react-webcam",
	      "description": "Webcam component",
	      "homepage": "https://codepen.io/mozmorris/pen/JLZdoP",
	      "dependencies": [
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-add-module-exports",
	        "babel-plugin-transform-class-properties",
	        "babel-plugin-transform-react-jsx",
	        "babel-preset-env",
	        "babel-preset-react",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "prop-types",
	        "react",
	        "react-dom",
	        "webpack"
	      ],
	      "tags": [],
	      "lastStarCount": 307,
	      "lastUpdatedAt": "2018-07-20T15:20:10Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/156303?v=4"
	    },
	    {
	      "githubPath": "STRML/react-resizable",
	      "description": "A simple React component that is resizable with a handle. ",
	      "homepage": "https://strml.github.io/react-resizable/examples/1.html",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-transform-class-properties",
	        "babel-plugin-transform-object-rest-spread",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "cross-env",
	        "css-loader",
	        "eslint",
	        "eslint-plugin-react",
	        "flow-bin",
	        "lodash",
	        "pre-commit",
	        "prop-types",
	        "react",
	        "react-dom",
	        "react-draggable",
	        "style-loader",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [],
	      "lastStarCount": 605,
	      "lastUpdatedAt": "2018-07-27T06:22:31Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/1197375?v=4"
	    },
	    {
	      "githubPath": "gianu/react-fittext",
	      "description": "React Plugin to fit text on the screen",
	      "homepage": "http://softwarepsychonaut.com/react-fittext",
	      "dependencies": [
	        "babel",
	        "babel-core",
	        "babel-loader",
	        "babel-runtime",
	        "create-react-class",
	        "css-loader",
	        "expose-loader",
	        "file-loader",
	        "gulp",
	        "gulp-jshint",
	        "gulp-react",
	        "gulp-util",
	        "html-webpack-plugin",
	        "nib",
	        "prop-types",
	        "react",
	        "react-dom",
	        "react-hot-loader",
	        "run-sequence",
	        "style-loader",
	        "stylus",
	        "stylus-loader",
	        "url-loader",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "text"
	      ],
	      "lastStarCount": 154,
	      "lastUpdatedAt": "2018-07-23T03:45:26Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/128563?v=4"
	    },
	    {
	      "githubPath": "fraserxu/react-dropdown",
	      "description": "🔽 A dead simple dropdown component for React",
	      "homepage": "http://fraserxu.me/react-dropdown/",
	      "dependencies": [
	        "babel-cli",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "babelify",
	        "browserify",
	        "browserify-hmr",
	        "classnames",
	        "ecstatic",
	        "gh-pages",
	        "react",
	        "react-dom",
	        "standard",
	        "watchify"
	      ],
	      "tags": [
	        "dropdown"
	      ],
	      "lastStarCount": 313,
	      "lastUpdatedAt": "2018-07-27T07:44:05Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/1183541?v=4"
	    },
	    {
	      "githubPath": "brigand/react-zeroclipboard",
	      "description": "react component that abstracts zeroclipboard",
	      "homepage": "http://brigand.github.io/react-zeroclipboard",
	      "dependencies": [
	        "babel-core",
	        "babel-preset-react",
	        "babelify",
	        "browserify",
	        "create-react-class",
	        "envify",
	        "envify",
	        "react",
	        "react-dom"
	      ],
	      "tags": [
	        "wrapper"
	      ],
	      "lastStarCount": 95,
	      "lastUpdatedAt": "2018-03-31T17:32:46Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/936069?v=4"
	    },
	    {
	      "githubPath": "nmn/react-timeago",
	      "description": "A simple time-ago component for ReactJs.",
	      "homepage": null,
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-jest",
	        "babel-plugin-syntax-flow",
	        "babel-plugin-syntax-jsx",
	        "babel-plugin-transform-flow-strip-types",
	        "babel-plugin-transform-react-jsx",
	        "babel-preset-es2015",
	        "babel-preset-flow",
	        "babel-preset-react",
	        "babel-preset-stage-1",
	        "babelify",
	        "browserify",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "jest",
	        "prettier",
	        "react",
	        "react-addons-test-utils",
	        "react-dom"
	      ],
	      "tags": [],
	      "lastStarCount": 529,
	      "lastUpdatedAt": "2018-07-24T07:38:52Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/3582514?v=4"
	    },
	    {
	      "githubPath": "STRML/react-grid-layout",
	      "description": "A draggable and resizable grid layout with responsive breakpoints, for React.",
	      "homepage": "https://strml.github.io/react-grid-layout/examples/0-showcase.html",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-jest",
	        "babel-loader",
	        "babel-plugin-react-transform",
	        "babel-plugin-transform-react-constant-elements",
	        "babel-plugin-transform-react-inline-elements",
	        "babel-plugin-typecheck",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-1",
	        "classnames",
	        "css-loader",
	        "ejs",
	        "eslint",
	        "eslint-plugin-flowtype",
	        "eslint-plugin-mocha",
	        "eslint-plugin-react",
	        "exports-loader",
	        "flow-bin",
	        "husky",
	        "imports-loader",
	        "jest-cli",
	        "lint-staged",
	        "lodash",
	        "lodash.isequal",
	        "opener",
	        "prettier",
	        "prop-types",
	        "react",
	        "react-dom",
	        "react-draggable",
	        "react-hot-loader",
	        "react-resizable",
	        "react-transform-hmr",
	        "style-loader",
	        "valiquire",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "grid"
	      ],
	      "lastStarCount": 6763,
	      "lastUpdatedAt": "2018-07-27T17:14:24Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/1197375?v=4"
	    },
	    {
	      "githubPath": "gpbl/react-day-picker",
	      "description": "Flexible date picker for React",
	      "homepage": "http://react-day-picker.js.org",
	      "dependencies": [
	        "autoprefixer",
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-jest",
	        "babel-loader",
	        "babel-plugin-transform-class-properties",
	        "babel-plugin-transform-export-extensions",
	        "babel-plugin-transform-object-rest-spread",
	        "babel-plugin-transform-react-remove-prop-types",
	        "babel-preset-env",
	        "babel-preset-react",
	        "babel-preset-stage-1",
	        "cheerio",
	        "codecov",
	        "cross-env",
	        "dtslint",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-config-airbnb-base",
	        "eslint-config-prettier",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-prettier",
	        "eslint-plugin-react",
	        "gh-pages",
	        "husky",
	        "jest",
	        "jest-enzyme",
	        "jest-junit-reporter",
	        "moment",
	        "null-loader",
	        "postcss-cli",
	        "prettier",
	        "prop-types",
	        "raf",
	        "react",
	        "react-dom",
	        "react-test-renderer",
	        "rimraf",
	        "typescript",
	        "webpack"
	      ],
	      "tags": [
	        "calendar"
	      ],
	      "lastStarCount": 2351,
	      "lastUpdatedAt": "2018-07-27T12:52:13Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/120693?v=4"
	    },
	    {
	      "githubPath": "akiran/react-highlight",
	      "description": "React component for syntax highlighting",
	      "homepage": "https://react-highlight.neostack.com/",
	      "dependencies": [
	        "autoprefixer",
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-jest",
	        "babel-loader",
	        "babel-plugin-transform-class-properties",
	        "babel-plugin-transform-react-jsx",
	        "babel-preset-env",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "eslint",
	        "eslint-plugin-react",
	        "highlight.js",
	        "html-loader",
	        "jest",
	        "jsx-loader",
	        "markdown-loader",
	        "multiline",
	        "node-libs-browser",
	        "raw-loader",
	        "react",
	        "react-dom",
	        "react-test-renderer",
	        "regenerator-runtime",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "text"
	      ],
	      "lastStarCount": 388,
	      "lastUpdatedAt": "2018-07-27T15:03:02Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/3403295?v=4"
	    },
	    {
	      "githubPath": "akiran/react-slick",
	      "description": "React carousel component ",
	      "homepage": "http://react-slick.neostack.com/",
	      "dependencies": [
	        "autoprefixer",
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-jest",
	        "babel-loader",
	        "babel-plugin-transform-class-properties",
	        "babel-plugin-transform-object-assign",
	        "babel-polyfill",
	        "babel-preset-airbnb",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "classnames",
	        "css-loader",
	        "deepmerge",
	        "del",
	        "enquire.js",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "es5-shim",
	        "eslint",
	        "eslint-plugin-import",
	        "eslint-plugin-react",
	        "express",
	        "foundation-apps",
	        "gulp",
	        "gulp-sass",
	        "husky",
	        "jasmine-core",
	        "jest",
	        "jquery",
	        "js-beautify",
	        "json-loader",
	        "json2mq",
	        "lint-staged",
	        "lodash.debounce",
	        "node-sass",
	        "postcss-loader",
	        "raf",
	        "react",
	        "react-addons-test-utils",
	        "react-dom",
	        "react-test-renderer",
	        "resize-observer-polyfill",
	        "run-sequence",
	        "sass-loader",
	        "sinon",
	        "slick-carousel",
	        "style-loader",
	        "webpack",
	        "webpack-dev-server",
	        "why-did-you-update"
	      ],
	      "tags": [],
	      "lastStarCount": 5360,
	      "lastUpdatedAt": "2018-07-27T18:27:43Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/3403295?v=4"
	    },
	    {
	      "githubPath": "olahol/react-tagsinput",
	      "description": "Highly customizable React component for inputing tags.",
	      "homepage": "",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-plugin-add-module-exports",
	        "babel-plugin-transform-es2015-modules-umd",
	        "babel-plugin-transform-react-remove-prop-types",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "babel-register",
	        "istanbul",
	        "jsdom",
	        "mocha",
	        "prop-types",
	        "react",
	        "react-autosuggest",
	        "react-dom",
	        "react-input-autosize",
	        "reactpack",
	        "sinon",
	        "standard"
	      ],
	      "tags": [],
	      "lastStarCount": 970,
	      "lastUpdatedAt": "2018-07-24T07:44:22Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/1386739?v=4"
	    },
	    {
	      "githubPath": "svenanders/react-breadcrumbs",
	      "description": "Automatic breadcrumbs for React-Router",
	      "homepage": null,
	      "dependencies": [
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-transform-object-rest-spread",
	        "babel-preset-env",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "eslint",
	        "eslint-loader",
	        "eslint-plugin-react",
	        "lodash.isequal",
	        "prop-types",
	        "react",
	        "react-dom",
	        "react-router-dom",
	        "redux",
	        "standard-version",
	        "uuid",
	        "webpack"
	      ],
	      "tags": [],
	      "lastStarCount": 341,
	      "lastUpdatedAt": "2018-07-25T03:00:00Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/1560743?v=4"
	    },
	    {
	      "githubPath": "srdjan/react-multistep",
	      "description": "React multistep form component",
	      "homepage": "http://srdjan.github.io/react-multistep/",
	      "dependencies": [
	        "babel",
	        "babel-cli",
	        "babel-core",
	        "babel-loader",
	        "babel-plugin-transform-class-properties",
	        "babel-plugin-transform-react-jsx",
	        "babel-preset-env",
	        "babel-preset-es2015",
	        "babel-preset-es2017",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "babel-preset-stage-2",
	        "babelify",
	        "browserify",
	        "eslint",
	        "html-loader",
	        "html-webpack-plugin",
	        "react",
	        "react-dom",
	        "standard",
	        "webpack",
	        "webpack-cli"
	      ],
	      "tags": [
	        "form"
	      ],
	      "lastStarCount": 289,
	      "lastUpdatedAt": "2018-07-27T20:38:55Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/61190?v=4"
	    },
	    {
	      "githubPath": "palantir/blueprint",
	      "description": "A React-based UI toolkit for the web",
	      "homepage": "http://blueprintjs.com/",
	      "dependencies": null,
	      "tags": [
	        "toolkit"
	      ],
	      "lastStarCount": 9994,
	      "lastUpdatedAt": "2018-07-27T21:13:31Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/303157?v=4"
	    },
	    {
	      "githubPath": "react-bootstrap/react-bootstrap",
	      "description": "Bootstrap 3 components built with React",
	      "homepage": "https://react-bootstrap.github.io/",
	      "dependencies": [
	        "@babel/cli",
	        "@babel/core",
	        "@babel/plugin-proposal-class-properties",
	        "@babel/plugin-proposal-export-default-from",
	        "@babel/plugin-proposal-export-namespace-from",
	        "@babel/plugin-syntax-dynamic-import",
	        "@babel/plugin-transform-runtime",
	        "@babel/preset-env",
	        "@babel/preset-react",
	        "@babel/register",
	        "@babel/runtime",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-add-module-exports",
	        "babel-plugin-dev-expression",
	        "babel-plugin-istanbul",
	        "chai",
	        "chalk",
	        "classnames",
	        "codecov",
	        "colors",
	        "create-react-class",
	        "cross-env",
	        "dom-helpers",
	        "enzyme",
	        "enzyme-adapter-react-15",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-config-prettier",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-mocha",
	        "eslint-plugin-prettier",
	        "eslint-plugin-react",
	        "execa",
	        "fs-extra",
	        "husky",
	        "invariant",
	        "karma",
	        "karma-chrome-launcher",
	        "karma-cli",
	        "karma-coverage",
	        "karma-firefox-launcher",
	        "karma-mocha",
	        "karma-mocha-reporter",
	        "karma-sinon-chai",
	        "karma-sourcemap-loader",
	        "karma-webpack",
	        "keycode",
	        "lint-staged",
	        "lodash",
	        "mocha",
	        "prettier",
	        "prop-types",
	        "prop-types-extra",
	        "react",
	        "react-dom",
	        "react-overlays",
	        "react-prop-types",
	        "react-test-renderer",
	        "react-transition-group",
	        "release-script",
	        "sinon",
	        "sinon-chai",
	        "uncontrollable",
	        "warning",
	        "webpack"
	      ],
	      "tags": [
	        "toolkit"
	      ],
	      "lastStarCount": 13452,
	      "lastUpdatedAt": "2018-07-27T15:47:33Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/6853419?v=4"
	    },
	    {
	      "githubPath": "reactstrap/reactstrap",
	      "description": "Simple React Bootstrap 4 components",
	      "homepage": "https://reactstrap.github.io",
	      "dependencies": [
	        "babel-cli",
	        "babel-loader",
	        "babel-plugin-transform-object-rest-spread",
	        "babel-preset-es2015-rollup",
	        "babel-preset-react",
	        "babel-preset-react-app",
	        "bootstrap",
	        "classnames",
	        "clean-webpack-plugin",
	        "conventional-changelog-cli",
	        "conventional-recommended-bump",
	        "copy-webpack-plugin",
	        "coveralls",
	        "cross-env",
	        "css-loader",
	        "ejs",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "eslint-plugin-standard",
	        "extract-text-webpack-plugin",
	        "history",
	        "holderjs",
	        "json-loader",
	        "lodash.isfunction",
	        "lodash.isobject",
	        "lodash.tonumber",
	        "prop-types",
	        "raw-loader",
	        "react",
	        "react-dom",
	        "react-helmet",
	        "react-lifecycles-compat",
	        "react-popper",
	        "react-prism",
	        "react-router",
	        "react-scripts",
	        "react-test-renderer",
	        "react-transition-group",
	        "rollup",
	        "rollup-plugin-babel",
	        "rollup-plugin-babel-minify",
	        "rollup-plugin-commonjs",
	        "rollup-plugin-node-resolve",
	        "rollup-plugin-replace",
	        "static-site-generator-webpack-plugin",
	        "style-loader",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "toolkit"
	      ],
	      "lastStarCount": 5453,
	      "lastUpdatedAt": "2018-07-27T17:21:56Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/17580417?v=4"
	    },
	    {
	      "githubPath": "mui-org/material-ui",
	      "description": "React components that implement Google's Material Design.",
	      "homepage": "https://material-ui.com/",
	      "dependencies": [
	        "@babel/cli",
	        "@babel/core",
	        "@babel/node",
	        "@babel/plugin-transform-object-assign",
	        "@babel/plugin-transform-runtime",
	        "@babel/preset-env",
	        "@babel/preset-flow",
	        "@babel/preset-react",
	        "@babel/preset-stage-1",
	        "@babel/register",
	        "@types/enzyme",
	        "@types/react",
	        "argos-cli",
	        "autoprefixer",
	        "autosuggest-highlight",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-istanbul",
	        "babel-plugin-module-resolver",
	        "babel-plugin-preval",
	        "babel-plugin-react-remove-properties",
	        "babel-plugin-transform-dev-warning",
	        "babel-plugin-transform-react-constant-elements",
	        "babel-plugin-transform-react-remove-prop-types",
	        "chai",
	        "clean-css",
	        "clipboard-copy",
	        "cross-env",
	        "css-loader",
	        "doctrine",
	        "downshift",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-import-resolver-webpack",
	        "eslint-plugin-babel",
	        "eslint-plugin-flowtype",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-material-ui",
	        "eslint-plugin-mocha",
	        "eslint-plugin-prettier",
	        "eslint-plugin-react",
	        "eslint-plugin-spellcheck",
	        "fg-loadcss",
	        "file-loader",
	        "flow-bin",
	        "flow-typed",
	        "fs-extra",
	        "glob",
	        "gm",
	        "isomorphic-fetch",
	        "jsdom",
	        "jss-rtl",
	        "karma",
	        "karma-browserstack-launcher",
	        "karma-chrome-launcher",
	        "karma-mocha",
	        "karma-mocha-reporter",
	        "karma-sourcemap-loader",
	        "karma-webpack",
	        "lz-string",
	        "mocha",
	        "next",
	        "nyc",
	        "postcss",
	        "prettier",
	        "puppeteer",
	        "raw-loader",
	        "react",
	        "react-autosuggest",
	        "react-docgen",
	        "react-dom",
	        "react-inspector",
	        "react-number-format",
	        "react-redux",
	        "react-router",
	        "react-router-dom",
	        "react-select",
	        "react-swipeable-views",
	        "react-test-renderer",
	        "react-text-mask",
	        "recast",
	        "redux",
	        "redux-logger",
	        "rimraf",
	        "rollup",
	        "rollup-plugin-babel",
	        "rollup-plugin-commonjs",
	        "rollup-plugin-node-globals",
	        "rollup-plugin-node-resolve",
	        "rollup-plugin-size-snapshot",
	        "rollup-plugin-uglify",
	        "sinon",
	        "size-limit",
	        "typescript",
	        "url-loader",
	        "vrtest",
	        "webfontloader",
	        "webpack",
	        "webpack-bundle-analyzer",
	        "workbox-build"
	      ],
	      "tags": [
	        "toolkit",
	        "material design"
	      ],
	      "lastStarCount": 38909,
	      "lastUpdatedAt": "2018-07-27T20:27:32Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/33663932?v=4"
	    },
	    {
	      "githubPath": "grommet/grommet",
	      "description": "Focus on the essential experience",
	      "homepage": "https://grommet.github.io",
	      "dependencies": null,
	      "tags": [
	        "toolkit"
	      ],
	      "lastStarCount": 3485,
	      "lastUpdatedAt": "2018-07-27T11:38:26Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/14203820?v=4"
	    },
	    {
	      "githubPath": "tomchentw/react-google-maps",
	      "description": "React.js Google Maps integration component",
	      "homepage": "https://tomchentw.github.io/react-google-maps/",
	      "dependencies": [
	        "@types/googlemaps",
	        "@types/markerclustererplus",
	        "@types/react",
	        "babel-cli",
	        "babel-plugin-lodash",
	        "babel-plugin-transform-class-properties",
	        "babel-plugin-transform-object-rest-spread",
	        "babel-plugin-transform-runtime",
	        "babel-preset-env",
	        "babel-preset-react",
	        "babel-runtime",
	        "can-use-dom",
	        "cheerio",
	        "cross-env",
	        "dtslint",
	        "eslint",
	        "glob",
	        "google-maps-infobox",
	        "husky",
	        "invariant",
	        "isomorphic-fetch",
	        "jscodeshift",
	        "lint-staged",
	        "lodash",
	        "make-fetch-happen",
	        "marker-clusterer-plus",
	        "markerwithlabel",
	        "mkdirp",
	        "prettier",
	        "prop-types",
	        "react",
	        "react-dom",
	        "react-icons",
	        "react-scripts",
	        "react-styleguidist",
	        "recompose",
	        "rimraf",
	        "scriptjs",
	        "standard-version",
	        "to-markdown",
	        "warning"
	      ],
	      "tags": [
	        "map"
	      ],
	      "lastStarCount": 3492,
	      "lastUpdatedAt": "2018-07-27T13:29:21Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/922234?v=4"
	    },
	    {
	      "githubPath": "gabrielbull/react-desktop",
	      "description": "React UI Components for macOS High Sierra and Windows 10",
	      "homepage": "http://reactdesktop.js.org",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-transform-decorators-legacy",
	        "babel-preset-es2015",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "chai",
	        "eslint",
	        "eslint-plugin-import",
	        "eslint-plugin-react",
	        "html-webpack-plugin",
	        "jsdom",
	        "mocha",
	        "prop-types",
	        "radium",
	        "react",
	        "react-addons-test-utils",
	        "react-color",
	        "react-dom",
	        "react-hot-loader",
	        "webpack",
	        "webpack-cli",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "toolkit"
	      ],
	      "lastStarCount": 7647,
	      "lastUpdatedAt": "2018-07-27T20:19:48Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/671923?v=4"
	    },
	    {
	      "githubPath": "leecade/react-native-swiper",
	      "description": "The best Swiper component for React Native.",
	      "homepage": "",
	      "dependencies": [
	        "babel-eslint",
	        "prop-types",
	        "rimraf",
	        "snazzy",
	        "standard",
	        "updtr"
	      ],
	      "tags": [
	        "native"
	      ],
	      "lastStarCount": 6474,
	      "lastUpdatedAt": "2018-07-27T10:16:23Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/533360?v=4"
	    },
	    {
	      "githubPath": "FaridSafi/react-native-gifted-chat",
	      "description": "💬 The most complete chat UI for React Native",
	      "homepage": "http://gifted.chat",
	      "dependencies": [
	        "@expo/react-native-action-sheet",
	        "@types/react",
	        "@types/react-native",
	        "babel",
	        "babel-jest",
	        "babel-preset-react-native",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-config-cooperka",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "eslint-plugin-react-native",
	        "husky",
	        "jest",
	        "moment",
	        "prop-types",
	        "react",
	        "react-native",
	        "react-native-communications",
	        "react-native-lightbox",
	        "react-native-parsed-text",
	        "react-test-renderer",
	        "uuid"
	      ],
	      "tags": [
	        "native"
	      ],
	      "lastStarCount": 5694,
	      "lastUpdatedAt": "2018-07-27T19:09:05Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/388375?v=4"
	    },
	    {
	      "githubPath": "GeekyAnts/NativeBase",
	      "description": "Essential cross-platform UI components for React Native",
	      "homepage": "https://nativebase.io/",
	      "dependencies": [
	        "babel-cli",
	        "babel-eslint",
	        "babel-jest",
	        "babel-preset-react-native",
	        "blueimp-md5",
	        "clamp",
	        "color",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "eslint-plugin-react-native",
	        "flow-bin",
	        "fs-extra",
	        "jest",
	        "jest-react-native",
	        "lodash",
	        "native-base-shoutem-theme",
	        "print-message",
	        "prop-types",
	        "react",
	        "react-native",
	        "react-native-easy-grid",
	        "react-native-keyboard-aware-scroll-view",
	        "react-native-vector-icons",
	        "react-native-vector-icons",
	        "react-test-renderer",
	        "react-tween-state",
	        "tween-functions"
	      ],
	      "tags": [
	        "native"
	      ],
	      "lastStarCount": 9533,
	      "lastUpdatedAt": "2018-07-27T18:37:44Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/18482943?v=4"
	    },
	    {
	      "githubPath": "elementalui/elemental",
	      "description": "A flexible and beautiful UI framework for React.js",
	      "homepage": "http://elemental-ui.com",
	      "dependencies": [
	        "babel",
	        "blacklist",
	        "classnames",
	        "create-react-class",
	        "eslint",
	        "eslint-config-keystone",
	        "eslint-plugin-react",
	        "glob",
	        "gulp",
	        "isparta",
	        "react",
	        "react-component-gulp-tasks",
	        "react-dom",
	        "react-router",
	        "react-router-dom",
	        "react-transition-group",
	        "rimraf",
	        "tap-xunit",
	        "tape",
	        "teaspoon"
	      ],
	      "tags": [
	        "toolkit"
	      ],
	      "lastStarCount": 4099,
	      "lastUpdatedAt": "2018-07-27T14:15:28Z",
	      "avatarUrl": "https://avatars2.githubusercontent.com/u/11880721?v=4"
	    },
	    {
	      "githubPath": "ianstormtaylor/slate",
	      "description": "A completely customizable framework for building rich text editors.",
	      "homepage": "http://slatejs.org",
	      "dependencies": [
	        "babel-cli",
	        "babel-core",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-external-helpers",
	        "babel-plugin-transform-runtime",
	        "babel-preset-env",
	        "babel-preset-react",
	        "babel-preset-stage-0",
	        "babel-runtime",
	        "chalk",
	        "commander",
	        "copy-webpack-plugin",
	        "cross-env",
	        "css-loader",
	        "emojis",
	        "emotion",
	        "eslint",
	        "eslint-config-prettier",
	        "eslint-plugin-import",
	        "eslint-plugin-prettier",
	        "eslint-plugin-react",
	        "extract-text-webpack-plugin",
	        "faker",
	        "figures",
	        "fs-promise",
	        "gh-pages",
	        "html-webpack-plugin",
	        "html-webpack-template",
	        "image-extensions",
	        "immutable",
	        "is-hotkey",
	        "is-url",
	        "jsdom",
	        "lerna",
	        "lodash",
	        "matcha",
	        "mocha",
	        "npm-run-all",
	        "prettier",
	        "prismjs",
	        "react",
	        "react-dom",
	        "react-emotion",
	        "react-hot-loader",
	        "react-portal",
	        "react-router-dom",
	        "read-metadata",
	        "rollup",
	        "rollup-plugin-alias",
	        "rollup-plugin-babel",
	        "rollup-plugin-commonjs",
	        "rollup-plugin-json",
	        "rollup-plugin-node-builtins",
	        "rollup-plugin-node-globals",
	        "rollup-plugin-node-resolve",
	        "rollup-plugin-replace",
	        "rollup-plugin-sourcemaps",
	        "rollup-plugin-uglify",
	        "slate-collapse-on-escape",
	        "slate-dev-benchmark",
	        "slate-soft-break",
	        "source-map-loader",
	        "source-map-support",
	        "style-loader",
	        "to-camel-case",
	        "to-snake-case",
	        "uglifyjs-webpack-plugin",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "text editor"
	      ],
	      "lastStarCount": 8047,
	      "lastUpdatedAt": "2018-07-27T21:20:51Z",
	      "avatarUrl": "https://avatars0.githubusercontent.com/u/311752?v=4"
	    },
	    {
	      "githubPath": "WhitestormJS/whs.js",
	      "description": ":rocket: 🌪 Super-fast 3D framework for Web Applications 🥇 & Games 🎮. Based on Three.js",
	      "homepage": "https://whs.io",
	      "dependencies": [
	        "@types/node",
	        "@types/three",
	        "babel",
	        "babel-core",
	        "babel-eslint",
	        "babel-jest",
	        "babel-loader",
	        "babel-plugin-add-module-exports",
	        "babel-plugin-external-helpers",
	        "babel-plugin-istanbul",
	        "babel-plugin-transform-class-properties",
	        "babel-plugin-transform-decorators-legacy",
	        "babel-plugin-transform-es2015-modules-commonjs",
	        "babel-plugin-transform-object-rest-spread",
	        "babel-plugin-transform-runtime",
	        "babel-polyfill",
	        "babel-preset-es2015",
	        "babel-preset-latest",
	        "babel-preset-stage-1",
	        "babel-register",
	        "babelify",
	        "babili-webpack-plugin",
	        "benchmark",
	        "buffer-shims",
	        "coveralls",
	        "cross-env",
	        "del",
	        "del-cli",
	        "express",
	        "gl",
	        "google-closure-compiler",
	        "gulp",
	        "gulp-babel",
	        "gulp-benchmark",
	        "gulp-browser-basedir",
	        "gulp-browserify",
	        "gulp-cli",
	        "gulp-jsdoc3",
	        "gulp-less",
	        "gulp-rollup",
	        "gulp-watch",
	        "happypack",
	        "jest",
	        "jest-babel",
	        "js-yaml",
	        "jsdoc-babel",
	        "less",
	        "lodash-es",
	        "mdurl",
	        "minami",
	        "minivents",
	        "mocha",
	        "nyc",
	        "path",
	        "postprocessing",
	        "present",
	        "pug",
	        "redux",
	        "rollup",
	        "rollup-plugin-babel",
	        "rollup-plugin-commonjs",
	        "rollup-plugin-json",
	        "rollup-plugin-multi-entry",
	        "rollup-plugin-node-resolve",
	        "rollup-plugin-replace",
	        "rollup-plugin-uglify",
	        "rollup-watch",
	        "semantic-ui-less",
	        "snyk",
	        "surge",
	        "three",
	        "tslint",
	        "typescript",
	        "uglify-js",
	        "uglify-loader",
	        "webpack",
	        "webpack-dashboard",
	        "webpack-dev-middleware",
	        "xo",
	        "yargs"
	      ],
	      "tags": [
	        "toolkit",
	        "3d",
	        "game"
	      ],
	      "lastStarCount": 4876,
	      "lastUpdatedAt": "2018-07-27T18:35:32Z",
	      "avatarUrl": "https://avatars3.githubusercontent.com/u/16437392?v=4"
	    },
	    {
	      "githubPath": "video-react/video-react",
	      "description": "A web video player built for the HTML5 world using React library.",
	      "homepage": "https://video-react.js.org/",
	      "dependencies": [
	        "babel-cli",
	        "babel-eslint",
	        "babel-loader",
	        "babel-plugin-transform-object-rest-spread",
	        "babel-preset-es2015",
	        "babel-preset-es2015-rollup",
	        "babel-preset-react",
	        "babel-preset-react-app",
	        "babel-preset-stage-0",
	        "bootstrap",
	        "classnames",
	        "clean-webpack-plugin",
	        "conventional-changelog-cli",
	        "conventional-recommended-bump",
	        "copy-webpack-plugin",
	        "coveralls",
	        "cross-env",
	        "css-loader",
	        "deep-freeze",
	        "ejs",
	        "enzyme",
	        "enzyme-adapter-react-16",
	        "eslint",
	        "eslint-config-airbnb",
	        "eslint-plugin-import",
	        "eslint-plugin-jsx-a11y",
	        "eslint-plugin-react",
	        "eslint-plugin-standard",
	        "extract-text-webpack-plugin",
	        "file-loader",
	        "history",
	        "hls.js",
	        "holderjs",
	        "json-loader",
	        "lodash.throttle",
	        "node-sass",
	        "prop-types",
	        "raw-loader",
	        "react",
	        "react-dom",
	        "react-helmet",
	        "react-prism",
	        "react-router",
	        "react-scripts",
	        "react-test-renderer",
	        "reactstrap",
	        "redux",
	        "rollup",
	        "rollup-plugin-babel",
	        "rollup-plugin-babel-minify",
	        "rollup-plugin-commonjs",
	        "rollup-plugin-node-resolve",
	        "rollup-plugin-replace",
	        "rollup-plugin-sass",
	        "sass-loader",
	        "sinon",
	        "static-site-generator-webpack-plugin",
	        "style-loader",
	        "url-loader",
	        "webpack",
	        "webpack-dev-server"
	      ],
	      "tags": [
	        "video"
	      ],
	      "lastStarCount": 795,
	      "lastUpdatedAt": "2018-07-27T08:14:22Z",
	      "avatarUrl": "https://avatars1.githubusercontent.com/u/22510068?v=4"
	    }
	  ]
	}

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactComponents = __webpack_require__(779);
	
	var _reactComponents2 = _interopRequireDefault(_reactComponents);
	
	var _Page = __webpack_require__(10);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _ListPageContainer = __webpack_require__(18);
	
	var _ListPageContainer2 = _interopRequireDefault(_ListPageContainer);
	
	var _StyledTextBlock = __webpack_require__(15);
	
	var _StyledTextBlock2 = _interopRequireDefault(_StyledTextBlock);
	
	var _addNotes = __webpack_require__(43);
	
	var _addNotes2 = _interopRequireDefault(_addNotes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var extendedList = (0, _addNotes2.default)(_reactComponents2.default, {
	  "airbnb/react-dates": "This library depends on momentjs, which is a fairly large library. If you are not already using moment, this small component could generate a large increase in your bundle size."
	});
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _Page2.default,
	    null,
	    _react2.default.createElement(
	      _ListPageContainer2.default,
	      { list: extendedList },
	      _react2.default.createElement(
	        _StyledTextBlock2.default,
	        null,
	        _react2.default.createElement(
	          "p",
	          null,
	          "Components are the building blocks of React apps. These projects include components that you can use in your own app."
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Try filtering on the ",
	          _react2.default.createElement(
	            "a",
	            { href: "#tag:toolkit" },
	            "toolkit"
	          ),
	          " tag to see the bigger component libraries. Or check out all the",
	          " ",
	          _react2.default.createElement(
	            "a",
	            { href: "#tag:'text editor'" },
	            "text editor"
	          ),
	          " or",
	          " ",
	          _react2.default.createElement(
	            "a",
	            { href: "#tag:calendar" },
	            "calendar"
	          ),
	          " components."
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-list-react-components-js-53888a1ecb2f8b953341.js